<svg class="icons">
  <g *ngFor="let icon of icons.all" [id]="icon.id" [innerHTML]="getTrustedHtml(icon.svg)"></g>
</svg>

<!-- OLD - need to replace all "use href="#"" and delete -->
<svg class="svg-icons">
  <g id="medal">
    <g clip-path="url(#clip0)">
      <path
        fill="#D75A4A"
        d="M13.03 10.04v.53c.03 1.01-1.25 1.47-2.07.76l-.08-.09c-.37-.42-1.39-.42-1.76 0l-.08.09c-.85.71-2.04.26-2.04-.83v-.53c0-.19-.05-.36-.13-.51V20l3.15-3.9 3.15 3.86V9.46c-.1.17-.15.37-.14.58z"
      />
      <path
        fill="#EDDE64"
        d="M9.08.44c.46.42 1.36.42 1.84 0 .7-.86 2.1-.37 2.1.74v.27c0 .69.58 1.23 1.26 1.17l.46-.03a1.18 1.18 0 01.92 2l-.31.31c-.59.38-.58 1.12 0 1.66l.31.31c.77.78.17 2.1-.92 2l-.46-.03a1.16 1.16 0 00-1.25 1.2v.53c.03 1.01-1.25 1.47-2.07.76l-.08-.09c-.37-.42-1.39-.42-1.76 0l-.08.09c-.85.71-2.04.26-2.04-.83v-.53c0-.64-.6-1.18-1.28-1.13l-.46.04a1.18 1.18 0 01-.92-2l.31-.32c.64-.66.62-1.38 0-1.66l-.3-.3a1.18 1.18 0 01.91-2.01l.46.03C6.4 2.68 7 2.14 7 1.45v-.27c0-1.11 1.4-1.6 2.1-.74z"
      />
      <path fill="#fff" d="M10.02 14.7a.35.35 0 01-.35-.35V12.6a.35.35 0 11.7 0v1.75c0 .2-.16.35-.35.35z" />
      <path
        fill="#ECBA16"
        d="M10.02 2.64l.75 1.88 2.26.37-1.5 1.51.37 2.26-1.88-1.13-1.89 1.13.38-2.26-1.5-1.5 2.25-.38.76-1.88z"
      />
    </g>
    <defs>
      <clipPath id="clip0"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="school">
    <path
      d="M11 0.74585H13.6102C13.8161 0.74585 13.983 0.912794 13.983 1.11873V2.61026C13.983 2.81619 13.8161 2.98314 13.6102 2.98314H11V0.74585Z"
      fill="#E04C34"
    />
    <path
      d="M21.0677 9.69482V21.2541C21.0677 21.666 20.7338 21.9999 20.322 21.9999H1.67789C1.26602 21.9999 0.932129 21.666 0.932129 21.2541V9.69482H21.0677Z"
      fill="#F1D24B"
    />
    <path
      d="M14.7288 8.94922H21.4406C21.6466 8.94922 21.8135 9.11616 21.8135 9.3221V10.0679C21.8135 10.2738 21.6466 10.4407 21.4406 10.4407H0.559283C0.353346 10.4407 0.186401 10.2738 0.186401 10.0679V9.3221C0.186401 9.11616 0.353346 8.94922 0.559283 8.94922H14.7288Z"
      fill="#F85360"
    />
    <path
      d="M15.4745 19.7626V21.2541H6.52539V19.7626C6.52662 19.3512 6.85979 19.0181 7.27115 19.0168H14.7288C15.1401 19.0181 15.4733 19.3512 15.4745 19.7626Z"
      fill="#D94D5D"
    />
    <path d="M14.7287 6.48071V19.017H7.27112V6.48071L10.9999 4.47461L14.7287 6.48071Z" fill="#EDC100" />
    <path
      d="M11 4.84746C10.794 4.84746 10.6271 4.68051 10.6271 4.47458V0.372881C10.6271 0.166945 10.794 0 11 0C11.2059 0 11.3728 0.166945 11.3728 0.372881V4.47458C11.3728 4.68051 11.2059 4.84746 11 4.84746Z"
      fill="#C7804C"
    />
    <path
      d="M15.8474 7.45755C15.7858 7.45763 15.7252 7.44224 15.6711 7.4128L11 4.89809L6.32926 7.4128C6.21161 7.48087 6.06624 7.47952 5.94987 7.40929C5.8335 7.33906 5.76456 7.21107 5.76995 7.07526C5.77534 6.93944 5.8542 6.81732 5.97577 6.75653L10.8232 4.14636C10.9336 4.08696 11.0664 4.08696 11.1767 4.14636L16.0242 6.75653C16.1744 6.8376 16.2504 7.01032 16.2086 7.17583C16.1669 7.34134 16.0181 7.45738 15.8474 7.45755Z"
      fill="#F85360"
    />
    <path
      d="M8.7627 19.017V15.6611C8.7627 14.4255 9.76436 13.4238 11 13.4238C12.2356 13.4238 13.2373 14.4255 13.2373 15.6611V19.017H8.7627Z"
      fill="#A1693E"
    />
    <path
      d="M11 11.9323C12.2356 11.9323 13.2373 10.9307 13.2373 9.69505C13.2373 8.45943 12.2356 7.45776 11 7.45776C9.76436 7.45776 8.7627 8.45943 8.7627 9.69505C8.7627 10.9307 9.76436 11.9323 11 11.9323Z"
      fill="#F8E8AB"
    />
    <path
      d="M10.9999 12.3051C9.55838 12.3051 8.38977 11.1364 8.38977 9.69489C8.38977 8.25333 9.55838 7.08472 10.9999 7.08472C12.4415 7.08472 13.6101 8.25333 13.6101 9.69489C13.6085 11.1358 12.4408 12.3034 10.9999 12.3051ZM10.9999 7.83048C9.97026 7.83048 9.13553 8.6652 9.13553 9.69489C9.13553 10.7246 9.97026 11.5593 10.9999 11.5593C12.0296 11.5593 12.8644 10.7246 12.8644 9.69489C12.8631 8.66572 12.0291 7.83171 10.9999 7.83048Z"
      fill="#ED9A00"
    />
    <path
      d="M11 10.4406C10.794 10.4406 10.6271 10.2736 10.6271 10.0677V9.6948C10.6271 9.59591 10.6664 9.50108 10.7363 9.43117L11.1092 9.05829C11.2555 8.91697 11.4881 8.91899 11.6319 9.06283C11.7757 9.20666 11.7778 9.43923 11.6365 9.58554L11.3728 9.84917V10.0677C11.3728 10.2736 11.2059 10.4406 11 10.4406Z"
      fill="#36495F"
    />
    <path
      d="M5.48879 12.3164C4.72066 12.3648 2.67354 12.6109 2.44608 13.9235C2.43113 13.8829 2.42356 13.84 2.42371 13.7967V12.6781C2.42371 12.4721 2.59065 12.3052 2.79659 12.3052H5.40676C5.4345 12.305 5.46212 12.3087 5.48879 12.3164Z"
      fill="white"
    />
    <path
      d="M5.7796 12.6781V13.7967C5.7796 14.0027 5.61266 14.1696 5.40672 14.1696H2.79655C2.63984 14.1687 2.50015 14.0706 2.44604 13.9235C2.6735 12.611 4.72062 12.3649 5.48876 12.3164C5.5418 12.3271 5.59161 12.3501 5.63418 12.3835C5.72631 12.4534 5.78019 12.5625 5.7796 12.6781Z"
      fill="#4397D5"
    />
    <path
      d="M9.88126 17.5255C10.2931 17.5255 10.627 17.1916 10.627 16.7797C10.627 16.3678 10.2931 16.0339 9.88126 16.0339C9.46939 16.0339 9.1355 16.3678 9.1355 16.7797C9.1355 17.1916 9.46939 17.5255 9.88126 17.5255Z"
      fill="#ED9A00"
    />
    <path
      d="M5.48879 15.6723C4.72066 15.7208 2.67354 15.9669 2.44608 17.2795C2.43113 17.2389 2.42356 17.1959 2.42371 17.1527V16.034C2.42371 15.8281 2.59065 15.6611 2.79659 15.6611H5.40676C5.4345 15.6609 5.46212 15.6647 5.48879 15.6723Z"
      fill="white"
    />
    <path
      d="M5.7796 16.0341V17.1527C5.7796 17.3586 5.61266 17.5256 5.40672 17.5256H2.79655C2.63984 17.5246 2.50015 17.4266 2.44604 17.2795C2.6735 15.9669 4.72062 15.7208 5.48876 15.6724C5.5418 15.6831 5.59161 15.7061 5.63418 15.7395C5.72631 15.8093 5.78019 15.9185 5.7796 16.0341Z"
      fill="#4397D5"
    />
    <path
      d="M19.2854 12.3164C18.5173 12.3648 16.4702 12.6109 16.2427 13.9235C16.2278 13.8829 16.2202 13.84 16.2203 13.7967V12.6781C16.2203 12.4721 16.3873 12.3052 16.5932 12.3052H19.2034C19.2311 12.305 19.2587 12.3087 19.2854 12.3164Z"
      fill="white"
    />
    <path
      d="M19.5762 12.6781V13.7967C19.5762 14.0027 19.4093 14.1696 19.2034 14.1696H16.5932C16.4365 14.1687 16.2968 14.0706 16.2427 13.9235C16.4701 12.611 18.5173 12.3649 19.2854 12.3164C19.3384 12.3271 19.3882 12.3501 19.4308 12.3835C19.5229 12.4534 19.5768 12.5625 19.5762 12.6781Z"
      fill="#4397D5"
    />
    <path
      d="M19.2854 15.6723C18.5173 15.7208 16.4702 15.9669 16.2427 17.2795C16.2278 17.2389 16.2202 17.1959 16.2203 17.1527V16.034C16.2203 15.8281 16.3873 15.6611 16.5932 15.6611H19.2034C19.2311 15.6609 19.2587 15.6647 19.2854 15.6723Z"
      fill="white"
    />
    <path
      d="M19.5762 16.0341V17.1527C19.5762 17.3586 19.4093 17.5256 19.2034 17.5256H16.5932C16.4365 17.5246 16.2968 17.4266 16.2427 17.2795C16.4701 15.9669 18.5173 15.7208 19.2854 15.6724C19.3384 15.6831 19.3882 15.7061 19.4308 15.7395C19.5229 15.8093 19.5768 15.9185 19.5762 16.0341Z"
      fill="#4397D5"
    />
    <path
      d="M16.2204 21.2543V22.0001H5.77966V21.2543C5.78089 20.8429 6.11406 20.5098 6.52543 20.5085H15.4746C15.886 20.5098 16.2191 20.8429 16.2204 21.2543Z"
      fill="#F85360"
    />
  </g>

  <g id="planet">
    <path
      d="M15.5119 16.7012C16.9287 15.5837 17.8769 13.9772 18.1705 12.1968C16.4665 13.1029 14.2851 13.431 11.8539 14.1693C11.6339 14.2364 11.4177 14.2998 11.2014 14.3595L8.88207 14.9561C7.78953 15.2059 6.75292 15.9554 5.79834 16.0785C7.16424 17.4829 9.04093 18.2739 11 18.271C11.1529 18.271 11.3021 18.2673 11.4512 18.2561L15.5119 16.7012Z"
      fill="#4482C3"
    />
    <path
      d="M6.216 5.52594C4.63455 6.90518 3.72753 8.90144 3.72888 10.9998C3.72888 11.1975 3.73634 11.3914 3.75498 11.5853C3.78705 12.0277 3.86198 12.4661 3.97871 12.8941C4.13263 13.4676 4.35681 14.0199 4.64617 14.5385C5.33973 14.4378 6.14143 15.0046 7.02515 14.8032C7.43159 14.7137 7.85668 14.6131 8.29295 14.5049L10.8472 13.8039C11.0001 13.7592 11.1529 13.7144 11.3096 13.6659C12.7563 13.2259 14.1099 12.7598 15.2919 12.3049C16.4665 11.8537 17.4733 10.6978 18.2377 10.2988C18.187 9.77415 18.0795 9.25653 17.917 8.75509C17.7838 8.34009 17.6128 7.93818 17.4062 7.55441C17.0274 6.85273 16.5361 6.21787 15.9519 5.67509C15.4162 5.17583 14.8077 4.76092 14.1472 4.44458L6.216 5.52594Z"
      fill="#4482C3"
    />
    <path
      d="M2.28656 10.4458C2.27323 10.4458 2.25991 10.445 2.24666 10.4435C2.14831 10.4331 2.05813 10.384 1.99596 10.3071C1.93379 10.2302 1.90473 10.1317 1.91517 10.0334C2.30453 6.37975 4.84445 3.31475 8.36217 2.25356C11.8799 1.19238 15.6911 2.34146 18.0359 5.17024C18.1221 5.27269 18.1468 5.41349 18.1005 5.53912C18.0543 5.66476 17.9442 5.75596 17.8122 5.77806C17.6801 5.80016 17.5464 5.74977 17.4617 5.64604C15.308 3.04932 11.8086 1.99481 8.57879 2.96922C5.34893 3.94363 3.01662 6.75748 2.65832 10.112C2.63825 10.3021 2.4777 10.4463 2.28656 10.4458Z"
      fill="#F3D55B"
    />
    <path
      d="M14.1471 4.44456C13.0678 5.13109 11.9049 5.67622 10.6868 6.06659C9.55696 6.391 8.06543 6.56253 6.95798 6.07405C6.69142 5.91889 6.4426 5.73508 6.21594 5.52591C8.40529 3.61129 11.5251 3.18592 14.1471 4.44456Z"
      fill="#ECF0F1"
    />
    <path
      d="M18.2377 10.299C17.2801 10.7827 16.2967 11.2134 15.2919 11.5892C15.0607 11.0448 14.9563 10.1499 14.2628 9.98953C13.7892 9.87767 13.2038 10.0417 12.8272 9.66885C12.5475 9.38936 12.3691 9.02458 12.3201 8.63224C12.2589 8.27431 12.4412 7.91894 12.7675 7.7597C13.036 7.64783 13.3753 7.67021 13.5841 7.45021C13.9144 7.05347 14.2814 6.6889 14.6804 6.36139C15.0879 6.10363 15.5128 5.87438 15.9519 5.67529C16.5361 6.21807 17.0274 6.85293 17.4062 7.55461C17.6128 7.93838 17.7838 8.34029 17.917 8.75529C18.0795 9.25673 18.187 9.77435 18.2377 10.299Z"
      fill="#4FBA6F"
    />
    <path
      d="M7.70008 10.5562C7.12957 11.0447 6.16753 11.4288 6.29431 12.3386C6.38008 12.9725 6.75296 13.5243 7.02516 14.0874C6.14143 14.2888 5.33974 14.4379 4.64618 14.5386C4.35682 14.02 4.13264 13.4677 3.97872 12.8942C3.86199 12.4662 3.78706 12.0278 3.75499 11.5854C3.73635 11.3915 3.72889 11.1976 3.72889 10.9999C3.7269 9.57433 4.14589 8.17987 4.9333 6.99146C5.55974 7.32705 6.20109 7.62908 6.84991 7.91993C7.37194 8.15485 8.0133 8.30027 8.23703 8.89688C8.3965 9.50736 8.18696 10.1549 7.70008 10.5562Z"
      fill="#4FBA6F"
    />
    <path
      d="M11.0001 20.1354C8.9338 20.1456 6.92677 19.4455 5.31512 18.1524C5.1622 18.0219 5.14031 17.7936 5.26565 17.6364C5.39098 17.4792 5.61839 17.4496 5.77973 17.5696C7.25968 18.7569 9.10274 19.3995 11.0001 19.3896C14.7716 19.3902 18.08 16.874 19.0867 13.2393C19.1409 13.0406 19.3459 12.9234 19.5446 12.9776C19.7434 13.0317 19.8606 13.2367 19.8064 13.4355C18.7112 17.3947 15.108 20.1361 11.0001 20.1354Z"
      fill="#F3D55B"
    />
    <path
      d="M15.512 16.7012C14.3507 17.6251 12.9326 18.1681 11.4513 18.2561C11.5614 17.8767 11.6946 17.5044 11.8503 17.1412C12.3126 16.265 13.6625 15.8287 14.5872 16.0934C14.9224 16.2518 15.2337 16.4564 15.512 16.7012Z"
      fill="#ECF0F1"
    />
    <path
      d="M10.8472 13.088C11 13.0432 11.1529 12.9985 11.3095 12.95C12.7563 12.51 14.1099 12.0439 15.2919 11.589C16.2967 11.2132 17.2801 10.7825 18.2377 10.2988C19.3265 9.73948 19.9306 9.26592 19.8411 8.9788C19.7553 8.70287 19.0506 8.63948 17.917 8.75507C17.7838 8.34007 17.6128 7.93816 17.4062 7.55439C19.9082 7.36422 21.6309 7.69236 21.8956 8.56117C22.1828 9.50083 20.695 10.8656 18.1743 12.193C18.1743 12.1951 18.1726 12.1968 18.1706 12.1968C16.1495 13.2389 14.0346 14.0879 11.8539 14.7324C11.6339 14.7995 11.4177 14.8629 11.2014 14.9225L10.8472 13.088Z"
      fill="#FFCA28"
    />
    <path
      d="M8.88208 15.5194C7.78954 15.7692 6.75293 15.9556 5.79835 16.0787H5.79462C2.63259 16.4851 0.376656 16.2055 0.0708936 15.2024C-0.212496 14.2665 1.25666 12.9129 3.75496 11.5854C3.78703 12.0279 3.86196 12.4663 3.97869 12.8943C2.66615 13.5394 1.91666 14.0838 2.01361 14.4044C2.11428 14.7326 3.10615 14.7587 4.64615 14.5387C5.33971 14.438 6.1414 14.2888 7.02513 14.0875C7.43157 13.998 7.85666 13.8973 8.29293 13.7892L8.88208 15.5194Z"
      fill="#FFCA28"
    />
    <path
      d="M11.358 14.2439C11.3584 14.4791 11.3048 14.7113 11.2014 14.9226C10.855 15.6357 10.0284 15.9751 9.28081 15.7111C8.53325 15.447 8.10308 14.6638 8.28135 13.8913C8.45962 13.1188 9.1895 12.6033 9.97715 12.6936C10.7648 12.7839 11.3591 13.4511 11.358 14.2439Z"
      fill="#FFCA28"
    />
  </g>
  <g id="mail">
    <path
      d="M20.7559 1.19862C19.9755 0.429287 18.9234 -0.00139158 17.8276 3.37814e-06H4.17241C3.0656 -0.000701627 2.00393 0.438664 1.22129 1.2213C0.438662 2.00393 -0.000704158 3.06561 8.47127e-07 4.17242V14.0345C-0.000704158 15.1413 0.438662 16.203 1.22129 16.9856C2.00393 17.7682 3.0656 18.2076 4.17241 18.2069H14.8462C14.9545 18.2064 15.0579 18.2519 15.1307 18.3321L18.3093 21.8786C18.4248 22.0009 18.6071 22.0325 18.757 21.9562C18.907 21.8799 18.9888 21.714 18.9579 21.5486L18.4686 18.5103C18.4358 18.3182 18.5564 18.1331 18.7455 18.0855C19.4952 17.9049 20.182 17.5248 20.7331 16.9855C21.5397 16.2155 21.9973 15.1497 22 14.0345V4.17242C22.0014 3.0543 21.5531 1.98261 20.7559 1.19862Z"
      fill="#F29C1F"
    />
    <path
      d="M22 4.17252V14.0346C21.9973 15.1498 21.5397 16.2156 20.7331 16.9856L12.5514 9.10356L20.7559 1.19873C21.5531 1.98271 22.0015 3.05441 22 4.17252Z"
      fill="#F0C419"
    />
    <path
      d="M20.7559 1.19862L12.5514 9.10345L12.3162 9.33104C11.5821 10.0403 10.4179 10.0403 9.6838 9.33104L9.44863 9.10345L2.34035 2.25311L1.24414 1.19862C2.02446 0.429287 3.07662 -0.00139158 4.17242 3.37814e-06H17.8276C18.9234 -0.00139158 19.9756 0.429287 20.7559 1.19862Z"
      fill="#F3D55B"
    />
    <path
      d="M9.44862 9.10356L1.24415 17.0084C0.446281 16.2248 -0.00220249 15.1529 8.13369e-06 14.0346V4.17252C-0.00143089 3.05441 0.446932 1.98271 1.24415 1.19873L2.34035 2.25321L9.44862 9.10356Z"
      fill="#F0C419"
    />
    <path
      d="M10.6207 1.89656H5.31034C5.10085 1.89656 4.93103 1.72674 4.93103 1.51725C4.93103 1.30776 5.10085 1.13794 5.31034 1.13794H10.6207C10.8302 1.13794 11 1.30776 11 1.51725C11 1.72674 10.8302 1.89656 10.6207 1.89656Z"
      fill="white"
    />
    <path
      d="M3.79313 1.89656C4.00262 1.89656 4.17244 1.72674 4.17244 1.51725C4.17244 1.30776 4.00262 1.13794 3.79313 1.13794C3.58364 1.13794 3.41382 1.30776 3.41382 1.51725C3.41382 1.72674 3.58364 1.89656 3.79313 1.89656Z"
      fill="white"
    />
  </g>
  <g id="groups">
    <g clip-path="url(#clip3)">
      <path fill="#FDD7AD" d="M5.31 1.9a1.9 1.9 0 11-3.8 0 1.9 1.9 0 013.8 0z" />
      <path
        fill="#E64C3C"
        d="M6.83 6.07v2.27c0 .42-.34.76-.76.76a.76.76 0 01-.76-.76v1.52h-3.8V8.34c0 .42-.33.76-.75.76-.2 0-.4-.08-.54-.22A.74.74 0 010 8.34V6.07c0-.63.5-1.14 1.14-1.14h4.55c.63 0 1.14.51 1.14 1.14z"
      />
      <path
        fill="#C03A2B"
        d="M5.31 8.72a.38.38 0 01-.38-.38v-1.9a.38.38 0 01.76 0v1.9c0 .21-.17.38-.38.38zM1.52 8.72a.38.38 0 01-.38-.38v-1.9a.38.38 0 11.76 0v1.9c0 .21-.17.38-.38.38z"
      />
      <path fill="#C03A2B" d="M5.31 8.72a.38.38 0 01-.38-.37v-.76a.38.38 0 01.76 0v.76c0 .2-.17.37-.38.37z" />
      <path fill="#35495E" d="M5.31 9.86v3.6a.95.95 0 01-1.9 0 .95.95 0 01-1.9 0v-3.6h3.8z" />
      <path fill="#C03A2B" d="M1.52 8.72a.38.38 0 01-.38-.38V7.6a.38.38 0 11.76 0v.75c0 .21-.17.38-.38.38z" />
      <path fill="#FDD7AD" d="M12.14 1.9a1.9 1.9 0 11-3.8 0 1.9 1.9 0 013.8 0z" />
      <path
        fill="#E64C3C"
        d="M13.66 6.07v2.27c0 .42-.35.76-.76.76a.76.76 0 01-.76-.76v1.52h-3.8V8.34c0 .42-.34.76-.75.76a.76.76 0 01-.76-.76V6.07c0-.63.5-1.14 1.14-1.14h4.55c.63 0 1.14.51 1.14 1.14z"
      />
      <path
        fill="#C03A2B"
        d="M12.14 8.72a.38.38 0 01-.38-.38v-1.9a.38.38 0 11.76 0v1.9c0 .21-.17.38-.38.38zM8.34 8.72a.38.38 0 01-.37-.38v-1.9a.38.38 0 01.75 0v1.9c0 .21-.17.38-.38.38z"
      />
      <path fill="#C03A2B" d="M12.14 8.72a.38.38 0 01-.38-.38V7.6a.38.38 0 11.76 0v.75c0 .21-.17.38-.38.38z" />
      <path fill="#35495E" d="M12.14 9.86v3.6a.95.95 0 01-1.9 0 .95.95 0 11-1.9 0v-3.6h3.8z" />
      <path fill="#FDD7AD" d="M8.72 4.17a1.9 1.9 0 11-3.79 0 1.9 1.9 0 013.8 0z" />
      <path
        fill="#FFCA28"
        d="M10.24 7.97v2.27c0 .42-.34.76-.76.76a.76.76 0 01-.76-.76v1.52H4.93v-1.52c0 .42-.34.76-.76.76a.76.76 0 01-.76-.76V7.97c0-.63.51-1.14 1.14-1.14H9.1c.63 0 1.14.5 1.14 1.14z"
      />
      <path
        fill="#F2994A"
        d="M8.72 10.62a.38.38 0 01-.38-.38v-1.9a.38.38 0 01.76 0v1.9c0 .21-.17.38-.38.38zM4.93 10.62a.38.38 0 01-.38-.38v-1.9a.38.38 0 01.76 0v1.9c0 .21-.17.38-.38.38z"
      />
      <path fill="#F2994A" d="M8.72 10.62a.38.38 0 01-.38-.38v-.76a.38.38 0 11.76 0v.76c0 .21-.17.38-.38.38z" />
      <path fill="#285680" d="M8.72 11.76v3.6a.95.95 0 01-1.9 0 .95.95 0 01-1.89 0v-3.6h3.8z" />
      <path fill="#2C3E50" d="M6.83 15.74a.38.38 0 01-.38-.38v-1.7a.38.38 0 11.76 0v1.7c0 .21-.17.38-.38.38z" />
      <path fill="#F2994A" d="M4.93 10.62a.38.38 0 01-.38-.38v-.76a.38.38 0 11.76 0v.76c0 .21-.17.38-.38.38z" />
      <path
        fill="#2C3E50"
        d="M3.41 13.84a.38.38 0 01-.38-.37v-1.71a.38.38 0 01.76 0v1.7c0 .21-.17.38-.38.38zM10.24 13.84a.38.38 0 01-.38-.37v-1.71a.38.38 0 01.76 0v1.7c0 .21-.17.38-.38.38z"
      />
      <path fill="#E0E0E0" d="M22 16.31a5.69 5.69 0 11-11.38 0 5.69 5.69 0 0111.38 0z" />
      <path
        fill="#35495E"
        d="M19.72 16.31c0 .63-.5 1.14-1.13 1.14h-.95c-.1 0-.2.08-.2.19v.95a1.14 1.14 0 01-2.27 0v-.95c0-.1-.08-.2-.19-.2h-.95a1.14 1.14 0 010-2.27h.95c.1 0 .2-.08.2-.19v-.95a1.14 1.14 0 112.27 0v.95c0 .1.08.2.19.2h.95c.62 0 1.13.5 1.13 1.13z"
      />
    </g>
    <defs>
      <clipPath id="clip3"><path fill="#fff" d="M0 0h22v22H0z" /></clipPath>
    </defs>
  </g>
  <g id="bell">
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.60889 19.9746C7.79475 21.1126 9.24372 22.0001 10.9999 22.0001C12.7561 22.0001 14.2051 21.1126 14.391 19.9746H7.60889Z"
        fill="#F29C1F"
      />
      <path
        d="M19.9554 18.9238C17.9602 19.6786 14.6944 20.1034 10.9999 20.1034C7.3054 20.1034 4.03954 19.6786 2.04437 18.9238C1.52773 18.7276 1.12258 18.3155 0.935187 17.7957C0.747796 17.2758 0.796873 16.7 1.06954 16.2193C1.14564 16.082 1.24007 15.9557 1.35023 15.8438C1.42609 15.7641 1.50575 15.6807 1.5854 15.5934C2.90161 14.1786 4.55161 11.8459 4.55161 9.10345V8.50793C4.54845 6.08941 5.85468 3.85865 7.9654 2.67793C8.20968 2.54159 8.46317 2.42245 8.72403 2.32138V2.27586C8.72403 1.01894 9.74296 0 10.9999 0C12.2568 0 13.2757 1.01894 13.2757 2.27586V2.31379C13.5364 2.41099 13.7899 2.52633 14.0344 2.65897C14.5967 2.95514 15.1109 3.33499 15.5592 3.78552C16.7711 4.99294 17.4511 6.63409 17.4482 8.34483V9.10345C17.4482 11.8459 19.0982 14.1786 20.4144 15.5934C20.494 15.6807 20.5737 15.7641 20.6495 15.8438C20.7597 15.9557 20.8541 16.082 20.9302 16.2193C21.2029 16.7 21.252 17.2758 21.0646 17.7957C20.8772 18.3155 20.472 18.7276 19.9554 18.9238Z"
        fill="#F0C419"
      />
      <path
        d="M8.72396 2.32129V3.4137C8.72396 3.62319 8.55413 3.79301 8.34465 3.79301C8.13516 3.79301 7.96533 3.62319 7.96533 3.4137V2.67784C8.20961 2.5415 8.4631 2.42236 8.72396 2.32129Z"
        fill="#F29C1F"
      />
      <path
        d="M14.0345 2.65889V3.41372C14.0345 3.62321 13.8647 3.79303 13.6552 3.79303C13.4457 3.79303 13.2759 3.62321 13.2759 3.41372V2.31372C13.5365 2.41092 13.79 2.52626 14.0345 2.65889Z"
        fill="#F29C1F"
      />
      <path
        d="M4.16475 16.5074C4.13525 16.6896 3.97755 16.8231 3.79303 16.8222C3.77125 16.8237 3.74939 16.8211 3.72855 16.8147C2.82958 16.6591 1.97992 16.4771 1.19855 16.2798C1.15145 16.2698 1.10731 16.249 1.06958 16.2191C1.14568 16.0818 1.24011 15.9555 1.35027 15.8436C1.42613 15.764 1.50579 15.6805 1.58544 15.5933C2.29475 15.7677 3.05717 15.9271 3.85751 16.0712C3.95671 16.0871 4.04528 16.1424 4.10313 16.2245C4.16098 16.3066 4.1832 16.4087 4.16475 16.5074Z"
        fill="white"
      />
      <path
        d="M20.9302 16.2191C20.8925 16.249 20.8484 16.2698 20.8013 16.2798C17.5925 17.0593 14.302 17.4515 10.9999 17.4481C9.33669 17.4468 7.67499 17.348 6.02334 17.1522C5.88125 17.1456 5.7548 17.0601 5.6958 16.9307C5.63679 16.8012 5.65516 16.6497 5.74338 16.5381C5.8316 16.4265 5.97483 16.3736 6.11438 16.4012C7.73602 16.5907 9.36721 16.687 10.9999 16.6895C14.17 16.6921 17.3296 16.3242 20.4144 15.5933C20.494 15.6805 20.5737 15.764 20.6495 15.8436C20.7597 15.9555 20.8541 16.0818 20.9302 16.2191Z"
        fill="white"
      />
      <path
        d="M10.9999 3.41389C10.7904 3.41389 10.6206 3.24406 10.6206 3.03458V1.89664C10.6206 1.68716 10.7904 1.51733 10.9999 1.51733C11.2094 1.51733 11.3792 1.68716 11.3792 1.89664V3.03458C11.3792 3.24406 11.2094 3.41389 10.9999 3.41389Z"
        fill="#F29C1F"
      />
    </svg>
  </g>
  <g id="profile">
    <path
      fill="#ECF0F1"
      d="M15.86 20H4.14a.69.69 0 01-.7-.69V.69c0-.38.32-.69.7-.69h11.72c.38 0 .7.3.7.69v18.62c0 .38-.32.69-.7.69z"
    />
    <path
      fill="#B1B4B5"
      d="M15.86 0h-1.03c.38 0 .69.3.69.69v18.62c0 .38-.31.69-.7.69h1.04c.38 0 .7-.3.7-.69V.69c0-.38-.32-.69-.7-.69z"
    />
    <path
      fill="#F4F7F7"
      d="M4.14 20h1.03a.69.69 0 01-.69-.69V.69c0-.38.31-.69.7-.69H4.13c-.38 0-.7.3-.7.69v18.62c0 .38.32.69.7.69z"
    />
    <path fill="#fff" d="M15.17 6.55a5.17 5.17 0 11-10.34 0 5.17 5.17 0 0110.34 0z" />
    <path
      fill="#BDC3C7"
      d="M12.76 13.45H7.24a.34.34 0 110-.7h5.52a.34.34 0 110 .7zM7.59 15.52H5.52a.34.34 0 110-.7h2.07a.34.34 0 110 .7zM8.28 16.9H5.52a.34.34 0 110-.7h2.76a.34.34 0 110 .7zM13.8 16.9h-2.08a.34.34 0 110-.7h2.07a.34.34 0 110 .7zM14.48 15.52h-2.76a.34.34 0 110-.7h2.76a.34.34 0 110 .7z"
    />
    <path fill="#556080" d="M5.86 20h8.28v-1.38H5.86V20z" />
    <path
      fill="#26B99A"
      d="M9.31 8.97a.34.34 0 01-.24-.1L7.34 7.13a.34.34 0 11.49-.49L9.27 8.1l2.87-3.82a.34.34 0 01.55.4l-3.1 4.15a.35.35 0 01-.26.13h-.02z"
    />
  </g>
  <g id="privacy">
    <g clip-path="url(#clip31)">
      <path
        fill="#ECF0F1"
        d="M18.62.34H1.38C.62.34 0 .96 0 1.72v13.1c0 .77.62 1.39 1.38 1.39h17.24c.76 0 1.38-.62 1.38-1.38V1.73c0-.77-.62-1.39-1.38-1.39z"
      />
      <path
        fill="#FB7B76"
        d="M17.66 15.12c-.52.5-1.2 1.14-1.98 1.77-1.7 1.39-3.86 2.76-5.68 2.76-1.82 0-3.97-1.37-5.68-2.76a29.72 29.72 0 01-1.98-1.77 1.38 1.38 0 010-1.97c.52-.5 1.2-1.13 1.98-1.77C6.02 10 8.18 8.62 10 8.62c1.82 0 3.97 1.38 5.68 2.76.78.64 1.46 1.27 1.98 1.77a1.38 1.38 0 010 1.97z"
      />
      <path
        fill="#fff"
        d="M16.87 15.37c-.33.44-.74.97-1.2 1.52-1.7 1.39-3.85 2.76-5.67 2.76-1.82 0-3.97-1.37-5.68-2.76-.45-.55-.86-1.08-1.19-1.52-.5-.75-.5-1.72 0-2.46.33-.45.74-.98 1.2-1.53C6.02 10 8.17 8.62 10 8.62c1.82 0 3.97 1.38 5.68 2.76.45.55.86 1.08 1.19 1.53.5.74.5 1.71 0 2.46z"
      />
      <path
        fill="#3B97D3"
        d="M15.52 14.14c0 1.72-.8 3.34-2.17 4.39l-.02.01A7 7 0 0110 19.66a7 7 0 01-3.32-1.1h-.01l-.01-.01a5.53 5.53 0 010-8.8l.02-.01A7 7 0 0110 8.62a7 7 0 013.32 1.1l.01.01h.01v.01a5.53 5.53 0 012.18 4.4zM20 1.72V3.1H0V1.72C0 .96.62.34 1.38.34h17.24c.76 0 1.38.62 1.38 1.38z"
      />
      <path
        fill="#2980BA"
        d="M11.03 2.07H8.97a.34.34 0 010-.7h2.06a.34.34 0 010 .7zM18.62 2.07h-3.8a.34.34 0 010-.7h3.8a.34.34 0 110 .7z"
      />
      <path fill="#FF5364" d="M1.38 2.07a.34.34 0 100-.7.34.34 0 000 .7z" />
      <path fill="#F0C419" d="M2.76 2.07a.34.34 0 100-.7.34.34 0 000 .7z" />
      <path fill="#65DDB9" d="M4.14 2.07a.34.34 0 100-.7.34.34 0 000 .7z" />
      <path fill="#2980BA" d="M8.14 11.66a3.1 3.1 0 11-.88 1.02l.88-1.02z" />
      <path fill="#285680" d="M10 15.86a1.72 1.72 0 100-3.45 1.72 1.72 0 000 3.45z" />
      <path
        fill="#35495E"
        d="M4.83 5.17H3.45a.34.34 0 110-.69h1.38a.34.34 0 110 .7zM16.55 5.17h-1.38a.34.34 0 010-.69h1.38a.34.34 0 110 .7zM13.8 5.17H6.2a.34.34 0 110-.69h7.6a.34.34 0 110 .7zM12.76 6.55H7.24a.34.34 0 010-.69h5.52a.34.34 0 010 .7z"
      />
      <path fill="#ECF0F1" d="M7.59 13.45a1.38 1.38 0 100-2.76 1.38 1.38 0 000 2.76z" />
    </g>
    <defs>
      <clipPath id="clip31">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </g>
  <g id="search">
    <path
      d="M6.5 0a6.5 6.5 0 015 10.7l.2.3h.8l5 5-1.5 1.5-5-5v-.8l-.3-.3A6.5 6.5 0 116.5 0zm0 2C4 2 2 4 2 6.5S4 11 6.5 11 11 9 11 6.5 9 2 6.5 2z"
    />
  </g>
  <g id="menu-dots">
    <g clip-path="url(#clip5)" fill="#BDBDBD">
      <path
        d="M2.4 12.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zM17.6 12.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zM10 12.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z"
      />
    </g>
    <defs>
      <clipPath id="clip5"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="menu-dots-green">
    <g fill="#47979D" clip-path="url(#clip5-1)">
      <path
        d="M2.41 12.41a2.41 2.41 0 100-4.82 2.41 2.41 0 000 4.82zM17.59 12.41a2.41 2.41 0 100-4.82 2.41 2.41 0 000 4.82zM10 12.41a2.41 2.41 0 100-4.82 2.41 2.41 0 000 4.82z"
      />
    </g>
    <defs>
      <clipPath id="clip5-1"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="location">
    <path
      d="M17.6 7.6c0 1-.5 2.4-1.2 3.8a35.6 35.6 0 01-5.2 7.6l-.6.7a.8.8 0 01-1.2 0l-.6-.7a63.5 63.5 0 01-5.2-7.6 9.1 9.1 0 01-1.2-3.8 7.6 7.6 0 0115.2 0z"
      fill="#F2C94C"
    />
    <path d="M13.6 7.2a3.6 3.6 0 11-7.2 0 3.6 3.6 0 017.2 0z" fill="#F2994A" />
    <path d="M12.4 7.2a2.4 2.4 0 11-4.8 0 2.4 2.4 0 014.8 0z" fill="#fff" />
  </g>
  <g id="cap">
    <path
      d="M.4 14.4l1-2.1 1 2.1a1 1 0 01-.9 1.3h-.2a1 1 0 01-.9-1.3zM20 8.8l-10 4.8L0 8.8l10-5.5 10 5.5z"
      fill="#6581C9"
    />
    <path
      d="M1.4 13.3a.3.3 0 01-.4-.4V9.5c0-.2.2-.4.3-.4l8.7-1a.3.3 0 110 .7l-8.3 1v3.1c0 .2-.1.4-.3.4z"
      fill="#445793"
    />
    <path
      d="M10 13.6l-6.2-3v3a2 2 0 001.1 1.7l.7.4c2.8 1.4 6 1.4 8.8 0l.7-.4a2 2 0 001.1-1.7v-3l-6.2 3zM11.4 8.5a1.4 1.4 0 11-2.8 0 1.4 1.4 0 012.8 0z"
      fill="#445793"
    />
  </g>
  <g id="startup">
    <g clip-path="url(#clip6)">
      <path
        d="M9.7 14.6l-2.2 4.9a.3.3 0 01-.6 0L6.2 18a.3.3 0 00-.6 0l-1.9 1.9a.3.3 0 01-.6-.2V17c0-.2 0-.2-.2-.2H.3c-.3 0-.4-.6-.2-.8l2-1.7a.3.3 0 00-.1-.6l-1.5-.6a.3.3 0 010-.7l5-2.2 3.8.7.4 3.6z"
        fill="#F0C419"
      />
      <path
        d="M7.2 10.9l-3.4 1.6a.3.3 0 000 .6l1.4.7-1.7 1.4a.2.2 0 000 .3h.8a.2.2 0 01.2.2v.7a.2.2 0 00.3.1l1.4-1.7.7 1.4a.3.3 0 00.6 0L9 12.8l-2-2z"
        fill="#F29C1F"
      />
      <path
        d="M12.5 12.4l.6 2c0 .4 0 .8-.2 1.2L10.5 19a.3.3 0 01-.6-.2l.2-3.1c0-.3 0-.5-.2-.8l-1-2v-.2l-1.6-1.6h-.1L5 10a2 2 0 00-.8-.2l-3.1.2a.3.3 0 01-.2-.6l3.4-2.4c.4-.2.8-.3 1.2-.2l2 .6 4.9 5z"
        fill="#C03A2B"
      />
      <path d="M9 12.8l-2.5 1.8a.8.8 0 01-1.1-1.1l1.8-2.4V11L9 12.8z" fill="#E64C3C" />
      <path
        d="M17 9.4c-3.3 3.3-7.4 4.5-9.1 2.7-1.8-1.7-.6-5.8 2.7-9a12.2 12.2 0 018-3.1A1.4 1.4 0 0120 1.4c0 .6 0 1.1-.2 1.7-.3 2-1.2 4.6-2.9 6.3z"
        fill="#4482C3"
      />
      <path
        d="M19.8 3c-.6-.2-1.2-.6-1.7-1.1-.5-.5-.9-1-1.2-1.7l1.7-.2A1.4 1.4 0 0120 1.4c0 .6 0 1.1-.2 1.7z"
        fill="#C03A2B"
      />
      <path
        d="M17.6 3.8a1.4 1.4 0 11-2.8 0 1.4 1.4 0 012.8 0zM14.7 7.7a2.4 2.4 0 11-4.8 0 2.4 2.4 0 014.8 0z"
        fill="#A5A5A4"
      />
      <path d="M13.3 7.7a1 1 0 11-2 0 1 1 0 012 0z" fill="#5E5F62" />
    </g>
    <defs>
      <clipPath id="clip6"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="work">
    <g clip-path="url(#clip7)">
      <path d="M3.7 3.9l1.7-2.7.6.4-1.8 2.7-.5-.4zM14 1.6l.6-.4L16.3 4l-.5.4L14 1.6z" fill="#A56A43" />
      <path
        d="M2 3.8h16c1 0 2 1 2 2v11.8c0 .7-.6 1.4-1.4 1.4H1.4C.6 19 0 18.3 0 17.6V5.9c0-1.2 1-2.1 2-2.1z"
        fill="#A56A43"
      />
      <path
        d="M19 4.1c-.2.3-.4.7-.4 1v6.3c0 .4-.3.7-.7.7H2.1a.7.7 0 01-.7-.7V5.2c0-.4-.2-.8-.5-1a2 2 0 011.2-.4h15.8l1.2.3zM14.1 1H6a.7.7 0 100 1.4H14a.7.7 0 100-1.4z"
        fill="#CB8252"
      />
      <path
        d="M9 13.4v-.3c0-1-.7-1.4-.7-2.8A1.7 1.7 0 0110 8.6c1 .1 1.7 1 1.6 2 0 1.2-.7 1.5-.7 2.5v.3H9z"
        fill="#F29C1F"
      />
      <path d="M9 13.1v-1.4c0-.4.3-.7.7-.7h.6c.4 0 .7.3.7.7v4.9a1 1 0 11-2 0V13z" fill="#F0C419" />
      <path
        d="M2 18h-.6a.3.3 0 010-.8H2a.3.3 0 010 .7zM7.6 18H3.4a.3.3 0 010-.8h4.2a.3.3 0 010 .7zM18.6 18H18a.3.3 0 010-.8h.7a.3.3 0 010 .7zM16.6 18h-4.2a.3.3 0 110-.8h4.2a.3.3 0 010 .7z"
        fill="#805333"
      />
      <path d="M11 13.4H9c-.2 0-.4.2-.4.4v.7c0 .2.2.3.4.3h2c.2 0 .4-.1.4-.3v-.7c0-.2-.2-.4-.4-.4z" fill="#F3D55B" />
    </g>
    <defs>
      <clipPath id="clip7"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="files">
    <g clip-path="url(#clip8)">
      <path
        d="M16.3 2.7V1.2C16.3.5 15.7 0 15 0H2.5C2 0 1.4.5 1.4 1.2V16c0 .6.5 1.2 1.1 1.2h1.6L16.3 2.7z"
        fill="#BDC3C7"
      />
      <path
        d="M10.8 2.7h6.7c.6 0 1.1.6 1.1 1.2v15c0 .6-.5 1.1-1.1 1.1H5.3c-.7 0-1.2-.5-1.2-1.2V4c0-.6.5-1.2 1.2-1.2h1.2"
        fill="#ECF0F1"
      />
      <path d="M17 18.8h-1.5a.4.4 0 110-.8h1.2V17a.4.4 0 01.8 0v1.5c0 .2-.2.4-.4.4z" fill="#95A5A5" />
      <path
        d="M16.3 8.2H6.5a.4.4 0 010-.7h9.8a.4.4 0 110 .7zM16.3 10.6H6.5a.4.4 0 010-.8h9.8a.4.4 0 110 .8zM16.3 13H6.5a.4.4 0 010-.8h9.8a.4.4 0 010 .7zM11.6 15.3H6.5a.4.4 0 010-.8h5a.4.4 0 110 .8z"
        fill="#BDC3C7"
      />
      <path d="M15.3 20a4.1 4.1 0 100-8.3 4.1 4.1 0 000 8.3z" fill="#71C386" />
      <path
        d="M17.4 15.5h-1.7v-1.7a.3.3 0 00-.7 0v1.7h-1.7a.3.3 0 000 .7H15V18a.3.3 0 00.7 0v-1.7h1.7a.3.3 0 000-.7z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="clip8"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="photo">
    <path d="M5.5 9V.7c0-.4.3-.7.7-.7h13.1c.4 0 .7.3.7.7V11c0 .4-.3.7-.7.7h-4.1L5.5 9z" fill="#2FA8CC" />
    <path d="M8.6 3.4a1 1 0 100-2 1 1 0 000 2z" fill="#F0C419" />
    <path d="M20 9.7V11c0 .4-.3.7-.7.7h-4.1l-7.3-2H20z" fill="#2980BA" />
    <path d="M20 5.5v4.2h-2l-4.5-4.3L15 3.7c.4.3 1 .4 1.5.4s1-.1 1.5-.5l1.9 2z" fill="#2C3E50" />
    <path d="M18 9.7H8L5.4 9v-.4L9.7 5c.5.4 1 .6 1.7.6.6 0 1.1-.2 1.6-.6l.5.5L18 9.7z" fill="#35495E" />
    <path
      d="M9 7.6h2.6c.3 0 .5.1.7.4l.5 1-2.5.7L8 9l.5-1c.1-.3.4-.4.6-.4zM2 7.6h.8c.3 0 .6.3.6.7v1.4h-2V8.3c0-.4.3-.7.7-.7z"
      fill="#3F5C6C"
    />
    <path d="M14.5 9H.7c-.4 0-.7.3-.7.7v9.6c0 .4.3.7.7.7h13.8c.4 0 .7-.3.7-.7V9.7c0-.4-.3-.7-.7-.7z" fill="#955BA5" />
    <path d="M9 18.6a4.1 4.1 0 100-8.3 4.1 4.1 0 000 8.3z" fill="#35495E" />
    <path d="M11.7 14.5a2.8 2.8 0 11-5.5 0 2.8 2.8 0 015.5 0z" fill="#2FA8CC" />
    <path d="M11 13.1A2.8 2.8 0 016.3 15v-.5a2.8 2.8 0 014.7-1.9v.5z" fill="#67B9CC" />
    <path d="M9 15.5a1 1 0 100-2 1 1 0 000 2z" fill="#3B97D3" />
    <path d="M3.4 11.7a.7.7 0 100-1.4.7.7 0 000 1.4z" fill="#F0C419" />
    <path d="M3.1 12.8V20h-.7v-7.2a.3.3 0 01.7 0z" fill="#894B9D" />
    <path
      d="M13 5c-.5.3-1 .5-1.6.5-.6 0-1.2-.2-1.7-.6l1.4-1.2c.2-.2.4-.2.5 0L13 4.9zM18.1 3.6c-.4.4-1 .6-1.5.5-.6 0-1.1-.1-1.5-.4l1.2-1.4a.3.3 0 01.5 0l1.3 1.3z"
      fill="#ECF0F1"
    />
  </g>
  <g id="smile">
    <path
      d="M10.6 17.9l4 1.6a1.5 1.5 0 002.2-1.5l-.4-4.4c0-.4.1-.8.4-1.1L19.6 9a1.5 1.5 0 00-.8-2.5l-4.2-1c-.4-.2-.8-.4-1-.8l-2.3-3.7a1.6 1.6 0 00-2.6 0L6.4 4.8c-.2.4-.6.6-1 .7l-4.2 1a1.5 1.5 0 00-.8 2.6l2.8 3.4c.3.3.4.7.4 1L3.2 18a1.5 1.5 0 002.2 1.5l4-1.6c.4-.2.8-.2 1.2 0z"
      fill="#F3D55B"
    />
    <path
      d="M19.6 9l-2.8 3.5c-.3.3-.4.7-.4 1l.4 4.5a1.5 1.5 0 01-2.2 1.5l-4-1.6-.6-.2V.3c.5 0 1 .3 1.3.8l2.3 3.7c.2.4.6.6 1 .7l4.2 1a1.5 1.5 0 01.8 2.6z"
      fill="#F0C419"
    />
    <path
      d="M12.4 10.1c-.5 0-1-.2-1.3-.5a.3.3 0 01.5-.5 1 1 0 001.6 0 .3.3 0 01.5.5 2 2 0 01-1.3.5zM7.6 10.1a2 2 0 01-1.3-.5.3.3 0 01.5-.5 1 1 0 001.6 0 .3.3 0 01.5.5c-.4.3-.8.5-1.3.5z"
      fill="#35495E"
    />
    <path
      d="M10 14.5c-3 0-3.4-2.4-3.4-2.4a.3.3 0 01.6 0s.3 1.7 2.8 1.7 2.8-1.8 2.8-1.8a.3.3 0 01.6.1s-.3 2.4-3.4 2.4z"
      fill="#802D40"
    />
  </g>
  <g id="send">
    <g clip-path="url(#clip9)">
      <path
        d="M23.7.1L.2 13.8a.4.4 0 000 .8l6.7 3L8.6 25l5.2-3.9 6 3.4a.4.4 0 00.7-.3L24.2 5l.8-4a.9.9 0 00-1.3-.9z"
        fill="#9FC9D3"
      />
      <path d="M22.3 4.6l-.1.1-10.6 15.1-3 5.2L7 17.7 21.6 4.2a.4.4 0 01.7.4z" fill="#069278" />
      <path
        d="M25 1l-.8 4-3.7 19.2a.4.4 0 01-.7.3l-6-3.4-2.2-1.3 10.6-15a.4.4 0 000-.2.4.4 0 00-.6-.4L6.9 17.7.2 14.6a.4.4 0 010-.8L23.7.1a.9.9 0 011.3 1z"
        fill="#00AB8D"
      />
      <path d="M13.8 21v.1L8.6 25l3-5.2 2.2 1.3z" fill="#3B97D3" />
    </g>
    <defs>
      <clipPath id="clip9"><path fill="#fff" d="M0 0h25v25H0z" /></clipPath>
    </defs>
  </g>
  <g id="plus">
    <path
      d="M13.2 5.7h-4v-4a1.8 1.8 0 00-3.5 0v4h-4a1.8 1.8 0 000 3.6h4v4a1.8 1.8 0 003.6 0v-4h4a1.8 1.8 0 000-3.6z"
      fill="#BDBDBD"
    />
  </g>
  <g id="plus-white">
    <path
      d="M13.2 5.7h-4v-4a1.8 1.8 0 00-3.5 0v4h-4a1.8 1.8 0 000 3.6h4v4a1.8 1.8 0 003.6 0v-4h4a1.8 1.8 0 000-3.6z"
      fill="#fff"
    />
  </g>
  <g id="like">
    <g clip-path="url(#clip10)">
      <path
        fill="#F0C419"
        d="M12.99 15.04a5.5 5.5 0 01.83-2.5c.46-.71 1.06-1.33 1.46-2.09.8-1.52 1.17-2.6 1.02-4.32A6.4 6.4 0 0010 .37a6.4 6.4 0 00-6.3 5.76c-.16 1.71.2 2.8 1.02 4.32.4.76 1 1.38 1.45 2.1.48.75.76 1.6.84 2.5h5.98z"
      />
      <path fill="#A5A5A4" d="M12.67 17.04v1.67a1 1 0 01-1 1H8.33a.98.98 0 01-.77-.36 1 1 0 01-.23-.64v-1.67h5.34z" />
      <path
        fill="#E57E25"
        d="M9 15.37a.33.33 0 01-.33-.33V9.37h-1a1.33 1.33 0 110-2.66H8c.74 0 1.33.6 1.33 1.33v.67H10a.33.33 0 010 .66h-.67v5.67c0 .18-.15.33-.33.33zm-1.33-8a.67.67 0 100 1.34h1v-.67c0-.37-.3-.67-.67-.67h-.33z"
      />
      <path
        fill="#E57E25"
        d="M11 15.37a.33.33 0 01-.33-.33V9.37H10a.33.33 0 010-.66h.67v-.67c0-.74.6-1.33 1.33-1.33h.33a1.33 1.33 0 110 2.66h-1v5.67c0 .18-.15.33-.33.33zm.33-6.66h1a.67.67 0 100-1.34H12c-.37 0-.67.3-.67.67v.67z"
      />
      <path
        fill="#F29C1F"
        d="M2 7.04H.33a.33.33 0 110-.67H2a.33.33 0 110 .67zM1.63 11.87a.33.33 0 01-.17-.62l1.45-.83a.33.33 0 01.33.58l-1.44.83a.33.33 0 01-.17.04zM18.37 11.87a.33.33 0 01-.17-.04L16.76 11a.33.33 0 11.33-.58l1.45.83a.33.33 0 01-.17.62zM19.67 7.04H18a.33.33 0 110-.67h1.67a.33.33 0 110 .67zM16.93 3.04a.33.33 0 01-.17-.62l1.44-.83a.33.33 0 11.34.57L17.09 3a.33.33 0 01-.16.04zM3.07 3.04A.33.33 0 012.9 3l-1.44-.84a.33.33 0 01.33-.57l1.45.83a.33.33 0 01-.17.62z"
      />
      <path
        fill="#5E5F62"
        d="M12.43 17.04c0 .12-.06.23-.16.29L8.23 19.7a.98.98 0 01-.67-.36.4.4 0 01.08-.07l3.8-2.23.49-.29a.33.33 0 01.5.3z"
      />
      <path fill="#D1D4D1" d="M7.33 15.04h5.34a1 1 0 110 2H7.33a1 1 0 110-2z" />
    </g>
    <defs>
      <clipPath id="clip10"><path fill="#fff" d="M0 .02h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="comment">
    <g clip-path="url(#clip11)">
      <path
        fill="#0391FD"
        d="M16.55 6.9v7.28c0 .94-.76 1.7-1.7 1.7H7.6l-3.45 3.8v-3.8H1.7a1.7 1.7 0 01-1.7-1.7V6.9c0-.93.76-1.7 1.7-1.7h13.15c.94 0 1.7.77 1.7 1.7z"
      />
      <path
        fill="#4362A5"
        d="M18.3.37H5.15c-.94 0-1.7.76-1.7 1.7v3.12h11.4c.94 0 1.7.77 1.7 1.7v4.17h1.75c.94 0 1.7-.76 1.7-1.7v-7.3c0-.93-.76-1.7-1.7-1.7z"
      />
      <path
        fill="#fff"
        d="M3.8 11.75a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07zM8.28 11.75a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07zM12.76 11.75a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07z"
      />
    </g>
    <defs>
      <clipPath id="clip11"><path fill="#fff" d="M0 .02h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="share">
    <g clip-path="url(#clip12)">
      <path
        fill="#DF4D60"
        d="M12.41 3.6v-.87a.72.72 0 011.21-.52l6.15 5.5a.7.7 0 010 1.04l-6.15 5.5a.72.72 0 01-1.2-.53V3.6z"
      />
      <path
        fill="#FF5364"
        d="M0 11.33v5.86c.24-5.86 6.55-5.86 6.55-5.86h2.42c.38 0 .69.31.69.7v1.7a.72.72 0 001.2.52l1.55-1.4 4.6-4.1a.7.7 0 000-1.05l-4.6-4.1-1.55-1.4a.72.72 0 00-1.2.53v1.7c0 .39-.31.7-.7.7h-2.4S0 5.12 0 11.32z"
      />
    </g>
    <defs>
      <clipPath id="clip12"><path fill="#fff" d="M0 .02h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="options">
    <g clip-path="url(#clip13)">
      <path
        fill="#3B97D3"
        d="M7.5 2.3L8.2.45c.1-.26.35-.44.63-.44h2.36c.28 0 .53.18.63.44l.69 1.83 2.8 1.62 1.93-.32c.28-.04.56.09.7.33l1.18 2.04c.14.25.11.55-.07.77L17.8 8.24v3.24l1.24 1.5c.18.23.2.53.07.78l-1.18 2.04a.68.68 0 01-.7.33l-1.93-.32-2.8 1.62-.69 1.83a.68.68 0 01-.63.44H8.82a.68.68 0 01-.63-.44l-.69-1.83-2.8-1.62-1.93.32a.68.68 0 01-.7-.33L.89 13.76a.68.68 0 01.07-.77l1.24-1.51V8.24L.96 6.74a.68.68 0 01-.07-.78l1.18-2.04a.68.68 0 01.7-.33l1.93.32L7.5 2.3z"
      />
      <path fill="#2980BA" d="M10 15.62A5.76 5.76 0 1010 4.1a5.76 5.76 0 000 11.52z" />
      <path
        fill="#fff"
        d="M6.61 10.87a1.02 1.02 0 100-2.03 1.02 1.02 0 000 2.03zM10 10.87a1.02 1.02 0 100-2.03 1.02 1.02 0 000 2.03zM13.39 10.87a1.02 1.02 0 100-2.03 1.02 1.02 0 000 2.03z"
      />
      <path
        fill="#285680"
        d="M10 15.95a6.1 6.1 0 110-12.19 6.1 6.1 0 010 12.2zm0-11.5a5.42 5.42 0 100 10.83 5.42 5.42 0 000-10.84z"
      />
    </g>
    <defs>
      <clipPath id="clip13"><path fill="#fff" d="M0 .02h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="group">
    <g clip-path="url(#clip14)">
      <path
        fill="#F09372"
        d="M7.59 6v.71c.05.88.73 1.58 1.6 1.66l1.39.14c.84.1 1.49.8 1.49 1.66v1.62c0 .34-.28.62-.63.62H.62A.62.62 0 010 11.8v-1.62C0 9.32.64 8.6 1.5 8.5l1.14-.14c.85-.09 1.5-.8 1.5-1.66V6h3.45z"
      />
      <path
        fill="#FDD7AD"
        d="M5.86 0h.42c1.12.03 2 .95 2 2.07v.25c.2-.1.15-.12.34-.04.44.2.58.84.32 1.45-.2.48-.33.8-.7.82C8.03 5.73 7.1 6.9 5.85 6.9 4.63 6.9 3.7 5.73 3.5 4.55c-.37-.02-.5-.34-.7-.82-.27-.6-.12-1.26.31-1.45.2-.08.14-.06.35.04v-.25c0-1.12.88-2.04 2-2.07h.41z"
      />
      <path
        fill="#285680"
        d="M12.07 10.17v1.62c0 .34-.28.62-.63.62H.62A.62.62 0 010 11.8v-1.62C0 9.32.64 8.6 1.5 8.5l.88-.1c.58.73 1.92 1.25 3.48 1.25 1.58 0 2.93-.53 3.5-1.27l1.22.12c.84.1 1.49.8 1.49 1.66z"
      />
      <path
        fill="#F09372"
        d="M15.52 6v.71c.05.88.73 1.58 1.6 1.66l1.39.14c.85.1 1.49.8 1.49 1.66v1.62a.62.62 0 01-.62.62H8.56a.62.62 0 01-.63-.62v-1.62c0-.85.65-1.57 1.5-1.66l1.15-.14c.84-.09 1.49-.8 1.49-1.66V6h3.45z"
      />
      <path
        fill="#FDD7AD"
        d="M13.8 0h.41c1.12.03 2 .95 2 2.07v.25c.2-.1.15-.12.34-.04.44.2.58.84.32 1.45-.2.48-.33.8-.7.82-.2 1.18-1.14 2.35-2.38 2.35-1.23 0-2.17-1.17-2.37-2.35-.37-.02-.5-.34-.7-.82-.27-.6-.12-1.26.31-1.45.2-.08.15-.06.35.04v-.25c0-1.12.88-2.04 2-2.07h.41z"
      />
      <path
        fill="#CC4B4C"
        d="M20 10.17v1.62a.62.62 0 01-.62.62H8.56a.62.62 0 01-.63-.62v-1.62c0-.85.65-1.57 1.5-1.66l.88-.1c.58.73 1.92 1.25 3.48 1.25 1.58 0 2.93-.53 3.5-1.27l1.22.12c.85.1 1.49.8 1.49 1.66z"
      />
      <path
        fill="#F09372"
        d="M11.9 13.38v.1c0 .98.74 1.8 1.71 1.9l.89.16c.97.1 1.7.92 1.7 1.9v1.85a.71.71 0 01-.7.71h-11a.71.71 0 01-.7-.71v-1.85c0-.98.73-1.8 1.7-1.9l.89-.16a1.9 1.9 0 001.7-1.9v-.1h3.81z"
      />
      <path
        fill="#2C2F38"
        d="M16.2 17.44v1.85a.71.71 0 01-.7.71h-5.16v-1.72a.7.7 0 00.7-.7v-.34a.7.7 0 00-.68-.69l.35-.6.67 1.64 2.45-2.17.67.12c.97.1 1.7.92 1.7 1.9zM10.34 18.28V20H4.51a.71.71 0 01-.72-.71v-1.85c0-.98.74-1.8 1.71-1.9l.67-.12 2.45 2.17.67-1.63.35.6a.7.7 0 00-.67.68v.35c0 .38.3.68.69.69h.68z"
      />
      <path fill="#D1D4D1" d="M9.31 15.86l.69 1.38.69-1.38.69 1.73V20H8.62v-2.41l.69-1.73z" />
      <path
        fill="#E64C3C"
        d="M9.66 16.55h.68c.39 0 .7.31.7.7v.34c0 .38-.31.69-.7.69h-.68a.69.69 0 01-.7-.7v-.34c0-.38.31-.69.7-.69z"
      />
      <path fill="#C03A2B" d="M11.19 20l-.66-1.75H9.47L8.8 20h2.38z" />
      <path
        fill="#FDD7AD"
        d="M7.24 11.41a2.76 2.76 0 005.52 0c.57-.25.96-.78 1.03-1.4 0-.96-.58-1.04-1.03-.79v-.94c0-1.15-.93-2.07-2.07-2.07H9.31c-1.14 0-2.07.92-2.07 2.07v.94c-.46-.25-1.03-.16-1.03.78a1.8 1.8 0 001.03 1.41z"
      />
      <path
        fill="#AF8066"
        d="M12.76 8.28v.92a.92.92 0 00-.7-.23c-1.29 0-1.37-1.38-1.37-1.38S9.23 8.97 7.93 8.97a.92.92 0 00-.69.23v-.92c0-1.15.93-2.07 2.07-2.07h1.38c1.14 0 2.07.92 2.07 2.07z"
      />
      <path
        fill="#E6E7E8"
        d="M13.83 15.42l-2.45 2.17-.69-1.73 1.8-1c.3.3.7.48 1.12.52l.22.04zM9.31 15.86l-.69 1.73-2.45-2.17.22-.04c.42-.04.82-.23 1.13-.53l1.79 1.01z"
      />
    </g>
    <defs>
      <clipPath id="clip14"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="like-wb">
    <g clip-path="url(#clip15)">
      <path
        fill="#BDBDBD"
        d="M12.99 15.04a5.5 5.5 0 01.83-2.5c.46-.71 1.06-1.33 1.46-2.09.8-1.52 1.17-2.6 1.02-4.32A6.4 6.4 0 0010 .37a6.4 6.4 0 00-6.3 5.76c-.16 1.71.2 2.8 1.02 4.32.4.76 1 1.38 1.45 2.1.48.75.76 1.6.84 2.5h5.98zM12.67 17.04v1.67a1 1 0 01-1 1H8.33a.98.98 0 01-.77-.36 1 1 0 01-.23-.64v-1.67h5.34z"
      />
      <path
        fill="#828282"
        d="M9 15.37a.33.33 0 01-.33-.33V9.37h-1a1.33 1.33 0 110-2.66H8c.74 0 1.33.6 1.33 1.33v.67H10a.33.33 0 010 .66h-.67v5.67c0 .18-.15.33-.33.33zm-1.33-8a.67.67 0 100 1.34h1v-.67c0-.37-.3-.67-.67-.67h-.33z"
      />
      <path
        fill="#828282"
        d="M11 15.37a.33.33 0 01-.33-.33V9.37H10a.33.33 0 010-.66h.67v-.67c0-.74.6-1.33 1.33-1.33h.33a1.33 1.33 0 110 2.66h-1v5.67c0 .18-.15.33-.33.33zm.33-6.66h1a.67.67 0 100-1.34H12c-.37 0-.67.3-.67.67v.67z"
      />
      <path
        fill="#BDBDBD"
        d="M2 7.04H.33a.33.33 0 110-.67H2a.33.33 0 110 .67zM1.63 11.87a.33.33 0 01-.17-.62l1.45-.83a.33.33 0 01.33.58l-1.44.83a.33.33 0 01-.17.04zM18.37 11.87a.33.33 0 01-.17-.04L16.76 11a.33.33 0 11.33-.58l1.45.83a.33.33 0 01-.17.62zM19.67 7.04H18a.33.33 0 110-.67h1.67a.33.33 0 110 .67zM16.93 3.04a.33.33 0 01-.17-.62l1.44-.83a.33.33 0 11.34.57L17.09 3a.33.33 0 01-.16.04zM3.07 3.04A.33.33 0 012.9 3l-1.44-.84a.33.33 0 01.33-.57l1.45.83a.33.33 0 01-.17.62z"
      />
      <path fill="#828282" d="M7.33 15.04h5.34a1 1 0 110 2H7.33a1 1 0 110-2z" />
    </g>
    <defs>
      <clipPath id="clip15"><path fill="#fff" d="M0 .02h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="comment-wb">
    <path
      fill="#BDBDBD"
      d="M16.55 6.87v7.3c0 .93-.76 1.7-1.7 1.7H7.6l-3.45 3.79v-3.8H1.7a1.7 1.7 0 01-1.7-1.7V6.87c0-.94.76-1.7 1.7-1.7h13.15c.94 0 1.7.76 1.7 1.7z"
    />
    <path
      fill="#828282"
      d="M18.3.34H5.15c-.94 0-1.7.77-1.7 1.7v3.13h11.4c.94 0 1.7.76 1.7 1.7v4.16h1.75c.94 0 1.7-.76 1.7-1.7V2.04c0-.93-.76-1.7-1.7-1.7z"
    />
    <path
      fill="#fff"
      d="M3.8 11.72a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06zM8.28 11.72a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06zM12.76 11.72a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06z"
    />
  </g>
  <g id="share-wb">
    <g clip-path="url(#clip16)">
      <path
        fill="#828282"
        d="M12.41 3.57v-.86a.72.72 0 011.21-.53l6.15 5.5a.7.7 0 010 1.05l-6.15 5.5a.72.72 0 01-1.2-.53V3.57z"
      />
      <path
        fill="#BDBDBD"
        d="M0 11.3v5.87c.24-5.86 6.55-5.86 6.55-5.86h2.42c.38 0 .69.3.69.69v1.7a.72.72 0 001.2.53l1.55-1.4 4.6-4.1a.7.7 0 000-1.05l-4.6-4.1-1.55-1.4a.72.72 0 00-1.2.53v1.7c0 .38-.31.7-.7.7h-2.4S0 5.1 0 11.3z"
      />
    </g>
    <defs>
      <clipPath id="clip16"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="pin">
    <path
      fill="#D8D8D8"
      d="M10 10.34c-.48 0-.93-.06-1.35-.17l.66 9.14c.03.38.31.69.69.69.38 0 .65-.31.69-.69l.65-9.14c-.41.1-.86.17-1.34.17z"
    />
    <path fill="#47979D" d="M15.17 5.17a5.17 5.17 0 10-10.33-.01 5.17 5.17 0 0010.33.01z" />
    <path
      fill="#006064"
      d="M6.2 5.52c-.2 0-.34-.14-.34-.35A4.15 4.15 0 0110 1.04c.2 0 .34.13.34.34 0 .2-.13.34-.34.34a3.46 3.46 0 00-3.45 3.45c0 .21-.14.35-.34.35z"
    />
  </g>
  <g id="sub-link">
    <path fill="#2FA8CC" d="M13.7 6.35a6.2 6.2 0 11-12.4 0 6.2 6.2 0 0112.4 0z" />
    <path
      fill="#71C285"
      d="M9.83 10.5h-.2a2.2 2.2 0 00-2 1.28h-.25a2.2 2.2 0 00-2-1.29H3.61c.12-.1.24-.22.35-.35.2-.25.2-.5-.06-.7a3.04 3.04 0 01-.65-.47c-.44-.52-.52-1.19-.73-1.81-.1-.32-.18-.63-.47-.82-.14-.1-.3-.17-.45-.27a.65.65 0 01-.28-.41A6.2 6.2 0 015.06.64c.47.17.98.22 1.46.4.13.03.26.1.36.2.13.16.17.37.1.56a.85.85 0 01-.44.42c-.3.15-.6.32-.9.45-.26.07-.49.24-.64.47a.68.68 0 00.06.78c.18.15.4.22.63.2h.98c.6.01 1.2.08 1.79.21.18.04.35.13.48.27.09.13.11.3.06.46-.09.29-.35.38-.6.48-.38.16-.76.3-1.13.47-.33.17-.63.38-.9.63-.18.17-.4.31-.62.41-.27.06-.54.1-.81.1-.33.03-.83 0-1 .35a.8.8 0 00-.05.54c.13.4.44.7.84.81.2.08.4.13.6.2.25.07.48.18.72.29.22.12.5.11.71-.03.2-.14.35-.36.57-.47.28-.09.59-.07.85.06.41.1.8.3 1.11.57.23.3.41.65.54 1.01zM13.7 6.35c0 1.53-.55 3-1.58 4.14h-.85c-1.42-2.27.42-3.66 1.14-4.14.08-.05.17-.1.26-.13.33-.1.69-.13 1.03-.07v.2z"
    />
    <path
      fill="#67B9CC"
      d="M11.18 2.97a.26.26 0 01-.19-.07c-.2-.2-.41-.39-.65-.55a.26.26 0 01.3-.42c.26.18.5.38.72.6a.26.26 0 01-.18.44zM12.53 5.41a.26.26 0 01-.25-.2 4.78 4.78 0 00-.73-1.62.26.26 0 01.43-.3c.38.55.65 1.16.8 1.8a.26.26 0 01-.25.32z"
    />
    <path
      fill="#41767F"
      d="M7.38 13.6a2.23 2.23 0 01-2 1.29H2.2a2.2 2.2 0 110-4.4h3.17c.87 0 1.65.5 2 1.3l-2.44.25H2.2a.65.65 0 000 1.3h2.73l2.45.25z"
    />
    <path
      fill="#71C285"
      d="M9.3 2.72a.45.45 0 01-.22.42c-.33.17-.73-.17-.95-.38a.6.6 0 01-.18-.23.48.48 0 01.04-.38.85.85 0 01.15-.21.5.5 0 01.54-.15c.09.06.17.13.22.22l.21.3c.1.12.17.26.2.41z"
    />
    <path
      fill="#325C60"
      d="M5.43 10.5H2.07C.93 10.5 0 11.41 0 12.55v.26c0 1.14.93 2.07 2.07 2.07h3.36c1.14 0 2.07-.93 2.07-2.07v-.26c0-1.14-.93-2.07-2.07-2.07zm-.13 2.84H2.2a.65.65 0 110-1.3h3.1a.65.65 0 010 1.3z"
    />
    <path
      fill="#41767F"
      d="M5.43 11H2.07c-.86 0-1.55.7-1.55 1.56v.26c0 .86.7 1.55 1.55 1.55h3.36c.86 0 1.55-.7 1.55-1.55v-.26c0-.86-.7-1.55-1.55-1.55zm-.13 2.34H2.2a.65.65 0 010-1.3h3.1a.65.65 0 110 1.3z"
    />
    <path
      fill="#325C60"
      d="M12.93 10.5H9.57c-1.14 0-2.07.92-2.07 2.06v.26c0 1.14.93 2.07 2.07 2.07h3.36c1.14 0 2.07-.93 2.07-2.07v-.26c0-1.14-.93-2.07-2.07-2.07zm-.13 2.84H9.7a.65.65 0 110-1.3h3.1a.65.65 0 110 1.3z"
    />
    <path
      fill="#41767F"
      d="M12.93 11H9.57c-.86 0-1.55.7-1.55 1.56v.26c0 .86.7 1.55 1.55 1.55h3.36c.86 0 1.55-.7 1.55-1.55v-.26c0-.86-.7-1.55-1.55-1.55zm-.13 2.34H9.7a.65.65 0 010-1.3h3.1a.65.65 0 110 1.3z"
    />
    <path
      fill="#31595F"
      d="M5.3 11.78H2.2c-.5 0-.9.41-.9.91s.4.9.9.9h3.1a.91.91 0 00.64-1.54.9.9 0 00-.64-.27zm0 1.56H2.2a.65.65 0 110-1.3h3.1a.65.65 0 110 1.3z"
    />
    <path
      fill="#2C3E50"
      d="M10.34 12.69a.9.9 0 01-.9.9H5.56a.9.9 0 01-.64-1.54.9.9 0 01.64-.27h3.88c.5 0 .9.41.9.91z"
    />
    <path
      fill="#35495E"
      d="M9.57 12.69c0 .23-.06.45-.2.64a.58.58 0 01-.46.26H6.1a.58.58 0 01-.46-.25c-.13-.2-.2-.42-.2-.65 0-.23.06-.45.2-.64.1-.16.27-.26.46-.27H8.9c.19.01.36.1.46.26.13.2.2.42.2.65z"
    />
  </g>
  <g id="sub-edit-post">
    <g clip-path="url(#clip17)">
      <path
        fill="#F3D55B"
        d="M11.38 2.07H1.55C.7 2.07 0 2.77 0 3.62v9.83C0 14.3.7 15 1.55 15h9.83c.86 0 1.55-.7 1.55-1.55V3.62c0-.86-.7-1.55-1.55-1.55z"
      />
      <path
        fill="#802F34"
        d="M11.04 3.23L5.75 8.52l-.01.01A.52.52 0 105 7.8l5.3-5.3.74.73zM7.2 10a.52.52 0 00-.73-.74l5.3-5.3.73.73L7.2 10z"
      />
      <path fill="#FF5364" d="M14.7 2.5l-1.28 1.28-2.2-2.2L12.5.3c.4-.4 1.06-.4 1.47 0l.73.73c.4.4.4 1.06 0 1.47z" />
      <path fill="#FDD7AD" d="M12.32 1.58l-.55.55a.26.26 0 10.37.37l.55-.55a.26.26 0 10-.37-.37z" />
      <path fill="#2C3E50" d="M5.21 10.83l-1.2.5a.26.26 0 01-.34-.34l.5-1.2c.5.15.89.54 1.04 1.04z" />
      <path fill="#F29C1F" d="M6.47 9.26a.52.52 0 00-.72-.74l5.29-5.29.73.73-5.3 5.3z" />
      <path
        fill="#F9EAB0"
        d="M7.2 10l-1.99.83c-.15-.5-.54-.89-1.04-1.04L5 7.8a.52.52 0 01.74.73l.01-.01a.52.52 0 01.72.74.52.52 0 01.73.74zM1.55 3.36H1.3a.26.26 0 110-.52h.26a.26.26 0 010 .52zM6.47 3.36H2.59a.26.26 0 110-.52h3.88a.26.26 0 010 .52zM11.9 13.97a.26.26 0 01-.26-.26v-.52a.26.26 0 11.52 0v.52c0 .14-.12.26-.26.26z"
      />
      <path
        fill="#35495E"
        d="M2.59 11.64h-1.3a.26.26 0 110-.52h1.3a.26.26 0 010 .52zM10.6 11.64H6.47a.26.26 0 110-.52h4.13a.26.26 0 010 .52zM7.24 12.93H1.3a.26.26 0 010-.52h5.95a.26.26 0 010 .52zM10.6 12.93H8.8a.26.26 0 010-.52h1.8a.26.26 0 010 .52z"
      />
      <path fill="#BDC3C7" d="M13.42 3.78l-.92.91-2.2-2.2.92-.9 2.2 2.19z" />
    </g>
    <defs>
      <clipPath id="clip17"><path fill="#fff" d="M0 0h15v15H0z" /></clipPath>
    </defs>
  </g>
  <g id="sub-complain">
    <g clip-path="url(#clip18)">
      <path
        fill="#F29C1F"
        d="M13.19 4.63V2.84c0-.57-.46-1.03-1.03-1.03H9.94L8.16.26a1.04 1.04 0 00-1.32 0L5.06 1.8H2.84c-.57 0-1.03.46-1.03 1.03v1.8L0 6.2v7.76C0 14.54.46 15 1.03 15h12.94c.57 0 1.03-.46 1.03-1.03V6.2l-1.81-1.58z"
      />
      <path fill="#F0C419" d="M15 6.2v7.77c0 .57-.46 1.03-1.03 1.03h-.22l-4.69-3.88L13.2 7.7 15 6.2z" />
      <path fill="#F3D55B" d="M13.75 15H1.25l4.69-3.88.9-.75c.38-.31.94-.31 1.32 0l.9.75 4.7 3.88z" />
      <path fill="#F0C419" d="M5.94 11.12L1.24 15h-.2C.45 15 0 14.54 0 13.97V6.2l1.81 1.5 4.13 3.41z" />
      <path
        fill="#F5EFCA"
        d="M13.19 2.84V7.7l-4.13 3.42-.9-.75a1.04 1.04 0 00-1.32 0l-.9.75L1.8 7.7V2.84c0-.57.46-1.03 1.03-1.03h9.32c.57 0 1.03.46 1.03 1.03z"
      />
      <path
        fill="#E64C3C"
        d="M10.4 3.43a.93.93 0 00-1.38-.05L7.5 4.97 5.98 3.39a.93.93 0 00-1.37.04.87.87 0 00.12 1.24l1.73 1.38L4.9 7.67a.5.5 0 00.02.7c.2.18.48.19.68.03l1.9-1.52L9.4 8.4c.2.16.49.15.68-.02a.5.5 0 00.02-.71L8.54 6.05l1.73-1.38a.86.86 0 00.12-1.24z"
      />
    </g>
    <defs>
      <clipPath id="clip18"><path fill="#fff" d="M0 0h15v15H0z" /></clipPath>
    </defs>
  </g>
  <g id="sub-delete">
    <path
      fill="#C2C2C2"
      d="M3 2.5v12c0 .5.5.5.56.5h7.88c.3 0 .56-.22.56-.5v-12c0-.28-.25-.5-.56-.5H3.56c-.3 0-.56.22-.56.5z"
    />
    <path fill="#35495E" d="M5 2V.57c0-.31.28-.57.62-.57h3.75c.35 0 .63.26.63.57V2H5z" />
    <path
      fill="#7F8C8D"
      d="M8.1 5.52c0-.29-.27-.52-.6-.52-.33 0-.6.23-.6.52v7.24c0 .28.27.52.6.52.33 0 .6-.24.6-.52V5.52zM5.19 5.52c0-.29-.27-.52-.6-.52-.32 0-.59.23-.59.52v7.24c0 .28.27.52.6.52.32 0 .59-.24.59-.52V5.52zM11 5.52c0-.29-.27-.52-.6-.52-.32 0-.59.23-.59.52v7.24c0 .28.27.52.6.52.32 0 .59-.24.59-.52V5.52z"
    />
    <path fill="#547580" d="M12 2.5V4H3V2.5c0-.28.25-.5.56-.5h7.88c.3 0 .56.22.56.5z" />
  </g>
  <g id="sub-edit-profile">
    <g clip-path="url(#clip19)">
      <path fill="#F9C795" d="M13.14 1.15l.7 1.95-1.3.26-1.29-.26.7-1.95h1.19z" />
      <path fill="#464F5D" d="M13.14 1.15c-.38.2-.82.2-1.19 0l.35-.98a.26.26 0 01.49 0l.35.98z" />
      <path fill="#F3D55B" d="M12.54 3.1h-1.29v8.54h2.59V3.1h-1.3z" />
      <path
        fill="#FF5364"
        d="M8.15 0h1.03c.43 0 .78.35.78.78v12.41c0 .43-.35.78-.78.78H1.94a.78.78 0 01-.78-.78V.78c0-.43.35-.78.78-.78h6.2z"
      />
      <path
        fill="#FB7B76"
        d="M9.96.78v.25s-8.48 0-8.79 12a.7.7 0 010-.1V.78c0-.43.34-.78.77-.78h1.03l.74.79c.15.16.36.24.57.24h2.56c.22 0 .42-.08.57-.24L8.15 0h1.03c.43 0 .78.35.78.78z"
      />
      <path
        fill="#464F5D"
        d="M9.96 12.93v1.3c0 .42-.35.77-.78.77H1.94a.78.78 0 01-.78-.78v-1.29c0 .43.35.78.78.78h7.24c.43 0 .78-.35.78-.78zM8.15 0L7.4.79a.77.77 0 01-.57.24H4.28A.77.77 0 013.71.8L2.97 0h5.18z"
      />
      <path
        fill="#F0C419"
        d="M7.89 8.52a3.1 3.1 0 01-4.66 0c.01-1.02.68-1.91 1.65-2.21.43.2.93.2 1.36 0 .97.3 1.64 1.2 1.65 2.2z"
      />
      <path
        fill="#285680"
        d="M4.88 6.3c-.97.3-1.64 1.2-1.65 2.22a3.1 3.1 0 012.33-5.16 1.55 1.55 0 00-.68 2.95zM8.66 6.47c0 .75-.27 1.48-.77 2.05C7.88 7.5 7.2 6.6 6.24 6.3a1.55 1.55 0 00-.68-2.95 3.1 3.1 0 013.1 3.1z"
      />
      <path fill="#FDD7AD" d="M7.11 4.91c0 .6-.34 1.14-.87 1.4a1.55 1.55 0 11.87-1.4z" />
      <path
        fill="#fff"
        d="M4.53 10.86H2.97a.52.52 0 00-.51.52v.52c0 .28.23.51.51.51h1.56c.28 0 .51-.23.51-.51v-.52a.52.52 0 00-.51-.52zM8.15 10.86H6.59a.52.52 0 00-.51.52v.52c0 .28.23.51.51.51h1.56c.28 0 .51-.23.51-.51v-.52a.52.52 0 00-.51-.52z"
      />
      <path fill="#BDC3C7" d="M11.25 11.38h2.59v1.3h-2.59v-1.3z" />
      <path fill="#F0C419" d="M12.54 3.1h1.3v8.28h-1.3V3.1z" />
      <path fill="#FF5364" d="M13.84 12.41v1.56c0 .57-.47 1.03-1.04 1.03h-.52c-.57 0-1.03-.46-1.03-1.03V12.4h2.59z" />
      <path fill="#FB7B76" d="M12.28 14.22a.26.26 0 100-.51.26.26 0 000 .51z" />
    </g>
    <defs>
      <clipPath id="clip19"><path fill="#fff" d="M0 0h15v15H0z" /></clipPath>
    </defs>
  </g>
  <g id="sub-network">
    <path fill="#4482C3" d="M7.5 13.966a6.466 6.466 0 100-12.932 6.466 6.466 0 000 12.931z" />
    <path
      fill="#4FBA6F"
      d="M5.635 3.334c-.287.478-.049 1.052.148 1.562a.747.747 0 01.064.538.883.883 0 01-.325.351c-.378.293-.757.582-1.136.87-.28.187-.519.432-.698.718-.3.577.008 1.257-.122 1.88-.075.352-.936 1.384-1.373 1.938a6.462 6.462 0 013.528-9.906l.002.008c.497.358.629 1.04.3 1.557a5.676 5.676 0 00-.388.484zM13.966 7.5c0 .469-.05.936-.153 1.394h-.003a.872.872 0 01-.78-.202c-.34-.279-.619-.693-1.118-.628a.976.976 0 00-.678.468c-.421.68-.204 1.546-.558 2.232a2.99 2.99 0 01-.802.871c-.002.003-.008.006-.01.01a.593.593 0 01-.957-.545 2.424 2.424 0 00-.445-1.725c-.29-.39-.721-.747-.719-1.23.008-.655.8-1.05 1.32-1.276.283-.117.524-.318.69-.577.465-.778-.256-1.386-.621-2.04a2.332 2.332 0 01.528-2.845A6.46 6.46 0 0113.966 7.5zM9.66 1.407l.002-.003.016-.01M8.048 13.94a6.442 6.442 0 01-4.596-1.396l1.027-.756a.765.765 0 01.51-.147c.388.044.651.44 1.024.553.292.09.602-.003.905.01a.45.45 0 01.176.042.46.46 0 01.145.13c.362.465.44 1.109.81 1.564z"
    />
    <path fill="#CC4B4C" d="M12.672 5.431a2.328 2.328 0 100-4.655 2.328 2.328 0 000 4.655z" />
    <path
      fill="#E6E7E8"
      d="M13.966 4.355c.001.301-.097.594-.28.834a2.243 2.243 0 01-2.027 0 1.375 1.375 0 01.532-2.085h.003c.276.233.68.233.957 0h.002c.497.217.816.709.813 1.25z"
    />
    <path
      fill="#fff"
      d="M13.448 2.586a.763.763 0 01-.295.608h-.002a.765.765 0 01-.957 0h-.003a.776.776 0 111.257-.608z"
    />
    <path fill="#E4C05C" d="M2.328 4.655a2.328 2.328 0 100-4.655 2.328 2.328 0 000 4.655z" />
    <path
      fill="#E6E7E8"
      d="M3.62 3.579c.002.301-.096.594-.279.834a2.243 2.243 0 01-2.027 0 1.375 1.375 0 01.533-2.085h.002c.276.233.68.233.957 0h.003c.496.217.816.709.812 1.25z"
    />
    <path
      fill="#fff"
      d="M3.103 1.81a.762.762 0 01-.294.608h-.003a.765.765 0 01-.957 0h-.002a.776.776 0 111.257-.608z"
    />
    <path fill="#CC66A1" d="M2.328 15a2.328 2.328 0 100-4.655 2.328 2.328 0 000 4.655z" />
    <path
      fill="#E6E7E8"
      d="M3.62 13.924c.002.3-.096.594-.279.834a2.243 2.243 0 01-2.027 0 1.375 1.375 0 01.533-2.086h.002c.276.234.68.234.957 0h.003c.496.218.816.71.812 1.252z"
    />
    <path
      fill="#fff"
      d="M3.103 12.155a.762.762 0 01-.294.608h-.003a.765.765 0 01-.957 0h-.002a.776.776 0 111.257-.608z"
    />
  </g>
  <g id="sub-events">
    <path fill="#E6E7E8" d="M14.5 4.66v9.3c0 .58-.47 1.04-1.04 1.04H1.56C1 15 .53 14.54.53 13.97V4.66h13.96z" />
    <path fill="#C03A2B" d="M.53 4.66v-2.6c0-.56.46-1.03 1.03-1.03h11.9c.57 0 1.03.47 1.03 1.04v2.59H.53z" />
    <path
      fill="#2C2F38"
      d="M3.89 1.7a1.03 1.03 0 11-1.04 0M8.03 1.7a1.03 1.03 0 11-1.04 0M12.17 1.7a1.03 1.03 0 11-1.04 0"
    />
    <path
      fill="#A5A5A4"
      d="M1.82 5.95h-.26a.26.26 0 010-.52h.26a.26.26 0 010 .52zM3.11 5.95h-.26a.26.26 0 010-.52h.26a.26.26 0 010 .52zM4.4 5.95h-.25a.26.26 0 010-.52h.26a.26.26 0 010 .52zM5.7 5.95h-.26a.26.26 0 010-.52h.26a.26.26 0 010 .52zM7 5.95h-.27a.26.26 0 010-.52H7a.26.26 0 010 .52zM8.29 5.95h-.26a.26.26 0 010-.52h.26a.26.26 0 010 .52zM9.58 5.95h-.26a.26.26 0 010-.52h.26a.26.26 0 010 .52zM10.87 5.95h-.26a.26.26 0 110-.52h.26a.26.26 0 110 .52zM12.17 5.95h-.26a.26.26 0 010-.52h.26a.26.26 0 010 .52zM13.46 5.95h-.26a.26.26 0 010-.52h.26a.26.26 0 010 .52zM9.58 13.7H4.15a.26.26 0 010-.51h5.43a.26.26 0 010 .52zM11.13 13.7h-.52a.26.26 0 110-.51h.52a.26.26 0 010 .52z"
    />
    <path
      fill="#5E5F62"
      d="M3.37 0c.29 0 .52.23.52.52v1.55a.52.52 0 11-1.04 0V.52c0-.29.24-.52.52-.52zM7.51 0c.29 0 .52.23.52.52v1.55a.52.52 0 01-1.04 0V.52c0-.29.23-.52.52-.52zM11.65 0c.28 0 .52.23.52.52v1.55a.52.52 0 01-1.04 0V.52c0-.29.23-.52.52-.52z"
    />
    <path
      fill="#24AE5F"
      d="M5.28 10.67l1.03 1.02 3.87-4.77a.54.54 0 01.9.1c.08.18.07.39-.05.55l-4.1 5.66a.52.52 0 01-.8.05l-1.65-1.83a.53.53 0 01-.08-.6l.02-.04a.54.54 0 01.86-.14z"
    />
  </g>
  <g id="sub-gallery">
    <path fill="#547580" d="M1.6 3.2v-.7c0-.9.6-1.6 1.5-1.6h10.3c1 0 1.6.7 1.6 1.6v7.7c0 .9-.7 1.6-1.6 1.6L1.6 3.2z" />
    <path
      fill="#ECF0F1"
      d="M11.9 3.2H1.6C.6 3.2 0 4 0 4.8v7.7c0 .9.7 1.6 1.6 1.6h10.3c.9 0 1.5-.7 1.5-1.6V4.8c0-.9-.6-1.6-1.5-1.6z"
    />
    <path fill="#84B5CB" d="M11.9 13c.3 0 .5-.2.5-.5V4.8c0-.3-.2-.5-.5-.5H1.6c-.3 0-.6.2-.6.5v7.7c0 .3.3.6.6.6h10.3z" />
    <path fill="#F0C419" d="M8 7.1a.8.8 0 100-1.5A.8.8 0 008 7z" />
    <path fill="#5D4C72" d="M12.4 7.9v4.6c0 .3-.2.6-.5.6H9.3A8.8 8.8 0 007 9.7a9.8 9.8 0 015.4-1.8z" />
    <path fill="#955BA5" d="M9.3 13H1.6a.5.5 0 01-.6-.5V7.4c.9 0 3.7.2 6 2.3 1 1 1.8 2 2.3 3.4z" />
  </g>
  <g id="sub-invite">
    <path
      fill="#8697CB"
      d="M13.62 11.26l-2.43-1.22a.93.93 0 01-.51-.82v-.96a5.58 5.58 0 00.98-1.82c.31-.09.54-.38.54-.72V4.7c0-.22-.1-.42-.25-.56V2.67s.3-2.29-2.8-2.29c-3.1 0-2.8 2.29-2.8 2.29v1.47a.76.76 0 00-.25.56v1.02c0 .27.14.5.35.64.26 1.1.92 1.9.92 1.9v.93c0 .34-.18.65-.48.82l-2.27 1.23a2.04 2.04 0 00-1.06 1.8v.82h11.19v-.78c0-.77-.44-1.48-1.13-1.82z"
    />
    <path
      fill="#556080"
      d="M4.62 11.24l1.51-.82.02-.01.74-.4c.3-.17.48-.48.48-.82v-.93s-.27-.32-.53-.84a5.16 5.16 0 01-.1-.22l-.01-.03a4.71 4.71 0 01-.1-.24v-.01a4.77 4.77 0 01-.09-.23c0-.02 0-.05-.02-.07a4.26 4.26 0 01-.07-.26.76.76 0 01-.35-.64V4.7c0-.22.1-.42.26-.56V2.7a2.8 2.8 0 00-1.78-.54c-2.44 0-2.55 2.03-2.55 2.03v1.27c-.13.13-.25.3-.25.5v.87c0 .23.12.43.3.55.22.96.96 1.65.96 1.65v.8a.8.8 0 01-.42.7L.92 11.6c-.57.3-.92.9-.92 1.54v.72h3.56v-.83c0-.74.4-1.43 1.06-1.79z"
    />
    <path fill="#71C386" d="M11.95 14.62a3.05 3.05 0 100-6.1 3.05 3.05 0 000 6.1z" />
    <path
      fill="#fff"
      d="M13.47 11.31H12.2v-1.27a.25.25 0 00-.5 0v1.27h-1.28a.25.25 0 000 .51h1.27v1.27a.25.25 0 00.51 0v-1.27h1.27a.25.25 0 000-.5z"
    />
  </g>
  <g id="friends">
    <g clip-path="url(#clip20)">
      <path
        fill="#2980BA"
        d="M7 11.9h1.1c1.3 0 2.4 1 2.4 2.4v2.8c0 .2-.1.3-.3.3H.5a.3.3 0 01-.3-.3v-2.8c0-1.3 1-2.4 2.4-2.4H7z"
      />
      <path fill="#285680" d="M2.2 15v2.4h-.6V15a.3.3 0 11.6 0zM9.1 15v2.4h-.7V15a.3.3 0 11.7 0z" />
      <path fill="#3B97D3" d="M6.5 9.6c-.2.6-.4 1.6.6 2.3a1.7 1.7 0 01-3.5 0c1-.7.8-1.7.6-2.3h2.3z" />
      <path
        fill="#84B5CB"
        d="M9.8 6.4a1 1 0 01-1.2 1c-.3 1-1 1.8-2 2.2-.8.3-1.7.3-2.4 0-1-.4-1.8-1.2-2.1-2.2h-.2a1 1 0 110-2V3.8C.6 2.8.9.2.9.2c1 2 5.5.3 7.2 1.4 1.7 1 .7 3.7.7 3.7.6 0 1 .5 1 1z"
      />
      <path
        fill="#894B9D"
        d="M16.6 14.5h1a2.4 2.4 0 012.4 2.4v2.8l-.3.3H10a.3.3 0 01-.3-.3v-2.8c0-1.3 1-2.4 2.4-2.4h4.5z"
      />
      <path fill="#3D324C" d="M11.7 17.6V20H11v-2.4a.3.3 0 11.7 0zM18.6 17.6V20H18v-2.4a.3.3 0 01.7 0z" />
      <path fill="#955BA5" d="M16 12.2c-.2.6-.4 1.6.6 2.3a1.7 1.7 0 11-3.5 0c1-.7.8-1.7.6-2.3H16z" />
      <path
        fill="#B49ACA"
        d="M19.3 9a1 1 0 01-1.2 1c-.3 1-1.1 1.8-2.1 2.2-.8.3-1.6.3-2.3 0-1-.4-1.8-1.2-2.1-2.2h-.2a1 1 0 110-2V6.4c-1.3-1.1-1-3.7-1-3.7 1 2 5.5.3 7.2 1.3 1.7 1 .7 3.8.7 3.8.5 0 1 .5 1 1z"
      />
      <path fill="#00AB8D" d="M16.6 6.9a3.4 3.4 0 100-6.9 3.4 3.4 0 000 6.9z" />
      <path fill="#fff" d="M16 1.5a.5.5 0 011 0v4a.5.5 0 01-1 0v-4z" />
      <path fill="#fff" d="M18.5 3a.5.5 0 010 1h-4a.5.5 0 010-1h4z" />
    </g>
    <defs>
      <clipPath id="clip20"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="message">
    <path
      fill="#F29C1F"
      d="M17.03 5.98a3.42 3.42 0 00-2.4-.98H3.43A3.42 3.42 0 000 8.42v8.1a3.42 3.42 0 003.42 3.42c6.45 0 10.81.19 11.96-.1a3.5 3.5 0 002.67-3.32v-8.1c0-.91-.37-1.8-1.02-2.44z"
    />
    <path fill="#F0C419" d="M18.05 8.42v8.1c0 .91-.38 1.79-1.04 2.42l-6.71-6.47 6.73-6.49a3.42 3.42 0 011.02 2.44z" />
    <path
      fill="#F3D55B"
      d="M17.03 5.98l-6.73 6.49-.2.19c-.6.58-1.55.58-2.15 0l-.2-.19-5.83-5.62-.9-.87c.64-.63 1.5-.98 2.4-.98h11.2c.9 0 1.77.35 2.41.98z"
    />
    <path
      fill="#F0C419"
      d="M7.75 12.47l-6.73 6.49A3.41 3.41 0 010 16.52v-8.1c0-.91.37-1.8 1.02-2.44l.9.87 5.83 5.62z"
    />
    <path
      fill="#fff"
      d="M8.71 6.56H4.36a.31.31 0 110-.63H8.7a.31.31 0 010 .63zM3.11 6.56a.31.31 0 100-.63.31.31 0 000 .63z"
    />
    <path fill="#D25627" d="M15.88 3.96l-6.2 6.2-.12.04a.33.33 0 01-.06-.17.7.7 0 00-1.18-.46l6.58-6.58.74.73.24.24z" />
    <path
      fill="#fff"
      d="M18.56 1.28a.34.34 0 10-.49.49.34.34 0 00.5-.5zM17.1 2.25l-.49.5a.34.34 0 10.49.48l.49-.49a.34.34 0 10-.5-.49z"
    />
    <path fill="#35495E" d="M8.75 12.22l-1.25.58a.34.34 0 01-.46-.46l.58-1.25a1.76 1.76 0 011.13 1.13z" />
    <path
      fill="#F9EAB0"
      d="M10.27 11.52l-1.52.7a1.76 1.76 0 00-1.13-1.13l.7-1.52a.7.7 0 011.18.46c0 .06.02.12.06.17.05.09.15.14.25.14a.68.68 0 01.66.7c0 .17-.07.35-.2.48z"
    />
    <path fill="#95A5A5" d="M17.83 3.96l-.98.98-.24-.25-.73-.73-.24-.24-.74-.73.98-.98 1.95 1.95z" />
    <path
      fill="#802D40"
      d="M10.27 11.52a.69.69 0 00-.46-1.18c-.1 0-.2-.05-.25-.14l.12-.04 6.2-6.2.73.73.24.25-6.58 6.58z"
    />
    <path
      fill="#FF5364"
      d="M19.54 2.25l-1.71 1.71-1.95-1.95 1.7-1.7C18-.1 18.64-.1 19.05.3l.49.48c.4.4.4 1.06 0 1.46z"
    />
  </g>
  <g id="join-group">
    <path
      fill="#00AB8D"
      d="M10.83 4.86a2.37 2.37 0 10-2.04 0h2.04zM7.1 5.61a.34.34 0 01-.25-.1A4.06 4.06 0 016.68.12a.34.34 0 11.52.43 3.38 3.38 0 00.15 4.48.34.34 0 01-.25.57zM13.13 4.75a.34.34 0 01-.3-.5c.61-1.2.46-2.65-.4-3.69a.34.34 0 11.52-.43 4.05 4.05 0 01.48 4.44.34.34 0 01-.3.18z"
    />
    <path
      fill="#FDD7AD"
      d="M16.93 9.55v5.37s0 1.82-1.16 2.88c-.13.13-.2.3-.2.48v1.04c0 .38-.3.68-.68.68H9.47a.68.68 0 01-.68-.68v-.12c0-.55-.21-1.07-.6-1.45a9.38 9.38 0 01-2.1-2.83c-.68-1.7-2.04-4.07-2.72-4.75-.68-.68 0-1.35.68-1.35s2.03 1.35 2.71 2.37c.22.33.47.63.75.9a.67.67 0 001.1-.29c.13-.42.2-.85.18-1.29v-7.8a1 1 0 01.68-.95 1.02 1.02 0 011.36.96v4.06a1 1 0 01.68-.95 1.02 1.02 0 011.36.96V7.8a1.01 1.01 0 012.02 0v1.7A1.01 1.01 0 0116 8.47c.54.06.95.52.94 1.07z"
    />
    <path
      fill="#CBB292"
      d="M9.81 1.7a.94.94 0 00-.34.06 1 1 0 00-.68.96v7.8c.01.43-.05.86-.18 1.28a.69.69 0 01-.3.38.67.67 0 00.98-.38c.13-.42.2-.85.18-1.29v-7.8a1 1 0 01.68-.95.94.94 0 00-.34-.06zM11.5 5.83a1 1 0 00-.67.95v3.05a.34.34 0 10.68 0V6.78a1 1 0 01.67-.95.97.97 0 00-.67 0zM13.54 6.84a1.01 1.01 0 00-.68.96v2.03a.34.34 0 00.68 0V7.8a1 1 0 01.68-.96.97.97 0 00-.68 0zM15.91 8.48a.94.94 0 00-.34.06 1.01 1.01 0 00-.68.96v.67a.34.34 0 10.68 0V9.5a1 1 0 01.68-.95.94.94 0 00-.34-.06z"
    />
  </g>
  <g id="like-group">
    <path
      fill="#EF5350"
      d="M20 2.07v11.72c0 1.15-.93 2.07-2.07 2.07h-4.48c-.22 0-.42.1-.55.28l-2.62 3.5a.35.35 0 01-.56 0l-2.62-3.5a.69.69 0 00-.55-.28H2.07A2.07 2.07 0 010 13.8V2.07C0 .93.93 0 2.07 0h15.86C19.07 0 20 .93 20 2.07z"
    />
    <path
      fill="#fff"
      d="M10 5.4s.74-1.6 2.41-1.6c1.43 0 2.42 1.28 2.42 2.8 0 2.1-1.97 3.5-4.83 6.16C7.14 10.1 5.17 8.7 5.17 6.6c0-1.52.99-2.8 2.42-2.8C9.26 3.8 10 5.4 10 5.4zM1.38 3.8a.34.34 0 01-.35-.35V2.4a.34.34 0 01.7 0v1.04c0 .19-.16.34-.35.34zM1.38 14.14a.34.34 0 01-.35-.35V4.83a.34.34 0 11.7 0v8.96c0 .2-.16.35-.35.35z"
    />
  </g>
  <g id="pencil">
    <path fill="#FDD7AD" d="M19.31 2.41c0 .26-.6.52-.48.74l-1.93.64-.7-1.38.7-1.38 1.93.65c-.11.22.48.47.48.73z" />
    <path fill="#BDC3C7" d="M5.17 1.03h-3.8V3.8h3.8V1.03z" />
    <path fill="#D75E72" d="M2.76 1.03V3.8H.69A.7.7 0 010 3.1V1.72c0-.38.3-.68.69-.69h2.07z" />
    <path fill="#F0C419" d="M16.9 1.03H4.14V3.8H16.9V1.03z" />
    <path
      fill="#2C2F38"
      d="M20 2.41c0 .21-.13.4-.33.46l-.84.28a1.6 1.6 0 01-.2-.74c0-.25.08-.5.2-.73l.84.28c.2.06.33.25.33.45z"
    />
    <path fill="#FDD7AD" d="M8.62 2.76l-2.07.02.25-.02h1.82z" />
    <path
      fill="#FDD7AD"
      d="M14.83 1.38V6.2c0 .11 0 .22-.02.34a4.78 4.78 0 01-.97 2.5l-1.3 1.75c-.08.15-.13.32-.13.5v3.53c0 .19-.15.34-.34.34H7.24a.34.34 0 01-.34-.34v-4.37c0-.16-.04-.32-.11-.46l-2.1-3.38a1.03 1.03 0 01-.03-.84l.85-2.16c.1-.25.28-.47.51-.62.16-.11.34-.19.53-.22l2.07-.02H6.8c-.09 0-.17 0-.25.02v-1.4a1.03 1.03 0 012.07 0 1.03 1.03 0 112.07 0 1.03 1.03 0 112.07 0 1.03 1.03 0 012.07 0z"
    />
    <path fill="#FDD7AD" d="M8.62 2.76l-2.07.02.25-.02h1.82z" />
    <path
      fill="#CBB292"
      d="M13.8 5.17c-.77 0-1.39-.62-1.39-1.38V1.38a1.38 1.38 0 012.76 0v2.41c0 .76-.62 1.38-1.38 1.38zm0-4.48c-.39 0-.7.3-.7.69v2.41a.69.69 0 101.38 0V1.38c0-.38-.3-.69-.69-.69z"
    />
    <path
      fill="#CBB292"
      d="M11.72 5.17c-.76 0-1.38-.62-1.38-1.38V1.38a1.38 1.38 0 012.76 0v2.41c0 .76-.61 1.38-1.38 1.38zm0-4.48c-.38 0-.69.3-.69.69v2.41a.69.69 0 001.38 0V1.38c0-.38-.3-.69-.69-.69z"
    />
    <path
      fill="#CBB292"
      d="M10.69 4.14a.34.34 0 01-.35-.35V1.38a.69.69 0 10-1.37 0v1.38a.34.34 0 11-.7 0V1.38a1.38 1.38 0 012.76 0v2.41c0 .2-.15.35-.34.35z"
    />
    <path
      fill="#CBB292"
      d="M6.55 3.13a.34.34 0 01-.34-.35v-1.4a1.38 1.38 0 012.76 0v1.38a.34.34 0 11-.7 0V1.38a.69.69 0 00-1.37 0v1.4c0 .2-.16.35-.35.35z"
    />
    <path
      fill="#CBB292"
      d="M12.07 15.52H7.24a.69.69 0 01-.69-.7v-4.36a.7.7 0 00-.07-.3L4.4 6.8a1.4 1.4 0 01-.06-1.15l.85-2.15c.26-.66.9-1.09 1.6-1.09H10A1.04 1.04 0 0111 3.61a2.14 2.14 0 01-2.1 1.9c.83.59 1.79 1.6 1.79 3.11a.34.34 0 11-.69 0c0-2.14-2.51-3.12-2.54-3.13a.34.34 0 01.13-.66h1.03c.98 0 1.56-.45 1.7-1.33a.33.33 0 00-.07-.27.35.35 0 00-.27-.13H6.8c-.43 0-.8.26-.96.65L4.98 5.9a.69.69 0 00.02.57l2.08 3.35c.1.2.16.42.16.64v4.37h4.83v-3.54a1.38 1.38 0 01.19-.7l1.3-1.75a4.46 4.46 0 00.92-2.63V3.45a.34.34 0 01.7 0V6.2l-.02.36c-.09.98-.45 1.9-1.04 2.69l-1.29 1.73a.7.7 0 00-.07.3v3.54c0 .38-.31.69-.7.69z"
    />
  </g>
  <g id="student">
    <path
      fill="#F09372"
      d="M12.45 12v.13c0 1.18.95 2.17 2.2 2.29l1.15.2c1.25.12 2.2 1.1 2.2 2.29v2.23c0 .23-.1.45-.27.6a.95.95 0 01-.65.26H2.92a.95.95 0 01-.65-.25.83.83 0 01-.27-.61V16.9c0-1.18.95-2.17 2.2-2.29l1.15-.2a2.36 2.36 0 002.2-2.29V12h4.9z"
    />
    <path
      fill="#2C2F38"
      d="M18 16.64v2.42c0 .25-.1.5-.28.67a1 1 0 01-.7.27H10v-2.26c.52 0 .94-.4.94-.9v-.45c0-.5-.41-.9-.93-.9l.5-.79.9 2.14L14.75 14l.92.16A2.53 2.53 0 0118 16.64zM10 17.74V20H2.87a.84.84 0 01-.62-.27.97.97 0 01-.25-.67v-2.42c0-1.27.9-2.35 2.08-2.48l.83-.16 2.98 2.84.82-2.14.44.78c-.46.01-.83.41-.83.9v.46c0 .5.37.9.84.9H10z"
    />
    <path fill="#D1D4D1" d="M9 15l1 1.67L11 15l1 2.08V20H8v-2.92L9 15z" />
    <path
      fill="#E64C3C"
      d="M9.67 16h.66c.37 0 .67.36.67.8v.4c0 .44-.3.8-.67.8h-.66c-.37 0-.67-.36-.67-.8v-.4c0-.44.3-.8.67-.8z"
    />
    <path fill="#C03A2B" d="M11 20l-.55-2h-.9L9 20h2z" />
    <path
      fill="#FDD7AD"
      d="M6.36 9.54A3.55 3.55 0 0010 13c2 0 3.64-1.55 3.64-3.46A2.23 2.23 0 0015 7.77c0-1.2-.76-1.3-1.36-.98v-1.2C13.64 4.17 12.42 3 10.9 3H9.09a2.66 2.66 0 00-2.73 2.6v1.18c-.6-.3-1.36-.2-1.36.98.1.78.62 1.45 1.36 1.78z"
    />
    <path
      fill="#E6E7E8"
      d="M14.72 14.36l-3.02 2.66-.85-2.12 2.21-1.25c.38.37.87.6 1.39.65l.27.06zM9.15 14.9l-.85 2.12-3.02-2.66.27-.06a2.31 2.31 0 001.39-.65l2.21 1.25z"
    />
    <path fill="#F0C419" d="M3.44 5.5a.35.35 0 01-.34-.34V2.74a.35.35 0 11.69 0v2.42c0 .19-.16.34-.35.34z" />
    <path
      fill="#35495E"
      d="M13.8 4.81v1.38l-2.98 1.22c-.52.22-1.12.22-1.65 0L6.2 6.19V4.81c0-.67.24-1.31.68-1.81l.06-.07.1-.1.1-.1.12-.1.1-.06.13-.09.1-.07.14-.07.12-.05.14-.06.12-.04a2.15 2.15 0 01.27-.08l.19-.03.1-.01c.1-.02.2-.02.3-.02h2.07c.1 0 .2 0 .29.02h.1l.19.04c.04 0 .07.02.11.03a2.11 2.11 0 01.28.09l.14.06.12.05.14.07.1.07.13.09.1.07a3 3 0 01.12.1l.1.08.1.11.06.06c.44.51.68 1.15.68 1.82z"
    />
    <path
      fill="#2C3E50"
      d="M16.68 3.06l-6.56 2.4a.36.36 0 01-.24 0l-6.56-2.4a.34.34 0 010-.64L9.88.02a.36.36 0 01.24 0l6.56 2.4a.34.34 0 010 .64z"
    />
  </g>
  <g id="university">
    <g clip-path="url(#clip21)">
      <path
        fill="#3F5C6C"
        d="M1.04 5.86h-.6a.34.34 0 01-.33-.43L.97 2a.34.34 0 01.33-.27h17.4c.16 0 .3.11.33.27l.86 3.44a.34.34 0 01-.33.43H1.04z"
      />
      <path
        fill="#F3D55B"
        d="M19.1 5.86V17.6H1.15V5.86h2.68a.7.7 0 00.5-.2l1.3-1.32 2.97-2.96L9.88.1a.35.35 0 01.5 0l1.27 1.28 2.96 2.96 1.32 1.32c.13.13.3.2.49.2h2.67z"
      />
      <path fill="#E64C3C" d="M10 12.41c-.76 0-1.38.62-1.38 1.38v3.72h2.76V13.8c0-.76-.62-1.38-1.38-1.38z" />
      <path fill="#CBB292" d="M8.62 13.8h2.76v3.71H8.62V13.8z" />
      <path
        fill="#8697CB"
        d="M3.8 7.59H2.75a.34.34 0 00-.35.34v2.76c0 .2.16.35.35.35h1.03c.2 0 .35-.16.35-.35V7.93a.34.34 0 00-.35-.34z"
      />
      <path
        fill="#90BAE1"
        d="M6.9 7.59H5.86a.34.34 0 00-.34.34v2.76c0 .2.15.35.34.35H6.9c.19 0 .34-.16.34-.35V7.93a.34.34 0 00-.34-.34zM3.8 12.41H2.75a.34.34 0 00-.35.35v2.76c0 .19.16.34.35.34h1.03c.2 0 .35-.15.35-.34v-2.76c0-.2-.16-.35-.35-.35z"
      />
      <path
        fill="#8697CB"
        d="M6.9 12.41H5.86a.34.34 0 00-.34.35v2.76c0 .19.15.34.34.34H6.9c.19 0 .34-.15.34-.34v-2.76c0-.2-.15-.35-.34-.35z"
      />
      <path
        fill="#90BAE1"
        d="M14.14 7.59H13.1c-.19 0-.34.15-.34.34v2.76c0 .2.15.35.34.35h1.04c.19 0 .34-.16.34-.35V7.93a.34.34 0 00-.34-.34z"
      />
      <path
        fill="#8697CB"
        d="M17.24 7.59h-1.03a.34.34 0 00-.35.34v2.76c0 .2.16.35.35.35h1.03c.2 0 .35-.16.35-.35V7.93a.34.34 0 00-.35-.34zM14.14 12.41H13.1c-.19 0-.34.16-.34.35v2.76c0 .19.15.34.34.34h1.04c.19 0 .34-.15.34-.34v-2.76c0-.2-.15-.35-.34-.35z"
      />
      <path
        fill="#90BAE1"
        d="M17.24 12.41h-1.03a.34.34 0 00-.35.35v2.76c0 .19.16.34.35.34h1.03c.2 0 .35-.15.35-.34v-2.76c0-.2-.16-.35-.35-.35z"
      />
      <path
        fill="#8697CB"
        d="M11.03 8.28H8.97a.34.34 0 00-.35.34v2.07c0 .2.16.34.35.34h2.06c.2 0 .35-.15.35-.34V8.62a.34.34 0 00-.35-.34z"
      />
      <path fill="#D1D4D1" d="M.7 17.24H19.3c.2 0 .35.16.35.35v1.2H.35v-1.2c0-.2.15-.35.34-.35z" />
      <path fill="#fff" d="M12.07 4.83a2.07 2.07 0 11-4.14 0 2.07 2.07 0 014.14 0z" />
      <path fill="#2C2F38" d="M10.69 5.17H10a.34.34 0 01-.34-.34v-.7a.34.34 0 01.69 0v.35h.34a.34.34 0 010 .7z" />
      <path
        fill="#464F5D"
        d="M2.41 9.66h1.73v1.03c0 .19-.16.34-.35.34H2.76a.34.34 0 01-.35-.34V9.66zM5.52 9.66h1.72v1.03c0 .19-.15.34-.34.34H5.86a.34.34 0 01-.34-.34V9.66zM2.41 14.48h1.73v1.04c0 .19-.16.34-.35.34H2.76a.34.34 0 01-.35-.34v-1.04zM5.52 14.48h1.72v1.04c0 .19-.15.34-.34.34H5.86a.34.34 0 01-.34-.34v-1.04zM12.76 9.66h1.72v1.03c0 .19-.15.34-.34.34H13.1a.34.34 0 01-.34-.34V9.66zM15.86 9.66h1.73v1.03c0 .19-.16.34-.35.34h-1.03a.35.35 0 01-.35-.34V9.66zM12.76 14.48h1.72v1.04c0 .19-.15.34-.34.34H13.1a.34.34 0 01-.34-.34v-1.04zM15.86 14.48h1.73v1.04c0 .19-.16.34-.35.34h-1.03a.34.34 0 01-.35-.34v-1.04z"
      />
      <path fill="#2C2F38" d="M10.69 15.52a.34.34 0 11-.69 0 .34.34 0 01.69 0z" />
      <path
        fill="#A5A5A4"
        d="M.35 18.62h19.3c.2 0 .35.16.35.35v.69c0 .19-.15.34-.34.34H.35a.34.34 0 01-.35-.34v-.7c0-.18.16-.34.35-.34z"
      />
      <path fill="#464F5D" d="M8.62 9.66h2.76v1.03c0 .19-.15.34-.35.34H8.97a.34.34 0 01-.35-.34V9.66z" />
      <path
        fill="#A5A5A4"
        d="M3.1 0h.35c.38 0 .69.31.69.69V3.1c0 .2-.16.35-.35.35H2.76a.34.34 0 01-.35-.35V.7c0-.38.31-.69.7-.69z"
      />
    </g>
    <defs>
      <clipPath id="clip21"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="earth">
    <g clip-path="url(#clip22)">
      <path fill="#4482C3" d="M10 20a10 10 0 100-20 10 10 0 000 20z" />
      <path
        fill="#4FBA6F"
        d="M7.14 3.58c-.45.74-.08 1.63.23 2.42.13.25.17.55.1.83-.12.22-.3.4-.5.54L5.2 8.71c-.43.3-.8.67-1.08 1.11-.46.9.01 1.94-.19 2.9-.11.55-1.44 2.14-2.12 3A9.98 9.98 0 017.27.42v.01c.77.56.97 1.61.47 2.4-.22.25-.42.5-.6.75zM20 10.02a9.8 9.8 0 01-.24 2.15c-.43.1-.88-.02-1.2-.31-.53-.43-.96-1.07-1.73-.97a1.5 1.5 0 00-1.05.72c-.65 1.05-.31 2.39-.86 3.45-.32.52-.74.98-1.24 1.34l-.01.02a.92.92 0 01-1.48-.84c.12-.95-.13-1.9-.69-2.67-.44-.6-1.11-1.15-1.1-1.9 0-1 1.23-1.62 2.03-1.97.44-.18.81-.49 1.07-.89.71-1.2-.4-2.14-.96-3.15a3.6 3.6 0 01.81-4.4A9.97 9.97 0 0120 10.03zM13.35.61l.03-.02M10.86 19.96a9.95 9.95 0 01-7.1-2.16l1.6-1.16c.22-.17.5-.25.78-.23.6.07 1 .68 1.58.85.45.14.93 0 1.4.02.1 0 .19.03.27.06a.7.7 0 01.22.2c.56.72.68 1.72 1.25 2.42z"
      />
    </g>
    <defs>
      <clipPath id="clip22"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="call">
    <g clip-path="url(#clip23)">
      <path
        fill="#F0C419"
        d="M19.67 3.73c-.19-.18-.44-.28-.7-.28H1.37l2.27 12.28.15.82h15.18c.57 0 1.03-.46 1.03-1.03V4.48c0-.28-.12-.56-.33-.75z"
      />
      <path
        fill="#F29C1F"
        d="M19.68 16.27c-.2.18-.45.28-.71.28H3.79l-.15-.82 6.1-5.85.95.88c.4.37 1.01.37 1.4 0l.94-.87 6.65 6.38z"
      />
      <path
        fill="#F3D55B"
        d="M19.67 3.73l-6.64 6.16-.93.87c-.4.37-1.01.37-1.41 0l-.95-.88-6.95-6.43h16.18c.26 0 .51.1.7.28z"
      />
      <path
        fill="#3B97D3"
        d="M10.45 19.45l-.46.13-.66.2-.64.19a.83.83 0 01-.42 0l-2.79-.64a.8.8 0 01-.39-.21c-.65-.64-2.95-3.1-4.25-7.41-1.3-4.3-.75-7.62-.56-8.5.03-.15.1-.28.21-.4L2.47.78a.8.8 0 01.36-.22l.64-.18.66-.2.45-.14A.82.82 0 015.6.58l1.18 3.88a.8.8 0 01-.56 1l-.45.14-.66.2-1.82.53a.4.4 0 00-.27.28 8.12 8.12 0 00.17 4.4 8.24 8.24 0 002.3 3.78c.1.1.25.13.39.09l1.81-.54.66-.2.46-.13a.82.82 0 011.02.55L11 18.44a.8.8 0 01-.55 1z"
      />
      <path fill="#F9EAB0" d="M14.14 5.17H8.62a.34.34 0 110-.69h5.52a.34.34 0 110 .7z" />
      <path fill="#F3D55B" d="M18.62 12.76a.34.34 0 01-.34-.35V7.6a.34.34 0 01.69 0v4.82c0 .2-.16.35-.35.35z" />
      <path
        fill="#2980BA"
        d="M8.36 15.35a.34.34 0 01-.43-.23l-.24-.77.66-.2.24.77a.34.34 0 01-.23.43zM10 19.58l-.67.2-.94-3.1a.35.35 0 01.67-.2l.93 3.1zM5.77 5.6l-.66.2-.23-.78a.34.34 0 01.65-.2l.24.78zM4.83 3.7a.34.34 0 01-.43-.23L3.48.37l.66-.2.94 3.1a.34.34 0 01-.24.43z"
      />
    </g>
    <defs>
      <clipPath id="clip23"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="check"><path fill="#00AB8D" d="M17.5 5.83l-10 10-4.58-4.58 1.17-1.18 3.41 3.4 8.82-8.81 1.18 1.17z" /></g>
  <g id="menu-down"><path fill="#000" d="M5.83 8.33L10 12.5l4.17-4.17H5.83z" /></g>
  <g id="computer">
    <g clip-path="url(#clip24)">
      <path fill="#95A5A5" d="M63.8 81.67H36.2v15.64h27.6V81.67z" />
      <path
        fill="#BDC3C7"
        d="M93.1 15.36H6.9a6.9 6.9 0 00-6.9 6.9v56.9a6.9 6.9 0 006.9 6.9h86.2a6.9 6.9 0 006.9-6.9v-56.9a6.9 6.9 0 00-6.9-6.9z"
      />
      <path fill="#35495E" d="M100 72.26v-50a6.9 6.9 0 00-6.9-6.9H6.9a6.9 6.9 0 00-6.9 6.9v50h100z" />
      <path
        fill="#BDC3C7"
        d="M24.14 92.95h51.72c.95 0 1.73.77 1.73 1.72v3.45c0 .95-.78 1.73-1.73 1.73H24.14c-.95 0-1.73-.78-1.73-1.73v-3.45c0-.95.78-1.72 1.73-1.72z"
      />
      <path
        fill="#65DDB9"
        d="M1.52 55.98l3.5-3.5 9.55 9.55-3.5 3.5a5.17 5.17 0 01-7.32 0L1.52 63.3a5.17 5.17 0 010-7.32z"
      />
      <path
        fill="#46B29D"
        d="M5.07 47.65l9.5-9.5 14.32 14.33-9.5 9.5a3.45 3.45 0 01-4.87 0l-9.45-9.45a3.45 3.45 0 010-4.88z"
      />
      <path
        fill="#E6E7E8"
        d="M14.57 38.15S32.47 17.86 27.7 5.92l33.42 33.43C49.2 34.57 28.9 52.48 28.9 52.48L14.57 38.15z"
      />
      <path fill="#65DDB9" d="M19.34 62.03l18.42 10.23 5.46-5.46-14.33-14.32-9.55 9.55z" />
      <path
        fill="#46B29D"
        d="M65.9 39.35a3.36 3.36 0 01-4.78 0L27.71 5.93A3.39 3.39 0 0130.09.16c.9 0 1.76.36 2.4 1l10.46 10.46v.02l12.14 12.12 10.8 10.8a3.36 3.36 0 010 4.79z"
      />
      <path fill="#BDC3C7" d="M42.95 11.64v-.02a8.62 8.62 0 1112.14 12.14L42.95 11.64z" />
      <path
        fill="#E6E7E8"
        d="M79.31 53.3H63.79a1.72 1.72 0 110-3.45h15.52a1.72 1.72 0 110 3.44zM81.03 46.4h-5.17a1.72 1.72 0 110-3.45h5.17a1.72 1.72 0 010 3.45zM93.1 46.4h-5.17a1.72 1.72 0 010-3.45h5.17a1.72 1.72 0 010 3.45zM93.1 53.3h-6.9a1.72 1.72 0 110-3.45h6.9a1.72 1.72 0 010 3.44z"
      />
      <path fill="#4482C3" d="M67.24 58.47h22.42a3.45 3.45 0 010 6.9H67.24a3.45 3.45 0 110-6.9z" />
    </g>
    <defs>
      <clipPath id="clip24"><path fill="#fff" d="M0 0h100v100H0z" /></clipPath>
    </defs>
  </g>
  <g id="profile-plus">
    <rect width="36" height="36" fill="#F2F2F2" rx="18" />
    <path
      fill="#BDBDBD"
      d="M22.7 16.2h-2.89v-2.9a1.31 1.31 0 00-2.62 0v2.89h-2.9a1.31 1.31 0 000 2.62h2.9v2.9a1.31 1.31 0 002.62 0v-2.9h2.9a1.31 1.31 0 000-2.62z"
    />
  </g>
  <g id="profile-plus-green">
    <rect width="36" height="36" fill="#F2F2F2" rx="18" />
    <path
      fill="#47979D"
      d="M22.7 16.2h-2.89v-2.9a1.31 1.31 0 00-2.62 0v2.89h-2.9a1.31 1.31 0 000 2.62h2.9v2.9a1.31 1.31 0 002.62 0v-2.9h2.9a1.31 1.31 0 000-2.62z"
    />
  </g>
  <g id="chat">
    <g clip-path="url(#clip25)">
      <path
        fill="#F29C1F"
        d="M75.86 94.83v1.72c0 1.9-1.54 3.44-3.45 3.45H27.6a3.46 3.46 0 01-3.45-3.45v-1.72c0-10.3 6.12-19.62 15.57-23.73a18.97 18.97 0 0020.58 0 25.46 25.46 0 017.99 5.45 25.72 25.72 0 017.58 18.28z"
      />
      <path
        fill="#E57E25"
        d="M39.66 91.38V100H36.2v-8.62a1.72 1.72 0 113.45 0zM63.8 91.38V100h-3.46v-8.62a1.72 1.72 0 113.45 0zM39.7 71.1a25.88 25.88 0 00-15.56 23.73H2.98A3 3 0 010 91.84v-4.03c0-8.73 5.07-16.66 13-20.31a15.5 15.5 0 0021.05-2.07 18.68 18.68 0 005.66 5.67z"
      />
      <path
        fill="#F9C795"
        d="M34.05 65.43A15.52 15.52 0 1118.02 40.3l.07-.03 3.19-.55a15.47 15.47 0 0112.78 5.2v20.52z"
      />
      <path fill="#D25627" d="M13.8 87.93v6.9h-3.46v-6.9a1.72 1.72 0 013.45 0z" />
      <path
        fill="#E57E25"
        d="M100 87.81v4.03a3 3 0 01-2.98 2.99H75.86a25.72 25.72 0 00-7.58-18.28c-2.3-2.3-5-4.16-7.99-5.45 2.28-1.46 4.2-3.4 5.66-5.67A15.5 15.5 0 0087 67.5a22.33 22.33 0 0113 20.31z"
      />
      <path
        fill="#F9C795"
        d="M65.95 44.91a15.47 15.47 0 0112.77-5.2l3.2.55.06.03a15.52 15.52 0 11-16.03 25.14V44.91z"
      />
      <path fill="#D25627" d="M89.66 87.93v6.9H86.2v-6.9a1.72 1.72 0 113.45 0z" />
      <path fill="#FDD7AD" d="M54.03 36.66a18.98 18.98 0 11-8.06 0h8.06z" />
      <path
        fill="#3B97D3"
        d="M83.8 24.45a21.81 21.81 0 01-1.89 15.8 18.1 18.1 0 01-2 2.85 31.66 31.66 0 00-1.19-3.4c-1.36-3.34-3.94-8.25-8.05-10.68h-.01v-.07c-4.27.92-8.6 1.52-12.95 1.8v.03l-3.68 5.88-1.94 3.12L50 43.1l-2.09-3.32-1.94-3.12-3.68-5.88v-.02c-4.35-.3-8.67-.9-12.93-1.81h-.02v.07h-.01c-4.1 2.43-6.7 7.34-8.05 10.69-.46 1.1-.86 2.24-1.2 3.4a18.1 18.1 0 01-2-2.85v-.02a21.81 21.81 0 01-1.87-15.8c-4.78-2.5-7.59-5.6-7.59-8.92C8.62 6.95 27.16 0 50 0c22.84 0 41.38 6.95 41.38 15.52 0 3.32-2.81 6.43-7.59 8.93z"
      />
      <path
        fill="#fff"
        d="M50 18.97a3.45 3.45 0 100-6.9 3.45 3.45 0 000 6.9zM34.48 18.97a3.45 3.45 0 100-6.9 3.45 3.45 0 000 6.9zM65.52 18.97a3.45 3.45 0 100-6.9 3.45 3.45 0 000 6.9z"
      />
    </g>
    <defs>
      <clipPath id="clip25"><path fill="#fff" d="M0 0h100v100H0z" /></clipPath>
    </defs>
  </g>
  <g id="calendar">
    <path fill="#ECF0F1" d="M17.93 4.83v4.34l-9.05 8.42h-7.5C.62 17.59 0 16.97 0 16.2V4.83h17.93z" />
    <path
      fill="#95A5A5"
      d="M3.1 6.9H1.72a.34.34 0 00-.34.34v1.04c0 .19.15.34.34.34H3.1c.2 0 .35-.15.35-.34V7.24a.34.34 0 00-.35-.34zM6.9 6.9H5.52a.34.34 0 00-.35.34v1.04c0 .19.16.34.35.34H6.9c.19 0 .34-.15.34-.34V7.24a.34.34 0 00-.34-.34zM10.69 6.9H9.31a.34.34 0 00-.34.34v1.04c0 .19.15.34.34.34h1.38c.19 0 .34-.15.34-.34V7.24a.34.34 0 00-.34-.34zM6.9 10.34H5.52a.34.34 0 00-.35.35v1.03c0 .2.16.35.35.35H6.9c.19 0 .34-.16.34-.35V10.7c0-.2-.15-.35-.34-.35zM6.9 13.8H5.52a.34.34 0 00-.35.34v1.03c0 .2.16.35.35.35H6.9c.19 0 .34-.16.34-.35v-1.03a.34.34 0 00-.34-.35zM3.1 10.34H1.72a.34.34 0 00-.34.35v1.03c0 .2.15.35.34.35H3.1c.2 0 .35-.16.35-.35V10.7c0-.2-.16-.35-.35-.35zM3.1 13.8H1.72a.34.34 0 00-.34.34v1.03c0 .2.15.35.34.35H3.1c.2 0 .35-.16.35-.35v-1.03a.34.34 0 00-.35-.35z"
    />
    <path fill="#3B97D3" d="M13.8 20a6.2 6.2 0 100-12.41 6.2 6.2 0 000 12.41z" />
    <path fill="#2980BA" d="M13.8 19.31a5.52 5.52 0 100-11.03 5.52 5.52 0 000 11.03z" />
    <path fill="#2FA8CC" d="M18.62 13.8a4.82 4.82 0 11-9.64-.02 4.82 4.82 0 019.64.01z" />
    <path
      fill="#67B9CC"
      d="M15.86 11.38a4.83 4.83 0 01-6.39 4.57 4.83 4.83 0 015.88-6.72l.03.04c.32.66.48 1.38.48 2.11z"
    />
    <path
      fill="#285680"
      d="M14.14 8.98v.68a.34.34 0 01-.7 0v-.68a3.8 3.8 0 01.7 0zM11.9 10.5a.34.34 0 01-.48-.12l-.33-.58c.19-.13.39-.25.6-.35l.33.59c.1.16.04.37-.12.47zM10.5 11.9a.34.34 0 01-.46.12l-.6-.34.36-.6.58.34a.34.34 0 01.13.48zM10 13.8c0 .18-.15.34-.34.34h-.68a3.79 3.79 0 010-.7h.68c.19 0 .34.16.34.35zM10.38 16.16l-.58.34c-.13-.2-.25-.39-.35-.6l.59-.34a.35.35 0 11.34.6zM12.02 17.55l-.34.59c-.2-.1-.4-.22-.6-.35l.34-.59a.35.35 0 11.6.35zM14.14 17.93v.68a3.8 3.8 0 01-.7 0v-.68a.34.34 0 11.7 0zM16.5 17.79c-.2.13-.39.25-.6.35l-.34-.6a.35.35 0 01.6-.34l.34.59zM18.14 15.9c-.1.21-.22.4-.35.6l-.59-.34a.35.35 0 01.35-.6l.59.34zM18.62 13.8l-.01.34h-.68a.34.34 0 110-.7h.68l.01.35zM18.14 11.68l-.6.34a.35.35 0 01-.16.05.34.34 0 01-.18-.65l.59-.33c.13.19.24.39.35.6zM16.5 9.8l-.34.58a.34.34 0 01-.47.13.34.34 0 01-.13-.47l.34-.6c.21.11.4.23.6.36z"
    />
    <path
      fill="#BDC3C7"
      d="M15.17 15.52a.35.35 0 01-.24-.1l-1.38-1.38a.34.34 0 01-.07-.38l1.03-2.42a.34.34 0 01.63.28l-.94 2.2 1.22 1.2a.34.34 0 01-.25.6z"
    />
    <path fill="#E64C3C" d="M17.93 2.41v3.1H0v-3.1c0-.76.62-1.38 1.38-1.38h15.17c.76 0 1.38.62 1.38 1.38z" />
    <path
      fill="#C03A2B"
      d="M14.14 1.03c.61.24 1.02.83 1.03 1.49a1.73 1.73 0 01-3.45 0c.02-.66.42-1.25 1.04-1.49h1.38zM5.17 1.03c.62.24 1.02.83 1.04 1.49-.03.92-.8 1.65-1.73 1.62-.92.03-1.7-.7-1.72-1.62.01-.66.42-1.25 1.03-1.49h1.38z"
    />
    <path
      fill="#95A5A5"
      d="M14.14.69a.69.69 0 10-1.38 0v1.38a.69.69 0 001.38 0V.69zM5.17.69a.69.69 0 00-1.38 0v1.38a.69.69 0 001.38 0V.69z"
    />
  </g>
  <g id="reply"><path fill="#828282" d="M5.8 5.2V3L1.8 7l4 4V8.8c3 0 5 1 6.5 3-.6-3-2.4-5.9-6.5-6.5z" /></g>
  <g id="sun">
    <path
      d="M18.0527 12.3395L18.6936 14.7345C18.7436 14.9211 18.6328 15.1129 18.4461 15.1629L16.0513 15.8037C15.9305 15.8361 15.8361 15.9304 15.8038 16.0513L15.1629 18.4461C15.1129 18.6327 14.9212 18.7435 14.7345 18.6936L12.3395 18.0526C12.2188 18.0203 12.09 18.0548 12.0016 18.1432L10.2473 19.8975C10.1818 19.9631 10.0928 20 10 20C9.90723 20 9.81824 19.9631 9.75262 19.8975L7.99832 18.1432C7.90996 18.0549 7.78121 18.0204 7.66051 18.0527L5.26543 18.6936C5.07879 18.7436 4.88699 18.6328 4.83707 18.4461L4.19617 16.0513C4.16383 15.9305 4.06949 15.8361 3.94867 15.8038L1.55387 15.1629C1.36723 15.1129 1.25645 14.9212 1.30637 14.7345L1.94734 12.3395C1.97965 12.2188 1.94512 12.09 1.85676 12.0016L0.102461 10.2473C0.036875 10.1818 0 10.0928 0 10C0 9.90723 0.036875 9.81824 0.102461 9.75262L1.85676 7.99832C1.94512 7.90996 1.97961 7.78121 1.94734 7.66051L1.30637 5.26543C1.25641 5.07879 1.36723 4.88699 1.55387 4.83707L3.94871 4.19617C4.06953 4.16383 4.16387 4.06949 4.19621 3.94867L4.83711 1.55383C4.88707 1.36719 5.07883 1.25641 5.26547 1.30633L7.66055 1.9473C7.78125 1.97961 7.91 1.94508 7.99836 1.85672L9.75266 0.102422C9.81824 0.036875 9.90723 0 10 0C10.0928 0 10.1818 0.036875 10.2474 0.102461L12.0017 1.85676C12.09 1.94512 12.2188 1.97961 12.3395 1.94734L14.7345 1.30637C14.9212 1.25641 15.113 1.36723 15.1629 1.55387L15.8038 3.94871C15.8361 4.06953 15.9305 4.16387 16.0513 4.19621L18.4461 4.83711C18.6328 4.88707 18.7436 5.07883 18.6936 5.26547L18.0527 7.66055C18.0204 7.78125 18.0549 7.91 18.1432 7.99836L19.8975 9.75266C19.9631 9.81824 20 9.90723 20 10C20 10.0929 19.9631 10.1818 19.8975 10.2474L18.1432 12.0017C18.0549 12.09 18.0204 12.2188 18.0527 12.3395Z"
      fill="#F29C1F"
    />
    <path
      d="M10 16.5517C13.6184 16.5517 16.5517 13.6184 16.5517 9.99996C16.5517 6.38155 13.6184 3.44824 10 3.44824C6.38161 3.44824 3.4483 6.38155 3.4483 9.99996C3.4483 13.6184 6.38161 16.5517 10 16.5517Z"
      fill="#F0C419"
    />
    <path
      d="M4.83869 10.6898C4.65744 10.6896 4.50725 10.5492 4.49487 10.3684C4.48678 10.2466 4.48276 10.1239 4.48276 10.0001C4.47709 8.26304 5.29576 6.62623 6.68912 5.58889C6.84135 5.47432 7.05764 5.50486 7.17217 5.65709C7.28674 5.80932 7.25619 6.02561 7.10397 6.14014C5.8844 7.04764 5.16768 8.47991 5.1724 10.0001C5.1724 10.108 5.17576 10.2153 5.18319 10.3215C5.1894 10.4128 5.15905 10.5028 5.09885 10.5717C5.03865 10.6406 4.95354 10.6828 4.86225 10.6889C4.85451 10.6894 4.84643 10.6898 4.83869 10.6898Z"
      fill="#F9EAB0"
    />
  </g>
  <g id="speech">
    <g clip-path="url(#clip25)">
      <path
        d="M15.1725 6.03467H18.9656C19.5369 6.03467 20.0001 6.49782 20.0001 7.06915V16.0347C20.0001 16.606 19.5369 17.0692 18.9656 17.0692H18.3621C18.2571 17.0687 18.1575 17.1161 18.0917 17.198C18.0259 17.2799 18.0011 17.3874 18.0242 17.4898L18.3656 19.0174C18.3996 19.1679 18.3295 19.3226 18.1941 19.3963C18.0586 19.4701 17.8907 19.4449 17.7828 19.3347L15.6173 17.1692C15.5529 17.1057 15.4663 17.0699 15.3759 17.0692H5.86212C5.29079 17.0692 4.82764 16.606 4.82764 16.0347V11.5519L15.1725 6.03467Z"
        fill="#F29C1F"
      />
      <path
        d="M15.1724 1.55182V10.5173C15.1724 11.0887 14.7093 11.5518 14.1379 11.5518H13.5345C13.4294 11.5513 13.3299 11.5988 13.2641 11.6807C13.1983 11.7626 13.1734 11.87 13.1966 11.9725L13.5379 13.5001C13.5719 13.6505 13.5019 13.8052 13.3665 13.879C13.231 13.9527 13.0631 13.9275 12.9552 13.8173L10.7897 11.6518C10.7252 11.5884 10.6387 11.5525 10.5483 11.5518H1.03448C0.463154 11.5518 0 11.0887 0 10.5173V1.55182C0 0.980488 0.463154 0.517334 1.03448 0.517334H14.1379C14.7093 0.517334 15.1724 0.980488 15.1724 1.55182Z"
        fill="#3B97D3"
      />
      <path
        d="M3.79308 2.93111H2.06895C1.87851 2.93111 1.72412 2.77672 1.72412 2.58628C1.72412 2.39584 1.87851 2.24146 2.06895 2.24146H3.79308C3.98353 2.24146 4.13791 2.39584 4.13791 2.58628C4.13791 2.77672 3.98353 2.93111 3.79308 2.93111Z"
        fill="white"
      />
      <path
        d="M13.1035 2.93111H5.1724C4.98196 2.93111 4.82758 2.77672 4.82758 2.58628C4.82758 2.39584 4.98196 2.24146 5.1724 2.24146H13.1035C13.2939 2.24146 13.4483 2.39584 13.4483 2.58628C13.4483 2.77672 13.2939 2.93111 13.1035 2.93111Z"
        fill="white"
      />
      <path
        d="M10 8.10348H2.06895C1.87851 8.10348 1.72412 7.94909 1.72412 7.75865C1.72412 7.5682 1.87851 7.41382 2.06895 7.41382H10C10.1904 7.41382 10.3448 7.5682 10.3448 7.75865C10.3448 7.94909 10.1904 8.10348 10 8.10348Z"
        fill="white"
      />
      <path
        d="M3.79308 9.8276H2.06895C1.87851 9.8276 1.72412 9.67321 1.72412 9.48277C1.72412 9.29233 1.87851 9.13794 2.06895 9.13794H3.79308C3.98353 9.13794 4.13791 9.29233 4.13791 9.48277C4.13791 9.67321 3.98353 9.8276 3.79308 9.8276Z"
        fill="white"
      />
      <path
        d="M13.1035 9.8276H5.1724C4.98196 9.8276 4.82758 9.67321 4.82758 9.48277C4.82758 9.29233 4.98196 9.13794 5.1724 9.13794H13.1035C13.2939 9.13794 13.4483 9.29233 13.4483 9.48277C13.4483 9.67321 13.2939 9.8276 13.1035 9.8276Z"
        fill="white"
      />
      <path
        d="M13.1034 4.65523H11.3793C11.1888 4.65523 11.0344 4.50085 11.0344 4.3104C11.0344 4.11996 11.1888 3.96558 11.3793 3.96558H13.1034C13.2938 3.96558 13.4482 4.11996 13.4482 4.3104C13.4482 4.50085 13.2938 4.65523 13.1034 4.65523Z"
        fill="white"
      />
      <path
        d="M13.1034 8.10348H11.3793C11.1888 8.10348 11.0344 7.94909 11.0344 7.75865C11.0344 7.5682 11.1888 7.41382 11.3793 7.41382H13.1034C13.2938 7.41382 13.4482 7.5682 13.4482 7.75865C13.4482 7.94909 13.2938 8.10348 13.1034 8.10348Z"
        fill="white"
      />
      <path
        d="M17.931 13.6208H16.2069C16.0164 13.6208 15.8621 13.4664 15.8621 13.276C15.8621 13.0855 16.0164 12.9312 16.2069 12.9312H17.931C18.1215 12.9312 18.2759 13.0855 18.2759 13.276C18.2759 13.4664 18.1215 13.6208 17.931 13.6208Z"
        fill="white"
      />
      <path
        d="M10 4.65523H2.06895C1.87851 4.65523 1.72412 4.50085 1.72412 4.3104C1.72412 4.11996 1.87851 3.96558 2.06895 3.96558H10C10.1904 3.96558 10.3448 4.11996 10.3448 4.3104C10.3448 4.50085 10.1904 4.65523 10 4.65523Z"
        fill="white"
      />
      <path
        d="M3.79308 6.37936H2.06895C1.87851 6.37936 1.72412 6.22497 1.72412 6.03453C1.72412 5.84408 1.87851 5.6897 2.06895 5.6897H3.79308C3.98353 5.6897 4.13791 5.84408 4.13791 6.03453C4.13791 6.22497 3.98353 6.37936 3.79308 6.37936Z"
        fill="white"
      />
      <path
        d="M13.1035 6.37936H5.1724C4.98196 6.37936 4.82758 6.22497 4.82758 6.03453C4.82758 5.84408 4.98196 5.6897 5.1724 5.6897H13.1035C13.2939 5.6897 13.4483 5.84408 13.4483 6.03453C13.4483 6.22497 13.2939 6.37936 13.1035 6.37936Z"
        fill="white"
      />
      <path
        d="M17.931 8.44845H16.5517C16.3613 8.44845 16.2069 8.29406 16.2069 8.10362C16.2069 7.91317 16.3613 7.75879 16.5517 7.75879H17.931C18.1215 7.75879 18.2759 7.91317 18.2759 8.10362C18.2759 8.29406 18.1215 8.44845 17.931 8.44845Z"
        fill="white"
      />
      <path
        d="M10.4621 13.6208H6.89659C6.70614 13.6208 6.55176 13.4664 6.55176 13.276C6.55176 13.0855 6.70614 12.9312 6.89659 12.9312H10.4621C10.6526 12.9312 10.8069 13.0855 10.8069 13.276C10.8069 13.4664 10.6526 13.6208 10.4621 13.6208Z"
        fill="white"
      />
      <path
        d="M8.62072 15.3449H6.89658C6.70614 15.3449 6.55176 15.1905 6.55176 15.0001C6.55176 14.8097 6.70614 14.6553 6.89658 14.6553H8.62072C8.81116 14.6553 8.96555 14.8097 8.96555 15.0001C8.96555 15.1905 8.81116 15.3449 8.62072 15.3449Z"
        fill="white"
      />
      <path
        d="M17.9309 15.3449H14.162C13.9715 15.3449 13.8171 15.1905 13.8171 15.0001C13.8171 14.8097 13.9715 14.6553 14.162 14.6553H17.9309C18.1214 14.6553 18.2758 14.8097 18.2758 15.0001C18.2758 15.1905 18.1214 15.3449 17.9309 15.3449Z"
        fill="white"
      />
      <path
        d="M12.2311 15.3449H10C9.8096 15.3449 9.65521 15.1905 9.65521 15.0001C9.65521 14.8097 9.8096 14.6553 10 14.6553H12.2311C12.4215 14.6553 12.5759 14.8097 12.5759 15.0001C12.5759 15.1905 12.4215 15.3449 12.2311 15.3449Z"
        fill="white"
      />
      <path
        d="M17.931 10.1726H16.5517C16.3613 10.1726 16.2069 10.0182 16.2069 9.82773C16.2069 9.63729 16.3613 9.48291 16.5517 9.48291H17.931C18.1215 9.48291 18.2759 9.63729 18.2759 9.82773C18.2759 10.0182 18.1215 10.1726 17.931 10.1726Z"
        fill="white"
      />
      <path
        d="M17.931 11.8967H16.3172C16.1268 11.8967 15.9724 11.7423 15.9724 11.5519C15.9724 11.3614 16.1268 11.207 16.3172 11.207H17.931C18.1215 11.207 18.2759 11.3614 18.2759 11.5519C18.2759 11.7423 18.1215 11.8967 17.931 11.8967Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip25"><rect width="20" height="20" fill="white" /></clipPath>
    </defs>
  </g>
  <g id="arrow">
    <path
      d="M15.41 16.5795L10.83 11.9995L15.41 7.40951L14 5.99951L8 11.9995L14 17.9995L15.41 16.5795Z"
      fill="#00AB8D"
    />
  </g>
  <g id="add">
    <g clip-path="url(#clip26)">
      <path fill="#FDD7AD" d="M8.51 2.33a2.33 2.33 0 11-4.65 0 2.33 2.33 0 014.65 0z" />
      <path
        fill="#E64C3C"
        d="M10.37 7.44v2.8c0 .5-.41.92-.93.92a.94.94 0 01-.93-.93v1.86H3.86v-1.86c0 .52-.42.93-.93.93a.91.91 0 01-.66-.27.91.91 0 01-.27-.66V7.44c0-.77.62-1.4 1.4-1.4h5.58c.77 0 1.4.63 1.4 1.4z"
      />
      <path
        fill="#C03A2B"
        d="M8.51 10.7a.47.47 0 01-.46-.47V7.91a.47.47 0 01.93 0v2.32c0 .26-.21.47-.47.47zM3.86 10.7a.47.47 0 01-.46-.47V7.91a.47.47 0 11.93 0v2.32c0 .26-.21.47-.47.47z"
      />
      <path fill="#C03A2B" d="M8.51 10.7a.47.47 0 01-.46-.47V9.3a.47.47 0 01.93 0v.93c0 .26-.21.47-.47.47z" />
      <path fill="#35495E" d="M8.51 12.1v4.41a1.16 1.16 0 11-2.32 0 1.16 1.16 0 01-2.33 0V12.1h4.65z" />
      <path fill="#C03A2B" d="M3.86 10.7a.47.47 0 01-.46-.47V9.3a.47.47 0 11.93 0v.93c0 .26-.21.47-.47.47z" />
      <path fill="#FDD7AD" d="M16.88 2.33a2.33 2.33 0 11-4.65 0 2.33 2.33 0 014.65 0z" />
      <path
        fill="#E64C3C"
        d="M18.74 7.44v2.8c0 .5-.41.92-.93.92a.94.94 0 01-.93-.93v1.86h-4.65v-1.86c0 .52-.41.93-.93.93a.94.94 0 01-.93-.93V7.44c0-.77.63-1.4 1.4-1.4h5.58c.77 0 1.4.63 1.4 1.4z"
      />
      <path
        fill="#C03A2B"
        d="M16.88 10.7a.47.47 0 01-.46-.47V7.91a.47.47 0 01.93 0v2.32c0 .26-.2.47-.47.47zM12.23 10.7a.47.47 0 01-.46-.47V7.91a.47.47 0 01.93 0v2.32c0 .26-.21.47-.47.47z"
      />
      <path fill="#C03A2B" d="M16.88 10.7a.47.47 0 01-.46-.47V9.3a.47.47 0 01.93 0v.93c0 .26-.2.47-.47.47z" />
      <path fill="#35495E" d="M16.88 12.1v4.41a1.16 1.16 0 01-2.32 0 1.16 1.16 0 11-2.33 0V12.1h4.65z" />
      <path fill="#FDD7AD" d="M12.7 5.12a2.33 2.33 0 11-4.65 0 2.33 2.33 0 014.65 0z" />
      <path
        fill="#4FBA6F"
        d="M14.56 9.77v2.79c0 .51-.42.93-.93.93a.94.94 0 01-.93-.93v1.86H8.05v-1.86c0 .51-.42.93-.93.93a.94.94 0 01-.93-.93v-2.8c0-.76.62-1.39 1.4-1.39h5.57c.77 0 1.4.63 1.4 1.4z"
      />
      <path
        fill="#24AE5F"
        d="M12.7 13.02a.47.47 0 01-.47-.46v-2.33a.47.47 0 01.93 0v2.33c0 .26-.2.46-.46.46zM8.05 13.02a.47.47 0 01-.47-.46v-2.33a.47.47 0 01.93 0v2.33c0 .26-.2.46-.46.46z"
      />
      <path fill="#24AE5F" d="M12.7 13.02a.47.47 0 01-.47-.46v-.93a.47.47 0 11.93 0v.93c0 .26-.2.46-.46.46z" />
      <path fill="#285680" d="M12.7 14.42v4.42a1.16 1.16 0 11-2.33 0 1.16 1.16 0 11-2.32 0v-4.42h4.65z" />
      <path fill="#2C3E50" d="M10.37 19.3a.46.46 0 01-.46-.46v-2.1a.47.47 0 11.93 0v2.1c0 .25-.21.46-.47.46z" />
      <path fill="#24AE5F" d="M8.05 13.02a.47.47 0 01-.47-.46v-.93a.47.47 0 11.93 0v.93c0 .26-.2.46-.46.46z" />
      <path
        fill="#2C3E50"
        d="M6.19 16.98a.47.47 0 01-.47-.47v-2.1a.47.47 0 01.93 0v2.1c0 .26-.2.47-.46.47zM14.56 16.98a.47.47 0 01-.47-.47v-2.1a.47.47 0 01.93 0v2.1c0 .26-.2.47-.46.47z"
      />
    </g>
    <defs>
      <clipPath id="clip26"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="work-group">
    <g clip-path="url(#clip27)">
      <path
        fill="#955BA5"
        d="M12.68 6.55a2.4 2.4 0 00-1.98-1.03H9.32a2.4 2.4 0 00-1.98 1.03l-.08 3.1h5.17l.25-3.1zM6.48 6.55A2.4 2.4 0 004.5 5.52H3.12A2.41 2.41 0 00.7 7.93v1.04c0 .38.31.68.7.69h2.4l2.68-3.1zM16.22 9.66h2.41a.7.7 0 00.7-.7V7.94a2.41 2.41 0 00-2.42-2.41h-1.38a2.4 2.4 0 00-1.98 1.03l2.67 3.1z"
      />
      <path
        fill="#F09372"
        d="M5.76 1.39a2.07 2.07 0 10-.8 2.4l.8-2.4zM11.97 1.39a2.07 2.07 0 00-3.9 0l.8 2.4a2.05 2.05 0 002.3 0l.8-2.4zM15.07 3.79a2.07 2.07 0 10-.8-2.4l.8 2.4z"
      />
      <path
        fill="#FDD7AD"
        d="M8.98 2.98a2.07 2.07 0 11-4.13.25 2.07 2.07 0 014.13-.25zM15.18 2.98a2.07 2.07 0 11-4.13.24 2.07 2.07 0 014.13-.24z"
      />
      <path
        fill="#4FBA6F"
        d="M12.43 6.55h1.38a2.41 2.41 0 012.41 2.42V10c0 .38-.3.69-.69.69H10.7a.69.69 0 01-.69-.69V8.97a2.41 2.41 0 012.42-2.42z"
      />
      <path
        fill="#4FBA6F"
        d="M7.94 10.69h1.38a.7.7 0 00.7-.69V8.97A2.41 2.41 0 007.6 6.55H6.22a2.41 2.41 0 00-2.41 2.42V10c0 .38.3.69.69.69h3.44z"
      />
      <path
        fill="#FDD7AD"
        d="M9.24 20c-.97 0-1.89-.47-2.45-1.26a18.27 18.27 0 00-1.87-2.28l-.81-.81a.9.9 0 01-.08-1.22.86.86 0 011.26-.04l.34.34a.34.34 0 00.6-.24v-5.3a.9.9 0 01.79-.91.86.86 0 01.92.86v3.45a.86.86 0 011.73 0v.34a.86.86 0 111.72 0v.35a.86.86 0 111.73 0v3.7A3.02 3.02 0 0110.1 20h-.86z"
      />
      <path
        fill="#F09372"
        d="M10.36 18.97H8.98a.34.34 0 010-.7h1.38a.34.34 0 010 .7zM7.94 15.17a.34.34 0 01-.34-.34V13.1a.34.34 0 01.69 0v1.73c0 .19-.15.34-.35.34zM9.67 15.17a.34.34 0 01-.35-.34V13.1a.34.34 0 01.7 0v1.73c0 .19-.16.34-.35.34zM11.4 15.17a.34.34 0 01-.35-.34v-1.38a.34.34 0 01.69 0v1.38c0 .19-.16.34-.35.34z"
      />
    </g>
    <defs>
      <clipPath id="clip27"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="monitor">
    <g clip-path="url(#clip28)">
      <path
        fill="#95A5A5"
        d="M4.22 15.52h14.4c.76 0 1.38-.62 1.38-1.38V1.38C20 .62 19.38 0 18.62 0H1.38C.62 0 0 .62 0 1.38v12.76c0 .73.57 1.34 1.3 1.37h2.92z"
      />
      <path fill="#285680" d="M18.62 1.72v2.42H1.38V1.72c0-.19.15-.34.34-.34h16.56c.19 0 .34.15.34.34z" />
      <path fill="#90BAE1" d="M18.62 4.14v8.27c0 .2-.15.35-.34.35H1.72a.34.34 0 01-.34-.35V4.14h17.24z" />
      <path fill="#B0D3F0" d="M18.62 4.14v3.25C10.18 5.5 4.54 8.77 1.38 11.54v-7.4h17.24z" />
      <path fill="#7F8C8D" d="M7.59 15.52h4.82v1.72H7.6v-1.72z" />
      <path
        fill="#95A5A5"
        d="M7.24 17.24h5.52c1.14 0 2.07.93 2.07 2.07 0 .38-.31.69-.7.69H5.87a.69.69 0 01-.69-.69c0-1.14.93-2.07 2.07-2.07zM18.28 17.59c.95 0 1.72.77 1.72 1.72 0 .38-.3.69-.69.69h-2.07a.69.69 0 01-.69-.69c0-.95.77-1.72 1.73-1.72z"
      />
      <path
        fill="#7F8C8D"
        d="M18.28 18.62a.34.34 0 01-.35-.34v-.7a.34.34 0 11.7 0v.7c0 .19-.16.34-.35.34zM10.69 18.97H9.31a.34.34 0 110-.7h1.38a.34.34 0 110 .7z"
      />
      <path fill="#E64C3C" d="M3.1 2.76a.34.34 0 11-.69 0 .34.34 0 01.7 0z" />
      <path fill="#F0C419" d="M4.48 2.76a.34.34 0 11-.69 0 .34.34 0 01.7 0z" />
      <path fill="#4FBA6F" d="M5.86 2.76a.34.34 0 11-.69 0 .34.34 0 01.7 0z" />
      <path
        fill="#2C3E50"
        d="M3.1 6.55h4.14c.2 0 .35.16.35.35V10c0 .2-.16.34-.35.34H3.1a.34.34 0 01-.34-.34V6.9c0-.2.15-.35.34-.35z"
      />
      <path fill="#FDD7AD" d="M16.55 7.59a2.07 2.07 0 11-4.14 0 2.07 2.07 0 014.14 0z" />
      <path fill="#955BA5" d="M11.38 12.76c.4-1 1.63-1.73 3.1-1.73.82-.01 1.62.24 2.3.71.35.26.63.61.8 1.02h-6.2z" />
      <path fill="#35495E" d="M7.59 8.78l1.67 1.44c.3.29.74.04.74-.4V7.07c0-.44-.45-.68-.74-.4L7.59 7.92v.86z" />
    </g>
    <defs>
      <clipPath id="clip28"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="think">
    <path fill="#E6E7E8" d="M7.95 14.14h4.14a.69.69 0 110 1.38H7.95a.69.69 0 010-1.38z" />
    <path fill="#D1D4D1" d="M7.95 15.52h4.14a.69.69 0 110 1.38H7.95a.69.69 0 110-1.38z" />
    <path fill="#E6E7E8" d="M7.95 16.9h4.14a.69.69 0 110 1.38H7.95a.69.69 0 010-1.38z" />
    <path fill="#A5A5A4" d="M8.3 18.28h3.44v.34c0 .76-.61 1.38-1.38 1.38h-.69c-.76 0-1.38-.62-1.38-1.38v-.34z" />
    <path
      fill="#F0C419"
      d="M12.43 13.12v1.02H7.61v-1.05c-.01-.68-.37-1.3-.94-1.66a6.2 6.2 0 116.72-.01c-.59.36-.95 1-.96 1.7z"
    />
    <path
      fill="#F3D55B"
      d="M16.22 6.2a6.2 6.2 0 01-2.83 5.22c-.59.37-.95 1-.96 1.7v1.02h-2.41V0a6.2 6.2 0 016.2 6.2zM14.74 13.35a.34.34 0 01-.29-.15l-.4-.56a.34.34 0 11.58-.4l.39.57a.34.34 0 01-.28.54zM3.64 2.45a.34.34 0 01-.19-.05l-.58-.38a.34.34 0 01.38-.58l.58.37a.34.34 0 01-.19.64zM16.98 11.03a.34.34 0 01-.19-.06l-.58-.37a.34.34 0 01.37-.58l.58.37a.34.34 0 01-.18.64zM2.56 5.2h-.07l-.68-.12a.34.34 0 11.13-.68l.68.12a.34.34 0 01-.07.68zM18.16 8.03l-.06-.01-.68-.12a.34.34 0 11.12-.68l.68.12a.34.34 0 01-.06.69zM1.93 8.3a.34.34 0 01-.07-.67l.67-.15a.34.34 0 11.15.68L2 8.3h-.08zM17.43 4.94a.34.34 0 01-.07-.68l.67-.14a.34.34 0 11.15.67l-.68.15h-.07zM3.22 11.27a.34.34 0 01-.2-.63l.57-.4a.34.34 0 11.4.58l-.57.39a.34.34 0 01-.2.06zM16.25 2.23a.34.34 0 01-.2-.63l.57-.4a.34.34 0 11.4.58l-.57.39a.34.34 0 01-.2.06zM5.54 13.51a.35.35 0 01-.29-.53l.38-.58a.34.34 0 01.58.37l-.38.58a.34.34 0 01-.29.16z"
    />
    <path
      fill="#285680"
      d="M13.81 9.1c0 1.6-3.8 1.6-3.8 1.6s-3.78 0-3.78-1.6c-.04-.56.13-1.1.48-1.53a2.74 2.74 0 011.73-.72s0 .96 1.58 2.24c1.58-1.28 1.58-2.24 1.58-2.24.64.03 1.26.28 1.73.72.34.43.51.97.48 1.52z"
    />
    <path
      fill="#E6E7E8"
      d="M11.6 6.85s0 .96-1.58 2.24C8.44 7.81 8.44 6.85 8.44 6.85s.95.74 1.58.74c.63 0 1.58-.74 1.58-.74z"
    />
    <path
      fill="#F09372"
      d="M11.6 6.85s-.95.74-1.58.74c-.63 0-1.58-.74-1.58-.74.24-.34.44-.72.59-1.11H11c.15.4.34.77.59 1.11zM11.9 3.31c.12-.1.26-.13.4-.1.2.05.1.59.1.59-.1.28-.34.5-.63.56h-3.5a.92.92 0 01-.64-.56s-.1-.54.1-.6c.15-.02.3.02.4.11h3.78z"
    />
    <path
      fill="#FDD7AD"
      d="M11.9 2.59c-.07-1.15-1.75-1.2-1.75-1.2h-.27s-1.68.05-1.74 1.2c-.07 1.15.13 1.26.13 1.66 0 .4-.13.75.4 1.15.54.4.54.8 1.08.8h.54c.54 0 .54-.4 1.07-.8.54-.4.4-.74.4-1.15 0-.4.2-.51.14-1.66z"
    />
  </g>
  <g id="user-check">
    <path
      fill="#F09372"
      d="M12.32 4.41c.2-.2.5-.3.8-.24.4.13.2 1.35.2 1.35-.2.62-.67 1.1-1.28 1.3h-7a2 2 0 01-1.28-1.3s-.2-1.22.21-1.35c.3-.06.59.03.8.24h7.55z"
    />
    <path
      fill="#285680"
      d="M13.58 19.37c-1.65.4-3.34.61-5.04.63 0 0-8.42 0-8.42-3.51 0-1.16.23-2.45 1.07-3.33a6.1 6.1 0 013.84-1.58h7.02a6.77 6.77 0 012.12.47l-.6 7.32z"
    />
    <path fill="#B0D3F0" d="M19.9 15.86a4.14 4.14 0 11-8.28 0 4.14 4.14 0 018.28 0z" />
    <path
      fill="#FDD7AD"
      d="M12.04 6.57c0 .92.27 1.7-.8 2.63-.22.18-.41.38-.59.6-.55.68-.73 1.23-1.57 1.23H8c-.83 0-1.02-.55-1.57-1.23a4.42 4.42 0 00-.58-.6c-1.07-.92-.8-1.71-.8-2.63 0-.92-.4-1.18-.27-3.81S8.28 0 8.28 0h.53s3.36.13 3.5 2.76c.13 2.63-.27 2.89-.27 3.8z"
    />
    <path
      fill="#E6E7E8"
      d="M12.05 11.58s0 1.6-2.33 3.88l-.85-1.32-.33-.35a.7.7 0 00.7-.69v-.87c.95-.13 1.9-.35 2.81-.65zM8.21 13.71l-.01.08-.83 1.67c-2.34-2.28-2.34-3.88-2.34-3.88.92.3 1.86.52 2.82.65v.87c0 .26.14.49.36.61z"
    />
    <path
      fill="#C03A2B"
      d="M9.72 15.46c-.34.33-.73.67-1.18 1.03-.44-.36-.84-.7-1.17-1.03l.83-1.67.01-.08c.1.05.22.08.33.08l-.02-.69 1.2 2.36z"
    />
    <path
      fill="#F09372"
      d="M12.05 11.58c-.92.3-1.86.52-2.82.65 0-.09-.08-.16-.17-.16H8.02c-.09 0-.16.07-.17.16a16.6 16.6 0 01-2.82-.65 2.01 2.01 0 001.4-1.78c.55.68.74 1.23 1.57 1.23h1.08c.84 0 1.02-.55 1.57-1.23.06.82.61 1.53 1.4 1.78z"
    />
    <path
      fill="#E64C3C"
      d="M9.23 12.23v.87a.7.7 0 01-1.02.61.69.69 0 01-.36-.6v-.88c0-.09.08-.16.17-.16h1.04c.09 0 .17.07.17.16z"
    />
    <path
      fill="#24AE5F"
      d="M14.24 18.07l-.9-.89a.69.69 0 11.98-.97l.29.28c.06.07.17.07.24 0l2.35-2.35a.69.69 0 01.98.97l-2.96 2.96a.69.69 0 01-.98 0z"
    />
  </g>
  <g id="user-network">
    <path
      fill="#E57E25"
      d="M9.7517 2.7653C8.5717.5207 5.9386-.5374 3.5336.2666 1.1286 1.0706-.339 3.4995.068 6.0024c.407 2.503 2.5685 4.3417 5.1043 4.3422.0828 0 .1655-.0035.2483-.0069l4.331-7.5724z"
    />
    <path
      fill="#FDD7AD"
      d="M7.2275 3.5651A5.193 5.193 0 005.262 5.8582a.7497.7497 0 01-.0897.0035c-1.1132.0006-2.0274-.8797-2.0687-1.9922-.0414-1.1125.805-2.0582 1.9152-2.1402 1.1102-.082 2.0863.7293 2.2087 1.8358z"
    />
    <path
      fill="#E57E25"
      d="M10.2482 2.7653c1.18-2.2446 3.8131-3.3027 6.2181-2.4987 2.405.804 3.8725 3.2329 3.4655 5.7358-.407 2.503-2.5685 4.3417-5.1043 4.3422-.0828 0-.1655-.0035-.2483-.0069l-4.331-7.5724z"
    />
    <path
      fill="#FDD7AD"
      d="M16.8965 3.7927c0 1.1427-.9263 2.069-2.069 2.069a.749.749 0 01-.0896-.0035 5.1936 5.1936 0 00-1.9656-2.293c.1261-1.087 1.0767-1.888 2.1692-1.8276 1.0926.0603 1.9493.9609 1.955 2.0551z"
    />
    <path
      fill="#3D324C"
      d="M1.0344 16.551a.3448.3448 0 01-.3448-.3448v-4.8276a.345.345 0 01.0524-.1828l1.2138-1.9413a.3454.3454 0 01.5862.3655l-1.1628 1.8576v4.7286a.3448.3448 0 01-.3448.3448zM5.1725 16.5514a.3448.3448 0 01-.3449-.3448v-2.4138c0-.0626.0171-.124.0493-.1776l1.269-2.1138a.3449.3449 0 01.5914.3551l-1.22 2.0318v2.3183a.3448.3448 0 01-.3448.3448zM18.9656 16.551a.3448.3448 0 01-.3448-.3448v-4.7286L17.4597 9.62a.3455.3455 0 01.5862-.3655l1.2138 1.9413a.3446.3446 0 01.0507.1828v4.8276a.3448.3448 0 01-.3448.3448zM14.8275 16.5514a.3448.3448 0 01-.3448-.3448v-2.3183l-1.22-2.0318a.3448.3448 0 11.5913-.3551l1.269 2.1138a.345.345 0 01.0493.1776v2.4138a.3448.3448 0 01-.3448.3448zM10 18.276a.3448.3448 0 01-.3448-.3448v-4.8276a.3448.3448 0 01.6897 0v4.8276A.3448.3448 0 0110 18.276z"
    />
    <path
      fill="#F0C419"
      d="M18.862 8.4063a5.1576 5.1576 0 01-4.0345 1.9379 5.8792 5.8792 0 01-.2483-.0069 5.1722 5.1722 0 00.1621-4.4724.7207.7207 0 01.0862-.0034c1.969 0 3.6138 1.0862 4.0345 2.5448zM5.4206 10.3373a5.8773 5.8773 0 01-.2482.0069 5.1576 5.1576 0 01-4.0345-1.938c.4207-1.4585 2.0655-2.5447 4.0345-2.5447a.7212.7212 0 01.0862.0034 5.1724 5.1724 0 00.162 4.4724z"
    />
    <path
      fill="#955BA5"
      d="M15.1723 7.931c.0019 2.6532-2.0023 4.8782-4.6411 5.1528-2.6388.2745-5.0581-1.4903-5.6025-4.0869-.5444-2.5966.9624-5.1845 3.4893-5.993 2.5269-.8084 5.256.4244 6.3199 2.8548.2861.6534.434 1.359.4344 2.0724z"
    />
    <path
      fill="#FDD7AD"
      d="M10.0001 8.6204c1.1426 0 2.0689-.9264 2.0689-2.069 0-1.1427-.9263-2.069-2.0689-2.069-1.1427 0-2.069.9263-2.069 2.069 0 1.1426.9263 2.069 2.069 2.069z"
    />
    <path
      fill="#FF5364"
      d="M14.0344 11.1649a5.1684 5.1684 0 01-8.069 0C6.3861 9.7063 8.031 8.6201 10 8.6201c1.969 0 3.6138 1.0862 4.0345 2.5448zM10 19.9996c.5713 0 1.0344-.4631 1.0344-1.0345 0-.5713-.4631-1.0344-1.0345-1.0344-.5713 0-1.0344.4631-1.0344 1.0344 0 .5714.4631 1.0345 1.0344 1.0345zM14.8275 18.275c.5713 0 1.0345-.4631 1.0345-1.0345 0-.5713-.4632-1.0344-1.0345-1.0344-.5713 0-1.0345.4631-1.0345 1.0344 0 .5714.4632 1.0345 1.0345 1.0345zM18.9656 18.275c.5713 0 1.0345-.4631 1.0345-1.0345 0-.5713-.4632-1.0344-1.0345-1.0344-.5714 0-1.0345.4631-1.0345 1.0344 0 .5714.4631 1.0345 1.0345 1.0345zM1.0345 18.275c.5713 0 1.0345-.4631 1.0345-1.0345 0-.5713-.4632-1.0344-1.0345-1.0344-.5713 0-1.0345.4631-1.0345 1.0344 0 .5714.4632 1.0345 1.0345 1.0345zM5.1723 18.275c.5713 0 1.0345-.4631 1.0345-1.0345 0-.5713-.4632-1.0344-1.0345-1.0344-.5713 0-1.0345.4631-1.0345 1.0344 0 .5714.4632 1.0345 1.0345 1.0345z"
    />
  </g>
  <g id="earth-network">
    <path fill="#4482C3" d="M10 18.62a8.62 8.62 0 100-17.24 8.62 8.62 0 000 17.24z" />
    <path
      fill="#4FBA6F"
      d="M7.51 4.44c-.38.64-.06 1.4.2 2.09a1 1 0 01.09.71c-.1.2-.25.36-.44.47-.5.4-1 .78-1.51 1.16-.38.25-.7.58-.93.96-.4.77 0 1.68-.16 2.5-.1.48-1.25 1.85-1.84 2.6A8.62 8.62 0 017.62 1.7l.01.01c.66.48.84 1.4.4 2.08-.18.2-.36.42-.52.64zM18.62 10c0 .63-.07 1.25-.2 1.86-.38.08-.77-.02-1.05-.27-.45-.37-.82-.92-1.49-.84-.38.07-.7.3-.9.63-.56.9-.27 2.06-.75 2.97-.27.46-.63.85-1.06 1.16l-.02.02a.79.79 0 01-1.27-.73c.1-.81-.11-1.64-.6-2.3-.38-.52-.96-1-.96-1.64.01-.87 1.07-1.4 1.76-1.7a2 2 0 00.92-.77c.62-1.04-.34-1.85-.82-2.72a3.1 3.1 0 01.7-3.8A8.61 8.61 0 0118.62 10zM12.88 1.88l.02-.02M10.73 18.59a8.59 8.59 0 01-6.13-1.86l1.37-1.01c.2-.15.44-.22.68-.2.52.06.87.59 1.37.74.39.12.8 0 1.2.01a.6.6 0 01.24.06c.07.04.14.1.2.17.47.62.58 1.48 1.07 2.09z"
    />
    <path fill="#CC4B4C" d="M16.9 7.24a3.1 3.1 0 100-6.2 3.1 3.1 0 000 6.2z" />
    <path
      fill="#E6E7E8"
      d="M18.62 5.8c0 .4-.13.8-.37 1.12a3 3 0 01-2.7 0 1.83 1.83 0 01.7-2.78c.38.3.92.3 1.28 0a1.8 1.8 0 011.1 1.67z"
    />
    <path fill="#fff" d="M17.93 3.45c0 .32-.14.61-.4.8-.37.3-.9.3-1.27 0-.25-.19-.4-.48-.4-.8a1.03 1.03 0 012.07 0z" />
    <path fill="#E4C05C" d="M3.1 6.2a3.1 3.1 0 100-6.2 3.1 3.1 0 000 6.2z" />
    <path
      fill="#E6E7E8"
      d="M4.83 4.77c0 .4-.13.8-.37 1.11a3 3 0 01-2.7 0 1.83 1.83 0 01.7-2.78c.37.31.91.31 1.28 0a1.8 1.8 0 011.09 1.67z"
    />
    <path fill="#fff" d="M4.14 2.41c0 .32-.15.62-.4.81-.37.3-.9.3-1.27 0-.26-.19-.4-.49-.4-.8a1.03 1.03 0 012.07 0z" />
    <path fill="#CC66A1" d="M3.1 20a3.1 3.1 0 100-6.2 3.1 3.1 0 000 6.2z" />
    <path
      fill="#E6E7E8"
      d="M4.83 18.56c0 .4-.13.8-.37 1.12-.85.43-1.86.43-2.7 0a1.83 1.83 0 01.7-2.78c.37.3.91.3 1.28 0a1.8 1.8 0 011.09 1.66z"
    />
    <path fill="#fff" d="M4.14 16.2c0 .32-.15.62-.4.82-.37.3-.9.3-1.27 0-.26-.2-.4-.5-.4-.81a1.03 1.03 0 112.07 0z" />
  </g>
  <g id="disconnect">
    <g clip-path="url(#clip29)">
      <path
        fill="#894B9D"
        d="M7.33 12.23h1.1A2.57 2.57 0 0111 14.79v2.94c0 .2-.16.36-.37.36H.37a.37.37 0 01-.37-.36v-2.94a2.57 2.57 0 012.57-2.56h4.76z"
      />
      <path
        fill="#3D324C"
        d="M2.2 15.52v2.57h-.73v-2.57a.37.37 0 11.73 0zM9.53 15.52v2.57H8.8v-2.57a.37.37 0 11.73 0z"
      />
      <path fill="#955BA5" d="M6.74 9.8c-.22.62-.4 1.68.6 2.42a1.83 1.83 0 11-3.67 0c.98-.74.81-1.8.59-2.43h2.48z" />
      <path
        fill="#B49ACA"
        d="M10.27 6.36a1.1 1.1 0 01-1.3 1.08 3.77 3.77 0 01-2.23 2.35c-.8.31-1.68.31-2.48 0a3.77 3.77 0 01-2.22-2.35 1.1 1.1 0 11-.2-2.18V3.74C.44 2.54.73-.24.73-.24c1.1 2.2 5.86.37 7.7 1.47 1.83 1.1.73 4.03.73 4.03.6 0 1.1.5 1.1 1.1z"
      />
      <path
        fill="#2980BA"
        d="M16.4 14.64h1.07c1.4 0 2.53 1.13 2.53 2.53v2.88c0 .2-.16.36-.36.36H9.54a.36.36 0 01-.37-.36v-2.88c0-1.4 1.13-2.53 2.53-2.53h4.7z"
      />
      <path
        fill="#285680"
        d="M11.34 17.89v2.52h-.72V17.9a.36.36 0 11.72 0zM18.56 17.89v2.52h-.73V17.9a.36.36 0 11.73 0z"
      />
      <path fill="#3B97D3" d="M15.81 12.25c-.22.61-.39 1.66.58 2.39a1.8 1.8 0 01-3.6 0c.96-.73.8-1.78.57-2.4h2.45z" />
      <path
        fill="#84B5CB"
        d="M19.28 8.86a1.08 1.08 0 01-1.29 1.07 3.71 3.71 0 01-2.18 2.32c-.79.3-1.66.3-2.45 0a3.71 3.71 0 01-2.18-2.32 1.08 1.08 0 11-.2-2.14v-1.5C9.62 5.1 9.89 2.36 9.89 2.36c1.09 2.16 5.78.36 7.58 1.44 1.8 1.08.73 3.97.73 3.97.6 0 1.08.49 1.08 1.08z"
      />
      <path fill="#E64C3C" d="M16.55 6.9a3.45 3.45 0 100-6.9 3.45 3.45 0 000 6.9z" />
      <path fill="#fff" d="M18.5 3a.5.5 0 010 1h-4a.5.5 0 010-1h4z" />
    </g>
    <defs>
      <clipPath id="clip29"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="user-1">
    <g clip-path="url(#clip30)">
      <path
        fill="#FDD7AD"
        d="M18.338 15.666a4.746 4.746 0 00-2.235-2.847 3.033 3.033 0 10-4.697 0 4.746 4.746 0 00-2.236 2.847c-.15.54.067 1.115.536 1.422a7.54 7.54 0 008.095 0c.47-.307.687-.882.538-1.422z"
      />
      <path fill="#FDD7AD" d="M16.787 10.9a3.034 3.034 0 11-6.067 0 3.034 3.034 0 016.067 0z" />
      <path
        fill="#222"
        d="M17.801 17.088a7.539 7.539 0 01-8.095 0 1.288 1.288 0 01-.537-1.422 4.746 4.746 0 012.236-2.847 3.033 3.033 0 004.698 0 4.746 4.746 0 012.236 2.847c.149.54-.069 1.115-.538 1.422z"
      />
      <path
        fill="#7E57C2"
        d="M18.967 22.729c-2.753 0-6.003-.895-9.113-2.69-6.311-3.645-9.696-9.64-7.546-13.364 2.15-3.724 9.033-3.79 15.346-.147 6.311 3.645 9.696 9.64 7.546 13.364-1.09 1.889-3.4 2.837-6.233 2.837zM8.504 4.674c-2.5 0-4.507.81-5.445 2.434-1.912 3.311 1.33 8.775 7.228 12.18 5.899 3.405 12.251 3.481 14.162.17 1.911-3.31-1.331-8.774-7.228-12.179-3.004-1.734-6.125-2.605-8.717-2.605z"
      />
      <path
        fill="#EF5350"
        d="M8.541 22.729c-2.834 0-5.142-.948-6.233-2.837-2.15-3.725 1.235-9.72 7.546-13.364 6.312-3.644 13.195-3.578 15.346.147 2.15 3.725-1.235 9.72-7.546 13.364-3.11 1.795-6.36 2.69-9.113 2.69zm1.746-15.45c-5.897 3.405-9.14 8.869-7.228 12.18 1.911 3.31 8.264 3.234 14.162-.171 5.897-3.405 9.14-8.869 7.228-12.18-1.912-3.31-8.264-3.234-14.162.171z"
      />
      <path
        fill="#29B6F6"
        d="M2.487 4.4a1.733 1.733 0 110-3.466 1.733 1.733 0 010 3.466zm0-2.6a.867.867 0 100 1.734.867.867 0 000-1.734zM23.287 26.5a1.733 1.733 0 110-3.467 1.733 1.733 0 010 3.467zm0-2.6a.867.867 0 100 1.733.867.867 0 000-1.733z"
      />
      <path
        fill="#FFCA28"
        d="M13.754 26.5c-4.3 0-7.8-5.832-7.8-13s3.5-13 7.8-13 7.8 5.832 7.8 13-3.5 13-7.8 13zm0-25.133C9.93 1.367 6.82 6.81 6.82 13.5c0 6.69 3.11 12.133 6.934 12.133 3.823 0 6.933-5.442 6.933-12.133 0-6.69-3.11-12.133-6.933-12.133zM24.587 1.8a.433.433 0 01-.433-.433V.933a.433.433 0 11.867 0v.434c0 .24-.194.433-.434.433zM24.587 3.967a.433.433 0 01-.433-.433V3.1a.433.433 0 01.867 0v.434c0 .239-.194.433-.434.433zM23.72 2.666h-.433a.433.433 0 110-.866h.434a.433.433 0 110 .866zM25.887 2.666h-.433a.433.433 0 010-.866h.433a.433.433 0 110 .866zM2.487 24.333a.433.433 0 01-.433-.433v-.434a.433.433 0 01.867 0v.434c0 .24-.194.433-.434.433zM2.487 26.5a.433.433 0 01-.433-.433v-.433a.433.433 0 11.867 0v.433c0 .24-.194.433-.434.433zM1.62 25.2h-.433a.433.433 0 110-.867h.434a.433.433 0 110 .867zM3.787 25.2h-.433a.433.433 0 010-.867h.433a.433.433 0 010 .867z"
      />
      <path
        fill="#333"
        d="M16.492 13.066a3.033 3.033 0 01-5.477 0c.126-.089.256-.17.39-.247a3.033 3.033 0 004.697 0c.135.076.265.158.39.247z"
      />
    </g>
    <defs>
      <clipPath id="clip30"><path fill="#fff" d="M0 0h26v26H0z" transform="translate(.5 .5)" /></clipPath>
    </defs>
  </g>
  <g id="user-2">
    <path
      fill="#A7C7D3"
      d="M21.92 14.5h-3.1c-.52 0-.93.4-.93.91v3.72c0-.5-.4-.92-.92-.92h-3.1c-.51 0-.92.42-.92.92v2.45c0-.5-.41-.91-.92-.91H8.92c-.5 0-.92.4-.92.91v2.29c0-.51-.41-.92-.92-.92h-3.1c-.51 0-.93.4-.93.92v1.74h19.79v-10.2c0-.5-.41-.91-.92-.91z"
    />
    <path
      fill="#A7C7D3"
      d="M19.24 14.88a.39.39 0 01-.4-.38V.39a.39.39 0 11.78 0v14.1c0 .22-.17.4-.38.4zM8 25.61H3.05v-1.74c0-.51.42-.92.92-.92h3.11c.5 0 .92.4.92.92v1.74z"
    />
    <path fill="#89B4C9" d="M12.95 25.61H8v-4.03c0-.5.41-.91.92-.91h3.1c.52 0 .93.4.93.91v4.03z" />
    <path fill="#6C96B3" d="M17.9 25.61h-4.95v-6.48c0-.5.4-.92.92-.92h3.1c.51 0 .92.42.92.92v6.48z" />
    <path fill="#618AAA" d="M22.84 25.61h-4.95v-10.2c0-.5.41-.91.92-.91h3.11c.5 0 .92.4.92.91v10.2z" />
    <path fill="#2F5066" d="M24.21 26H1.76a.39.39 0 110-.78H24.2a.39.39 0 110 .78z" />
    <path
      fill="#FDB659"
      d="M19.24 4.08h4.97c.16 0 .23-.2.11-.3l-1.3-1.13a.17.17 0 010-.25l1.3-1.14c.12-.1.05-.3-.1-.3h-4.98v3.12z"
    />
    <path
      fill="#83D9FF"
      d="M19.63 5.54l-5.39 2.92c-.48.26-.61.72-.78 1.31l-1.07 3.8 1.42.48L15 12.5l1.03-3.08 2.7-1.65a1.99 1.99 0 00.9-2.22z"
    />
    <path
      fill="#5FC9ED"
      d="M19.63 5.54l-.62.33c-.1.54-.43 1.02-.92 1.32l-2.47 1.5a.77.77 0 00-.33.42l-.35 1.06a4 4 0 01-2.28 2.45l-.27.95 2.63-1.08 1.02-3.08 2.7-1.65a1.99 1.99 0 00.9-2.22z"
    />
    <path
      fill="#38627C"
      d="M15.02 12.49l1.55 1.83c.26.34.48.58.43.96l-.36 2.93h-.95l-.24-2.52a.42.42 0 00-.26-.35l-2.8-1.78 2.63-1.07z"
    />
    <path
      fill="#4F7693"
      d="M12.4 13.56l-.16 2.79c-.01.23.02.38-.07.55l-1.79 3.77h1l2.7-3.58c.15-.18.17-.43.22-.65l.72-3.95-2.63 1.07z"
    />
    <path
      fill="#FECBAA"
      d="M14.82 6.14l.45.86c.2.4.04.9-.36 1.1l-.34.18c-.4.2-.9.05-1.11-.36l-.44-.86c-.2-.4-.05-.9.36-1.1l.34-.18c.4-.2.9-.05 1.1.36z"
    />
  </g>
  <g id="user-3">
    <path
      fill="#547580"
      d="M2.69 4.6V3.26c0-1.49 1.2-2.7 2.69-2.7H23.3C24.8.57 26 1.78 26 3.27V16.7c0 1.48-1.2 2.69-2.69 2.69L2.69 4.6z"
    />
    <path
      fill="#ECF0F1"
      d="M20.62 4.6H2.7A2.69 2.69 0 000 7.3v13.44c0 1.49 1.2 2.7 2.69 2.7h17.93c1.49 0 2.69-1.21 2.69-2.7V7.3c0-1.48-1.2-2.69-2.69-2.69z"
    />
    <path
      fill="#84B5CB"
      d="M20.62 21.64c.5 0 .9-.4.9-.9V7.3c0-.5-.4-.9-.9-.9H2.7c-.5 0-.9.4-.9.9v13.45c0 .5.4.9.9.9h17.93z"
    />
    <path fill="#F0C419" d="M13.9 11.33a1.34 1.34 0 100-2.7 1.34 1.34 0 000 2.7z" />
    <path
      fill="#5D4C72"
      d="M21.52 12.67v8.07c0 .5-.4.9-.9.9h-4.48a15.25 15.25 0 00-3.93-5.82 16.93 16.93 0 019.3-3.15z"
    />
    <path
      fill="#955BA5"
      d="M16.14 21.64H2.69a.9.9 0 01-.9-.9v-8.96c1.5.03 6.44.44 10.42 4.04 1.74 1.6 3.09 3.6 3.93 5.82z"
    />
  </g>
  <g id="close">
    <path fill="#54747A" d="M8 .8L7.2 0 4 3.2.8 0 0 .8 3.2 4 0 7.2l.8.8L4 4.8 7.2 8l.8-.8L4.8 4 8 .8z" />
  </g>
  <g id="close-black">
    <path fill="#222" d="M8 .8L7.2 0 4 3.2.8 0 0 .8 3.2 4 0 7.2l.8.8L4 4.8 7.2 8l.8-.8L4.8 4 8 .8z" />
  </g>
  <g id="close-dark-green">
    <path
      fill="#54747A"
      d="M15.83 5.34l-1.17-1.17L10 8.83 5.34 4.17 4.17 5.34 8.82 10l-4.65 4.66 1.17 1.17L10 11.18l4.66 4.65 1.17-1.17L11.17 10l4.66-4.66z"
    />
  </g>
  <g id="education1">
    <path
      id="Shape"
      d="M1.55206 12.0686H0.862406C0.671963 12.0686 0.517578 11.9142 0.517578 11.7237C0.517578 11.5333 0.671963 11.3789 0.862406 11.3789H1.55206C1.7425 11.3789 1.89689 11.5333 1.89689 11.7237C1.89689 11.9142 1.7425 12.0686 1.55206 12.0686Z"
      fill="#7F8284"
    />
    <path
      id="Shape_2"
      d="M4.31036 12.0686H3.62071C3.43026 12.0686 3.27588 11.9142 3.27588 11.7237C3.27588 11.5333 3.43026 11.3789 3.62071 11.3789H4.31036C4.5008 11.3789 4.65519 11.5333 4.65519 11.7237C4.65519 11.9142 4.5008 12.0686 4.31036 12.0686Z"
      fill="#7F8284"
    />
    <path
      id="Shape_3"
      d="M11.8725 12.6589C11.8791 12.6522 11.8838 12.6439 11.8863 12.6348C11.8889 12.6409 11.8924 12.6467 11.8966 12.652C12.123 12.9895 12.2431 13.387 12.2414 13.7934C12.2414 14.936 11.3151 15.8623 10.1725 15.8623C9.02984 15.8623 8.10353 14.936 8.10353 13.7934C8.10191 13.387 8.22201 12.9895 8.44836 12.652C8.45256 12.6467 8.45604 12.6409 8.4587 12.6348C8.46118 12.6439 8.46593 12.6522 8.4725 12.6589H11.8725Z"
      fill="#FDD7AD"
    />
    <path
      id="Shape_4"
      d="M8.47278 12.6143C8.46702 12.6203 8.46235 12.6273 8.45898 12.6349L8.47278 12.6143Z"
      fill="#FDD7AD"
    />
    <path
      id="Shape_5"
      d="M11.8863 12.6349C11.883 12.6273 11.8783 12.6203 11.8726 12.6143L11.8863 12.6349Z"
      fill="#FDD7AD"
    />
    <path
      id="Shape_6"
      d="M13.6207 17.5855V19.6544C13.6207 19.8449 13.4663 19.9993 13.2758 19.9993H7.06895C6.87851 19.9993 6.72412 19.8449 6.72412 19.6544V17.5855C6.72412 16.6333 7.49604 15.8613 8.44826 15.8613H11.8965C12.8488 15.8613 13.6207 16.6333 13.6207 17.5855Z"
      fill="#3B97D3"
    />
    <path
      id="Shape_7"
      d="M8.79318 18.6202V19.9995H8.10352V18.6202C8.10352 18.4298 8.2579 18.2754 8.44835 18.2754C8.63879 18.2754 8.79318 18.4298 8.79318 18.6202Z"
      fill="#2980BA"
    />
    <path
      id="Shape_8"
      d="M12.2414 18.6202V19.9995H11.5518V18.6202C11.5518 18.4298 11.7061 18.2754 11.8966 18.2754C12.087 18.2754 12.2414 18.4298 12.2414 18.6202Z"
      fill="#2980BA"
    />
    <path
      id="Shape_9"
      d="M11.8966 10.3242L11.8965 12.5863C11.8968 12.6029 11.8933 12.6195 11.8862 12.6346C11.8837 12.6436 11.879 12.6519 11.8724 12.6587C11.7345 12.8759 11.0241 13.0346 10.1724 13.0346C9.32067 13.0346 8.61032 12.8759 8.47239 12.6587C8.46582 12.6519 8.46108 12.6436 8.4586 12.6346C8.45154 12.6195 8.448 12.6029 8.44825 12.5863V10.3518L11.8966 10.3242Z"
      fill="#35495E"
    />
    <path
      id="Shape_10"
      d="M13.1562 9.49514C13.2216 9.52138 13.2644 9.58472 13.2644 9.65514C13.2644 9.72556 13.2216 9.7889 13.1562 9.81514L11.8965 10.3241L10.2672 10.9824C10.1843 11.0159 10.0916 11.0159 10.0086 10.9824L8.44826 10.3517L6.72412 9.65514L10.0086 8.3279C10.0916 8.29435 10.1843 8.29435 10.2672 8.3279L13.1562 9.49514Z"
      fill="#3F5C6C"
    />
    <path
      id="Shape_11"
      d="M5.00019 7.16577C5.02146 7.82383 4.77223 8.46188 4.31054 8.93129C3.88193 9.34657 3.63416 9.91396 3.62088 10.5106V11.0347H1.55192V10.5934C1.5383 9.95733 1.2802 9.35098 0.831228 8.90026C0.161225 8.19241 -0.0173314 7.15107 0.378584 6.26044C0.7745 5.36982 1.66719 4.80469 2.64157 4.82783C3.91752 4.872 4.94479 5.89026 5.00019 7.16577Z"
      fill="#F0C419"
    />
    <path
      id="Shape_12"
      d="M4.31061 7.16559C4.33552 7.79121 4.16315 8.40882 3.81785 8.93111C3.49651 9.39502 3.3247 9.94609 3.32543 10.5104V11.0346H1.8475V10.5932C1.84815 9.99016 1.6689 9.40066 1.33268 8.90007C1.0151 8.40598 0.851398 7.82871 0.86233 7.24145C0.86233 5.88973 1.65302 4.80007 2.62612 4.82766C3.52509 4.85525 4.28371 5.90697 4.31061 7.16559Z"
      fill="#F3D55B"
    />
    <path
      id="Shape_13"
      d="M1.55186 7.58546C1.36142 7.58546 1.20703 7.43107 1.20703 7.24063C1.20703 6.47886 1.82457 5.86133 2.58634 5.86133C2.77678 5.86133 2.93117 6.01571 2.93117 6.20615C2.93117 6.3966 2.77678 6.55098 2.58634 6.55098C2.20546 6.55098 1.89669 6.85975 1.89669 7.24063C1.89669 7.43107 1.7423 7.58546 1.55186 7.58546Z"
      fill="white"
    />
    <path
      id="Shape_14"
      d="M3.62072 11.0352V12.0696C3.62072 12.641 3.15757 13.1041 2.58624 13.1041C2.01491 13.1041 1.55176 12.641 1.55176 12.0696V11.0352H3.62072Z"
      fill="#95A5A5"
    />
    <path
      id="Shape_15"
      d="M9.24451 0.676552L9.54347 0H10.8021L11.1011 0.676552L12.0317 1.23345L12.7466 1.1631L13.2762 2.11379L12.9314 2.72V3.83345L13.2762 4.44L12.7466 5.39035L12.0317 5.32034L11.1011 5.8769L10.8021 6.55379H9.54347L9.24451 5.8769L8.31382 5.32034L7.59899 5.39035L7.06934 4.44L7.41416 3.83345V2.72L7.06934 2.11379L7.59899 1.1631L8.31382 1.23345L9.24451 0.676552Z"
      fill="#3B97D3"
    />
    <path
      id="Oval"
      d="M10.1731 5.13716C11.1996 5.13716 12.0317 4.30503 12.0317 3.27854C12.0317 2.25205 11.1996 1.41992 10.1731 1.41992C9.14658 1.41992 8.31445 2.25205 8.31445 3.27854C8.31445 4.30503 9.14658 5.13716 10.1731 5.13716Z"
      fill="#285680"
    />
    <path
      id="Shape_16"
      d="M17.7179 8.15268L18.2665 9.17544L19.4314 9.33095C19.5648 9.34876 19.6756 9.44257 19.7153 9.5712C19.7549 9.69982 19.7161 9.83976 19.6158 9.92958L18.7934 10.6672L18.9941 11.743C19.0181 11.871 18.968 12.0015 18.8645 12.0805C18.7611 12.1596 18.6219 12.1736 18.5048 12.1168L17.4141 11.5892L16.3234 12.1168C16.2063 12.1736 16.0672 12.1596 15.9637 12.0805C15.8603 12.0015 15.8102 11.871 15.8341 11.743L16.0348 10.6672L15.2124 9.93096C15.1121 9.84114 15.0733 9.7012 15.113 9.57258C15.1526 9.44395 15.2635 9.35014 15.3969 9.33233L16.5617 9.17682L17.1103 8.15406C17.1702 8.04204 17.2867 7.97197 17.4137 7.97168C17.5407 7.97139 17.6576 8.04093 17.7179 8.15268Z"
      fill="#F0C419"
    />
    <g id="Group">
      <path
        id="Shape_17"
        d="M4.87255 4.57877C4.73293 4.57832 4.60736 4.49373 4.5545 4.36451C4.50163 4.23529 4.5319 4.08694 4.63117 3.98877C5.0021 3.6206 5.40987 3.29152 5.84806 3.0067C6.00759 2.91039 6.21476 2.95824 6.3159 3.11474C6.41704 3.27125 6.37554 3.47979 6.2222 3.58566C5.82355 3.84497 5.45253 4.14447 5.11496 4.47946C5.05049 4.54335 4.96331 4.57906 4.87255 4.57877Z"
        fill="#E57E25"
      />
      <path
        id="Shape_18"
        d="M14.4935 16.2333C14.3426 16.2334 14.2092 16.1354 14.1642 15.9914C14.1192 15.8475 14.1729 15.6909 14.2969 15.605C15.1755 14.9939 15.9092 14.1972 16.4459 13.2712C16.5411 13.1062 16.7521 13.0496 16.9171 13.1449C17.0821 13.2401 17.1387 13.4511 17.0435 13.6161C16.4554 14.6298 15.6519 15.5021 14.6897 16.1713C14.6321 16.2114 14.5637 16.2331 14.4935 16.2333Z"
        fill="#E57E25"
      />
      <path
        id="Shape_19"
        d="M5.85142 16.2343C5.78122 16.234 5.71277 16.2124 5.65521 16.1722C4.89338 15.6464 4.23132 14.9892 3.70004 14.2312C3.59313 14.0751 3.63189 13.8621 3.78691 13.7537C3.94194 13.6453 4.15534 13.682 4.26521 13.836C4.74973 14.5269 5.35341 15.126 6.04797 15.6053C6.17197 15.6912 6.22573 15.8477 6.18069 15.9917C6.13565 16.1357 6.00227 16.2337 5.85142 16.2336V16.2343Z"
        fill="#E57E25"
      />
      <path
        id="Shape_20"
        d="M16.7585 6.2375C16.6347 6.23812 16.52 6.17231 16.4581 6.06509C15.8872 5.06505 15.0865 4.21521 14.1223 3.58578C13.9685 3.47973 13.9271 3.27051 14.0289 3.1139C14.1308 2.95729 14.3388 2.91027 14.4981 3.00785C15.5546 3.69696 16.432 4.62737 17.0581 5.72233C17.1034 5.8018 17.1152 5.896 17.0911 5.98421C17.0669 6.07242 17.0086 6.14741 16.9291 6.19267C16.8772 6.22236 16.8183 6.23783 16.7585 6.2375Z"
        fill="#E57E25"
      />
    </g>
    <path
      id="Shape_21"
      d="M7.41378 9.93361V11.0336C7.41378 11.224 7.2594 11.3784 7.06895 11.3784C6.87851 11.3784 6.72412 11.224 6.72412 11.0336V9.6543L7.41378 9.93361Z"
      fill="#F3D55B"
    />
  </g>
  <g id="student-org">
    <path
      fill="#7F8284"
      d="M1.55 12.07H.86a.34.34 0 010-.7h.7a.34.34 0 110 .7zM4.31 12.07h-.69a.34.34 0 010-.7h.69a.34.34 0 010 .7z"
    />
    <path
      fill="#FDD7AD"
      d="M11.87 12.66l.02-.03v.02a2.07 2.07 0 11-3.44-.02l.02.03h3.4zM8.47 12.61l-.01.02.01-.02zM11.89 12.63l-.02-.02.02.02z"
    />
    <path
      fill="#3B97D3"
      d="M13.62 17.59v2.06c0 .2-.15.35-.34.35H7.07a.34.34 0 01-.35-.35V17.6c0-.96.78-1.73 1.73-1.73h3.45c.95 0 1.72.77 1.72 1.73z"
    />
    <path fill="#2980BA" d="M8.8 18.62V20h-.7v-1.38a.34.34 0 01.7 0zM12.24 18.62V20h-.69v-1.38a.34.34 0 11.7 0z" />
    <path
      fill="#35495E"
      d="M11.9 10.32v2.27a.1.1 0 01-.01.04l-.02.03c-.14.22-.85.37-1.7.37s-1.56-.15-1.7-.37l-.01-.03a.11.11 0 01-.01-.04v-2.24l3.45-.03z"
    />
    <path
      fill="#3F5C6C"
      d="M13.16 9.5a.17.17 0 010 .32l-1.26.5-1.63.66a.35.35 0 01-.26 0l-1.56-.63-1.73-.7 3.29-1.32a.34.34 0 01.26 0l2.89 1.17z"
    />
    <path
      fill="#F0C419"
      d="M5 7.17a2.4 2.4 0 01-.69 1.76c-.43.42-.68.98-.69 1.58v.52H1.55v-.44A2.47 2.47 0 00.83 8.9 2.41 2.41 0 115 7.17z"
    />
    <path
      fill="#F3D55B"
      d="M4.31 7.17c.03.62-.15 1.24-.5 1.76-.31.47-.49 1.02-.48 1.58v.52H1.85v-.44c0-.6-.18-1.19-.52-1.69a2.97 2.97 0 01-.47-1.66c0-1.35.8-2.44 1.77-2.41.9.03 1.65 1.08 1.68 2.34z"
    />
    <path
      fill="#fff"
      d="M1.55 7.59a.34.34 0 01-.34-.35c0-.76.61-1.38 1.38-1.38a.34.34 0 110 .7c-.38 0-.7.3-.7.68 0 .2-.15.35-.34.35z"
    />
    <path fill="#95A5A5" d="M3.62 11.04v1.03a1.03 1.03 0 11-2.07 0v-1.03h2.07z" />
    <path
      fill="#3B97D3"
      d="M9.24.68l.3-.68h1.26l.3.68.93.55.72-.07.53.95-.35.61v1.11l.35.61-.53.95-.72-.07-.93.56-.3.67H9.54l-.3-.67-.93-.56-.71.07-.53-.95.34-.6V2.71l-.34-.6.53-.96.71.07.93-.55z"
    />
    <path fill="#285680" d="M10.17 5.14a1.86 1.86 0 100-3.72 1.86 1.86 0 000 3.72z" />
    <path
      fill="#F0C419"
      d="M17.72 8.15l.55 1.03 1.16.15a.34.34 0 01.19.6l-.83.74.2 1.07a.34.34 0 01-.49.38l-1.09-.53-1.09.53a.34.34 0 01-.49-.38l.2-1.07-.82-.74a.34.34 0 01.19-.6l1.16-.15.55-1.03a.34.34 0 01.6 0z"
    />
    <path
      fill="#E57E25"
      d="M4.87 4.58a.34.34 0 01-.24-.6c.37-.36.78-.69 1.22-.97a.34.34 0 01.37.58c-.4.25-.77.55-1.1.89a.34.34 0 01-.25.1zM14.5 16.23a.34.34 0 01-.2-.63 7.3 7.3 0 002.15-2.33.34.34 0 11.6.35 8 8 0 01-2.36 2.55.35.35 0 01-.2.06zM5.85 16.23a.35.35 0 01-.2-.06 7.8 7.8 0 01-1.95-1.94.34.34 0 01.57-.4 7.1 7.1 0 001.78 1.78.34.34 0 01-.2.62zM16.76 6.24a.34.34 0 01-.3-.17 7.26 7.26 0 00-2.34-2.48.34.34 0 01.38-.58 7.96 7.96 0 012.56 2.71.35.35 0 01-.3.52z"
    />
    <path fill="#F3D55B" d="M7.41 9.93v1.1a.34.34 0 01-.69 0V9.65l.7.28z" />
  </g>
  <g id="close">
    <path fill="#828282" d="M8 .8L7.2 0 4 3.2.8 0 0 .8 3.2 4 0 7.2l.8.8L4 4.8 7.2 8l.8-.8L4.8 4 8 .8z" />
  </g>
  <g id="cancel">
    <rect width="26" height="26" fill="#F2F2F2" rx="13" />
    <path
      fill="#BDBDBD"
      d="M18.83 8.34l-1.17-1.17L13 11.83 8.34 7.17 7.17 8.34 11.83 13l-4.66 4.66 1.17 1.17L13 14.18l4.66 4.65 1.17-1.17L14.18 13l4.65-4.66z"
    />
  </g>
  <g id="close-box">
    <rect width="10" height="10" fill="#47979D" rx="2" />
    <path
      fill="#fff"
      d="M7.92 2.67l-.6-.59L5 4.41 2.67 2.08l-.59.6L4.41 5 2.08 7.33l.6.59L5 5.59l2.33 2.33.59-.6L5.59 5l2.33-2.33z"
    />
  </g>
  <g id="become">
    <g clip-path="url(#clip32)">
      <path
        fill="#4980AC"
        d="M17.5 9.95h-5.3c-.64 0-1.16.52-1.16 1.16V20h6.6v-4.03h.85c.7 0 1.25-.57 1.25-1.26V12.2c0-1.24-1-2.25-2.25-2.25z"
      />
      <path fill="#407194" d="M13 15.97h4.65v1.14H13v-1.14z" />
      <path fill="#5D91B9" d="M17.65 9.96v4.35h-2.78v1.66h3.62a1.25 1.25 0 001.25-1.26V12.2c0-1.2-.92-2.16-2.1-2.24z" />
      <path
        fill="#BE694E"
        d="M10.91.93v4.12h7.27V3.18c0-1.51-1.22-2.74-2.73-2.74h-2.28c-.23 0-.46-.06-.65-.18l-.18-.12a.93.93 0 00-1.43.8z"
      />
      <path fill="#EBAE9D" d="M13.44 6.75v3.4c0 .52.43.95.96.95h.3c.53 0 .95-.43.95-.95v-3.4h-2.2z" />
      <path fill="#FFCDBE" d="M10.58 5.05c0 .51.42.93.93.93h6.07a.93.93 0 100-1.86h-6.07a.93.93 0 00-.93.93z" />
      <path
        fill="#FFCDBE"
        d="M12.3 2.62v3.9c0 1.17.95 2.13 2.12 2.13h.25c1.18 0 2.13-.96 2.13-2.13V3.99c0-.82-.67-1.5-1.5-1.5h-2.88a.12.12 0 00-.12.13z"
      />
      <path
        fill="#E09380"
        d="M14.6 7.5h-.1a1 1 0 01-.7-.3.26.26 0 01.37-.37c.09.09.2.14.33.14h.1c.12 0 .24-.05.33-.14a.26.26 0 11.36.38 1 1 0 01-.7.28z"
      />
      <path
        fill="#80B6FC"
        d="M13.85 11.93h-8.3a.47.47 0 01-.47-.46v-1.7c0-.26.21-.47.47-.47h8.3c.26 0 .47.21.47.47v1.7c0 .25-.2.46-.47.46z"
      />
      <path
        fill="#62A4FB"
        d="M13.85 9.3h-1.13c.26 0 .47.21.47.47v6.85c0 .26-.21.47-.47.47h1.13c.26 0 .47-.2.47-.47V9.77c0-.26-.2-.47-.47-.47z"
      />
      <path
        fill="#DDEBFD"
        d="M13.85 18.46h-8.3a.47.47 0 01-.47-.47v-6.85c0-.26.21-.47.47-.47h8.3c.26 0 .47.2.47.47v6.85c0 .26-.2.47-.47.47z"
      />
      <path
        fill="#BED9FD"
        d="M14.32 11.14v6.85c0 .26-.2.47-.47.47h-1.13c.26 0 .47-.21.47-.47v-7.32h.66c.26 0 .47.2.47.47z"
      />
      <path fill="#DF646E" d="M8.57 12.16v2.3c0 .16.17.25.3.17l1.87-1.15a.2.2 0 000-.33l-1.87-1.16a.2.2 0 00-.3.17z" />
      <path fill="#5D91B9" d="M12.23 16.94H7.18a.26.26 0 110-.53h5.05a.26.26 0 010 .53z" />
      <path fill="#DF646E" d="M8.7 17.26a.63.63 0 10-.49-1.17.63.63 0 00.48 1.17z" />
      <path fill="#FFCDBE" d="M14.87 15.97h-.9a.75.75 0 01-.75-.75v-.9h1.65v1.65z" />
      <path
        fill="#FFCDBE"
        d="M13.62 14.84h-1.23a.26.26 0 110-.53h1.23a.26.26 0 110 .53zM9.55 19.62h-.96a.44.44 0 01-.44-.44v-.72H10v.72c0 .24-.2.44-.44.44z"
      />
      <path
        fill="#F5DE46"
        d="M4.45 11.94c2.32 0 4.2-1.9 4.2-4.25a4.22 4.22 0 00-4.2-4.25c-2.31 0-4.2 1.9-4.2 4.25a4.22 4.22 0 004.2 4.25z"
      />
      <path
        fill="#ECC52E"
        d="M7.65 4.93c.25.55.4 1.17.4 1.82A4.22 4.22 0 013.85 11a4.16 4.16 0 01-3.2-1.5 4.2 4.2 0 003.8 2.44 4.27 4.27 0 003.2-7z"
      />
      <path
        fill="#407194"
        d="M2.5 7.34v2.03c0 .1.07.19.17.21l1.68.44c.07.02.14.02.2 0l1.69-.44c.1-.02.16-.1.16-.2V7.33H2.5z"
      />
      <path
        fill="#5D91B9"
        d="M7.46 7.25l-2.95-.9a.21.21 0 00-.12 0l-2.94.9a.1.1 0 00-.07.05v1.19a.26.26 0 00.52 0v-.92l2.5.76h.11l2.95-.9c.1-.02.1-.15 0-.18z"
      />
    </g>
    <defs>
      <clipPath id="clip32"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="find">
    <path
      fill="#D6E4E8"
      d="M14.06 7.5a.31.31 0 01-.22-.53L15.4 5.4a.31.31 0 01.45.45L14.28 7.4a.31.31 0 01-.22.09zM4.37 15.31a.31.31 0 01-.22-.53l1.88-1.88a.31.31 0 01.44.45L4.6 15.22a.31.31 0 01-.23.1zM6.25 6.56a.31.31 0 01-.22-.09L3.84 4.28a.31.31 0 11.44-.44l2.2 2.19a.31.31 0 01-.23.53zM10 5a.31.31 0 01-.31-.31V3.44a.31.31 0 11.62 0v1.25A.31.31 0 0110 5zM17.19 12.19a.31.31 0 01-.14-.03l-2.5-1.25a.31.31 0 01.28-.56l2.5 1.25a.31.31 0 01-.14.59zM4.69 10.31H3.44a.31.31 0 110-.62h1.25a.31.31 0 110 .62zM11.25 17.81a.31.31 0 01-.3-.23l-.63-2.5a.31.31 0 01.6-.16l.63 2.5a.31.31 0 01-.3.4z"
    />
    <path
      fill="#D6E4E8"
      d="M17.19 6.56a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM2.81 19.06a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM2.81 5.31a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
    />
    <path fill="#BACED3" d="M3.75 4.38A2.5 2.5 0 011.58.64a2.5 2.5 0 103.4 3.4c-.37.22-.8.33-1.23.34z" />
    <path
      fill="#8E969B"
      d="M19.48 18.6l-4.94-4.94a.63.63 0 01-.07-.79 5.32 5.32 0 10-1.6 1.6.62.62 0 01.79.07l4.96 4.96a.62.62 0 00.95-.07.65.65 0 00-.09-.83zM10 14.06a4.06 4.06 0 110-8.12 4.06 4.06 0 010 8.12z"
    />
    <path
      fill="#778084"
      d="M14.54 13.66a.62.62 0 01-.12-.18.63.63 0 00-.61.05 5.29 5.29 0 01-5.34.23 4.07 4.07 0 01-2.23-2.21 5.17 5.17 0 01-.43-3.88c.19-.68.5-1.31.93-1.86a5.31 5.31 0 006.13 8.66.63.63 0 01.79.07l4.96 4.96a.62.62 0 00.95-.08.65.65 0 00-.09-.82l-4.94-4.94z"
    />
    <path fill="#FCAB68" d="M10 9.06a.94.94 0 100-1.87.94.94 0 000 1.87z" />
    <path fill="#EA8E49" d="M9.69 8.13a.93.93 0 01.62-.89.93.93 0 00-1.25.88.94.94 0 001.25.89.93.93 0 01-.62-.88z" />
    <path
      fill="#FCAB68"
      d="M17.19 3.75a.62.62 0 100-1.25.62.62 0 000 1.25zM10 9.06a2.19 2.19 0 00-2.19 2.19v.56a.63.63 0 00.36.57 4.05 4.05 0 003.66 0 .63.63 0 00.36-.57v-.56A2.19 2.19 0 0010 9.06z"
    />
    <path
      fill="#EA8E49"
      d="M9.55 11.63a1.24 1.24 0 01-.8-1.17v-.15c0-.35.08-.7.25-1a2.19 2.19 0 00-1.19 1.94v.56a.63.63 0 00.36.57 4.05 4.05 0 003.66 0 .63.63 0 00.36-.57v-.14c-.86.28-1.79.27-2.64-.04z"
    />
    <path
      fill="#FCAB68"
      d="M18.13 5.45c-.6.23-1.28.23-1.88 0a.48.48 0 01-.31-.45 1.25 1.25 0 012.5 0 .48.48 0 01-.31.45zM2.81 16.25a.62.62 0 100-1.25.62.62 0 000 1.25z"
    />
    <path
      fill="#FCAB68"
      d="M3.75 17.95c-.6.23-1.27.23-1.88 0a.48.48 0 01-.3-.45 1.25 1.25 0 012.5 0 .48.48 0 01-.32.45zM2.81 2.5a.62.62 0 100-1.25.62.62 0 000 1.25z"
    />
    <path
      fill="#FCAB68"
      d="M3.75 4.2c-.6.23-1.27.23-1.88 0a.48.48 0 01-.3-.45 1.25 1.25 0 012.5 0 .48.48 0 01-.32.45z"
    />
    <path
      fill="#EA8E49"
      d="M3.29 4.33a2.5 2.5 0 01-1.62-1.08c-.07.16-.1.33-.1.5a.48.48 0 00.3.45c.45.17.94.22 1.42.13z"
    />
    <path fill="#BACED3" d="M18.12 5.63a2.5 2.5 0 01-2.17-3.74 2.5 2.5 0 103.4 3.4c-.37.22-.8.33-1.23.34z" />
    <path
      fill="#EA8E49"
      d="M17.66 5.58a2.5 2.5 0 01-1.62-1.08c-.07.16-.1.33-.1.5a.48.48 0 00.3.45c.46.17.95.22 1.42.13z"
    />
    <path fill="#BACED3" d="M3.75 18.13a2.5 2.5 0 01-2.17-3.74 2.5 2.5 0 103.4 3.4c-.37.22-.8.33-1.23.34z" />
    <path
      fill="#EA8E49"
      d="M3.29 18.08A2.5 2.5 0 011.67 17c-.07.16-.1.33-.1.5a.48.48 0 00.3.45c.45.17.94.22 1.42.13z"
    />
    <path
      fill="#FCAB68"
      d="M10 3.44a.94.94 0 100-1.88.94.94 0 000 1.88zM17.5 12.81a.94.94 0 100-1.87.94.94 0 000 1.87zM11.25 18.44a.94.94 0 100-1.88.94.94 0 000 1.88zM2.5 10.94a.94.94 0 100-1.88.94.94 0 000 1.88z"
    />
    <path
      fill="#fff"
      d="M12.5 6.35a.31.31 0 01-.17-.05 4.38 4.38 0 00-.58-.31.31.31 0 11.25-.57c.23.1.45.22.67.35a.31.31 0 01-.17.58z"
    />
  </g>
  <g id="verified">
    <path fill="#3DB39E" d="M10 20a10 10 0 100-20 10 10 0 000 20z" />
    <path fill="#37A18E" d="M18.38 4.55L9.53 13.7l.02.99h.4l9.58-7.72c-.28-.86-.67-1.69-1.15-2.42z" />
    <path
      fill="#F2F1EF"
      d="M19.81 4.1l-1.76-1.74a.63.63 0 00-.88 0l-7.54 7.8-3.27-3.22a.63.63 0 00-.88 0L3.92 8.48a.61.61 0 000 .86l5.22 5.18c.14.14.33.18.52.17.18.01.37-.03.51-.17l9.64-9.54a.63.63 0 000-.87z"
    />
    <path
      fill="#E6E5E3"
      d="M10.17 14.52l9.64-9.54a.61.61 0 000-.86l-.28-.26-9.89 9.72-5.47-5.33-.23.23a.61.61 0 000 .86l5.22 5.18c.14.14.32.18.51.17.17.01.36-.03.5-.17z"
    />
  </g>
  <g id="college">
    <path fill="#3D4566" d="M15.44 5.65v2.97L10 10.88 4.56 8.62V5.65h10.88z" />
    <path fill="#2E2E4D" d="M15.44 5.65v2.97L10 10.88V5.65h5.44z" />
    <path
      fill="#F3F5F9"
      d="M18.16 13.85c0 .8-.68 1.46-1.51 1.46H2.09l-1.76-.58c.33 0 .6-.26.6-.59v-.59a.59.59 0 00-.6-.58l1.37-.59h14.95c.83 0 1.51.66 1.51 1.47z"
    />
    <path fill="#E1E6F0" d="M16.65 15.31H10v-2.93h6.65c.83 0 1.51.66 1.51 1.47 0 .8-.68 1.46-1.5 1.46z" />
    <path
      fill="#FFDF40"
      d="M19.07 13.85c0 1.13-.94 2.05-2.12 2.05l-1.67.58H4.56l-1.51-.58H.33v-1.17h16.62c.5 0 .9-.4.9-.88a.9.9 0 00-.9-.88H.33V11.8h7.86l.3.58h.6l.3-.58h7.56c1.18 0 2.12.91 2.12 2.05z"
    />
    <path
      fill="#FFBE40"
      d="M19.07 13.85c0 1.13-.94 2.05-2.12 2.05l-1.67.58H10v-1.75h6.95c.5 0 .91-.4.91-.88a.9.9 0 00-.9-.88H10V11.8h6.95c1.18 0 2.12.91 2.12 2.05z"
    />
    <path fill="#F3F5F9" d="M19.67 18.83l-1.71.58H1.84v-2.93h16.78l1.05.59c-.34 0-.6.26-.6.59v.58c0 .33.26.59.6.59z" />
    <path fill="#E1E6F0" d="M19.67 18.83l-1.71.58H10v-2.93h8.62l1.05.59c-.34 0-.6.26-.6.59v.58c0 .33.26.59.6.59z" />
    <path
      fill="#82E1D8"
      d="M2.14 17.95c0 .48.41.88.9.88h16.63V20H3.05a2.08 2.08 0 01-2.12-2.05c0-1.14.94-2.05 2.12-2.05h16.62v1.17H3.05c-.5 0-.9.4-.9.88z"
    />
    <path fill="#FFBE40" d="M16.65 4.64h1.21v5.98h-1.21V4.64z" />
    <path fill="#6DCDD6" d="M10 15.9h9.67v1.17H10V15.9z" />
    <path fill="#FF98CD" d="M8.19 11.8h1.2v5.86H8.2V11.8z" />
    <path fill="#4D5E80" d="M10 0L0 4.14 10 8.3l10-4.15L10 0z" />
    <path fill="#3D4566" d="M20 4.14L10 8.3V0l10 4.14z" />
    <path fill="#6DCDD6" d="M10 18.83h9.67V20H10v-1.17z" />
  </g>
  <g id="upload">
    <path
      fill="#00AB8D"
      d="M12.9 6.7a5 5 0 00-9.33-1.34A4 4 0 004 13.33h8.67A3.33 3.33 0 0016 10a3.32 3.32 0 00-3.1-3.3zm-.23 5.3H4a2.67 2.67 0 01-.3-5.31l.72-.08.33-.63a3.65 3.65 0 016.84.97l.2 1 1.02.08a1.99 1.99 0 01-.14 3.97zM5.33 8.67h1.7v2h1.94v-2h1.7L8 6 5.33 8.67z"
    />
  </g>
  <g id="group-icon">
    <path
      fill="#fff"
      d="M26.7 23.62a4.39 4.39 0 10-7.16-4.23h-3.66v-5.27h4.45c.49 0 .88-.4.88-.88a6.15 6.15 0 00-3.33-5.45 4.34 4.34 0 001.57-3.34A4.5 4.5 0 0015 0a4.5 4.5 0 00-4.45 4.45c0 1.28.55 2.48 1.57 3.34a6.15 6.15 0 00-3.33 5.45c0 .49.4.88.88.88h4.45v5.27h-3.66a4.4 4.4 0 10-7.16 4.23 6.22 6.22 0 00-3.3 5.5c0 .49.4.88.88.88h10.55c.48 0 .87-.4.87-.88a6.22 6.22 0 00-3.3-5.5 4.4 4.4 0 001.46-2.47h9.08c.2.98.73 1.84 1.46 2.47a6.22 6.22 0 00-3.3 5.5c0 .49.39.88.87.88h10.55c.49 0 .88-.4.88-.88a6.22 6.22 0 00-3.3-5.5zM6.14 17.64a2.64 2.64 0 110 5.28 2.64 2.64 0 010-5.28zm4.31 10.6H1.84a4.42 4.42 0 014.31-3.57c2.13 0 3.9 1.54 4.31 3.57zM15 1.76c1.46 0 2.7 1.23 2.7 2.7a2.7 2.7 0 01-5.4 0c0-1.47 1.24-2.7 2.7-2.7zm-4.36 10.6c.41-2 2.21-3.51 4.36-3.51a4.45 4.45 0 014.36 3.51h-8.72zm13.2 5.28a2.64 2.64 0 110 5.28 2.64 2.64 0 010-5.28zm-4.3 10.6a4.42 4.42 0 014.3-3.57c2.13 0 3.91 1.54 4.32 3.57h-8.62z"
    />
  </g>
  <g id="event-icon">
    <path
      fill="#fff"
      d="M25.6 21.21h-2.63v-2.64a.88.88 0 00-1.76 0v3.52c0 .49.4.88.88.88h3.52a.88.88 0 000-1.76zM7.91 15.94H4.39a.88.88 0 000 1.76h3.52a.88.88 0 000-1.76zM7.91 21.21H4.39a.88.88 0 000 1.76h3.52a.88.88 0 000-1.76z"
    />
    <path
      fill="#fff"
      d="M27.36 3.52h-.88v-.88a2.64 2.64 0 00-5.27 0v.88H17.7v-.88a2.64 2.64 0 00-5.28 0v.88H8.8v-.88a2.64 2.64 0 00-5.27 0v.88h-.88A2.64 2.64 0 000 6.15v19.46a2.64 2.64 0 002.64 2.63h14.48A7.92 7.92 0 0030 22.1V6.15a2.64 2.64 0 00-2.64-2.63zm-4.4-.88a.88.88 0 011.77 0v3.51a.88.88 0 01-1.76 0V2.64zM14.19 4.4V2.63a.88.88 0 011.76 0v3.51a.88.88 0 01-1.76 0V4.4zm-8.9-1.76a.88.88 0 011.75 0v3.51a.88.88 0 01-1.76 0V2.64zm16.81 25.6a6.16 6.16 0 11.01-12.32 6.16 6.16 0 01-.01 12.32zm6.15-11.12a7.9 7.9 0 00-11.16-1.14.88.88 0 00-.26-.04H13.3c-.48 0-.88.4-.88.88s.4.87.88.87h2.22a7.88 7.88 0 00-1.3 3.52h-.92a.88.88 0 000 1.76h.93c.14 1.29.6 2.49 1.29 3.51H2.64a.88.88 0 01-.88-.87V12.42h26.48v4.7zm0-6.46H1.76v-4.5c0-.5.4-.89.88-.89h.88v.88a2.64 2.64 0 005.27 0v-.88h3.63v.88a2.64 2.64 0 005.28 0v-.88h3.51v.88a2.64 2.64 0 005.27 0v-.88h.88c.49 0 .88.4.88.88v4.51z"
    />
  </g>
  <g id="circle-plus">
    <g clip-path="url(#clip33)">
      <path
        fill="#fff"
        d="M11.95 2.05A6.95 6.95 0 007 0C5.13 0 3.37.73 2.05 2.05A6.95 6.95 0 000 7c0 1.87.73 3.63 2.05 4.95A6.95 6.95 0 007 14c1.87 0 3.63-.73 4.95-2.05A6.95 6.95 0 0014 7c0-1.87-.73-3.63-2.05-4.95zM7 12.91a5.91 5.91 0 11.01-11.83A5.91 5.91 0 017 12.91zm.55-6.46H10v1.1H7.55V10h-1.1V7.55H4v-1.1h2.46V4h1.1v2.46z"
      />
    </g>
    <defs>
      <clipPath id="clip33"><path fill="#fff" d="M0 0h14v14H0z" /></clipPath>
    </defs>
  </g>
  <g id="smile-slim">
    <path
      fill="#828282"
      d="M13.66 2.34A7.95 7.95 0 008 0C5.86 0 3.85.83 2.34 2.34A7.95 7.95 0 000 8c0 2.14.83 4.15 2.34 5.66A7.95 7.95 0 008 16c2.14 0 4.15-.83 5.66-2.34A7.95 7.95 0 0016 8c0-2.14-.83-4.15-2.34-5.66zM8 14.75a6.76 6.76 0 11.02-13.52A6.76 6.76 0 018 14.75z"
    />
    <path
      fill="#828282"
      d="M12.12 9.12c-.33-.1-.68.07-.85.38-.12.22-.3.49-.52.76a3.6 3.6 0 01-5.43-.01 4.94 4.94 0 01-.58-.79c-.17-.3-.54-.46-.86-.34-.33.13-.49.49-.32.79.17.31.43.72.8 1.13a4.87 4.87 0 003.71 1.71c1.46 0 2.72-.6 3.66-1.72.34-.41.59-.82.74-1.14.16-.3-.02-.66-.35-.77zM5.25 6.63a1 1 0 100-2 1 1 0 000 2zM10.75 6.63a1 1 0 100-2 1 1 0 000 2z"
    />
  </g>
  <g id="down-arrow"><path fill="#54747A" d="M6 1.5l-3 3-3-3h6z" /></g>
  <g id="light-gray-down-arrow"><path fill="#A6A6A6" d="M7 0 4 3 1 0 0 1l4 4 4-4-1-1Z" /></g>
  <g id="green-down-arrow"><path d="M10.58 0 6 4.33 1.41 0 0 1.33 6 7l6-5.67L10.58 0Z" fill="#47979D" /></g>

  <!--  new design-->
  <g id="new-verified">
    <path
      fill="#47979D"
      d="M18.71 8.07c-.23-.2-.62-.5-.67-.66-.05-.15.08-.65.16-.95.18-.72.41-1.61-.1-2.32-.52-.7-1.44-.76-2.18-.8-.3-.03-.82-.06-.95-.15-.13-.1-.33-.59-.45-.88-.29-.72-.62-1.54-1.43-1.8-.8-.27-1.54.2-2.2.61-.28.18-.71.45-.89.45-.17 0-.6-.27-.88-.46-.63-.4-1.4-.9-2.23-.62-.8.27-1.14 1.09-1.43 1.8-.12.3-.31.77-.44.87-.13.1-.66.13-.97.15-.78.06-1.67.12-2.16.82-.5.7-.27 1.55-.08 2.3.08.3.2.8.16.95-.05.14-.44.46-.67.65C.72 8.5 0 9.1 0 10c0 .88.7 1.47 1.28 1.94.25.2.62.52.67.67.05.16-.08.65-.16.94-.19.73-.42 1.63.11 2.34.52.69 1.44.75 2.18.8.3.02.82.06.95.15.13.1.33.58.45.87.29.73.62 1.55 1.43 1.8.16.06.33.09.48.09.62 0 1.2-.37 1.71-.7.29-.17.72-.45.9-.45.18 0 .6.27.88.45.62.4 1.4.89 2.21.6.81-.27 1.14-1.08 1.43-1.8.12-.29.31-.77.45-.87.13-.1.65-.13.96-.15.77-.06 1.65-.11 2.16-.8.5-.7.29-1.57.1-2.33-.08-.3-.2-.79-.16-.94.05-.14.44-.46.66-.64.59-.48 1.31-1.08 1.31-1.97 0-.89-.71-1.47-1.29-1.93zm-1.07 2.62c-.48.4-.98.81-1.18 1.4-.2.6-.03 1.25.13 1.87.07.3.2.81.18.92a3 3 0 01-.95.15c-.61.04-1.31.09-1.83.47-.51.37-.76.99-1 1.58-.12.3-.32.78-.4.86-.15 0-.57-.27-.82-.43-.52-.33-1.11-.71-1.77-.71-.66 0-1.25.38-1.78.7-.25.17-.68.44-.77.46-.13-.1-.32-.58-.44-.87-.24-.6-.5-1.22-1.01-1.59-.52-.37-1.17-.41-1.81-.46a4.1 4.1 0 01-.96-.12c-.05-.15.08-.65.16-.95.15-.59.33-1.25.13-1.86-.2-.61-.72-1.05-1.18-1.44-.23-.18-.65-.53-.69-.66.04-.16.47-.52.7-.7.49-.4.99-.82 1.19-1.4.2-.61.03-1.26-.13-1.9-.08-.3-.2-.8-.2-.9.13-.09.64-.12.95-.15.65-.04 1.31-.08 1.83-.46s.76-1 1-1.59c.12-.29.32-.78.4-.85.15 0 .58.28.83.44.52.34 1.12.73 1.78.73.66 0 1.26-.38 1.78-.71.25-.16.68-.43.77-.45.13.09.32.57.44.86.24.6.5 1.22 1.01 1.6.52.37 1.18.41 1.81.45.32.03.84.06.94.12.05.15-.08.65-.15.95-.16.59-.33 1.26-.13 1.87.2.62.73 1.05 1.2 1.43.22.18.61.5.67.65-.05.16-.47.5-.7.7z"
    />
    <path
      fill="#47979D"
      d="M13.7 6.88a.82.82 0 00-1.17.1L8.85 11.4 7.28 9.82A.83.83 0 106.1 11l2.2 2.21c.16.16.37.24.6.24h.03a.82.82 0 00.6-.3l4.26-5.1a.83.83 0 00-.1-1.16z"
    />
  </g>
  <g id="new-edit">
    <path fill="#47979D" d="M5 10c-.17.83-.5 2.6-.5 3h3l8-7-3-3.5L5 10z" />
    <path
      fill="#000"
      d="M15.67.42a1.43 1.43 0 00-2.03 0l-2.22 2.21H1.95C.87 2.63 0 3.5 0 4.58v13.48C0 19.13.87 20 1.95 20h11.44c1.08 0 1.95-.87 1.95-1.94V6.59l2.24-2.24a1.43 1.43 0 000-2.02L15.67.42zm-2.58 3.64l.82.82.56.56-.56.56-6.39 6.37a.51.51 0 01-.26.14l-1.62.31-.08.01a.4.4 0 01-.4-.49l.31-1.62c.02-.1.07-.19.14-.26l6.4-6.4.54-.53.54.53zm2.39.36l-.17-.16-1.6-1.6-.14-.14 1.08-1.09 1.92 1.91-1.09 1.08zm-1.57 13.64c0 .28-.23.5-.52.5H1.95a.51.51 0 01-.52-.5V4.58c0-.29.23-.52.52-.52h8.04l-5.4 5.39c-.27.27-.45.62-.53 1l-.31 1.62a1.83 1.83 0 001.8 2.2c.12 0 .24-.02.36-.04l1.62-.32c.39-.07.73-.26 1-.53l5.38-5.36v10.04z"
    />
  </g>
  <g id="new-location">
    <g fill="#7E57C2" clip-path="url(#clip0)">
      <path d="M9 7.5A2.25 2.25 0 109 3a2.25 2.25 0 000 4.5zm0-3A.75.75 0 119 6a.75.75 0 010-1.5z" />
      <path
        d="M8.02 13.97l.31.62a.75.75 0 001.34 0l.65-1.3c.65-1.3 1.26-2.32 2.66-4.52l.04-.06.42-.66a5.25 5.25 0 10-8.67.3 36.04 36.04 0 013.25 5.63zM5.3 4.71a3.75 3.75 0 116.89 2.53l-.43.67-.03.05A49.02 49.02 0 009 12.58a33.95 33.95 0 00-3.02-5.12 3.73 3.73 0 01-.7-2.75z"
      />
      <path
        d="M13.67 11a.75.75 0 10-.34 1.46c2 .48 3.17 1.24 3.17 1.79 0 1.04-3.34 2.25-7.5 2.25s-7.5-1.21-7.5-2.25c0-.55 1.16-1.3 3.17-1.79A.75.75 0 104.33 11C1.69 11.63 0 12.74 0 14.25 0 16.53 4.05 18 9 18s9-1.47 9-3.75c0-1.5-1.7-2.62-4.33-3.25z"
      />
    </g>
    <defs>
      <clipPath id="clip0"><path fill="#fff" d="M0 0h18v18H0z" /></clipPath>
    </defs>
  </g>
  <g id="new-members">
    <path
      fill="#29B6F6"
      d="M19.89 7.47A2.2 2.2 0 0017.09 6c-.57.2-1.02.62-1.28 1.14a3.03 3.03 0 00-2.68-.8 3.3 3.3 0 00-1.56-2.4c.4-.42.65-1 .65-1.63 0-1.27-1-2.3-2.22-2.3a2.26 2.26 0 00-2.22 2.3c0 .64.25 1.21.65 1.63a3.3 3.3 0 00-1.56 2.4 3.03 3.03 0 00-2.68.8C3.93 6.61 3.49 6.2 2.9 6a2.13 2.13 0 00-1.69.14c-.53.28-.92.76-1.1 1.34-.18.59-.14 1.21.13 1.76a2.23 2.23 0 001.98 1.26c.35 0 .7-.09 1-.25a3.2 3.2 0 001.72 2.28 3.37 3.37 0 00-.1 2.9c-.58.1-1.1.43-1.44.92a2.37 2.37 0 00.49 3.22 2.15 2.15 0 003.1-.5c.35-.52.48-1.14.39-1.72a3.04 3.04 0 002.62-1 3.1 3.1 0 002.62 1c-.09.58.04 1.2.4 1.71.43.62 1.1.95 1.8.95.44 0 .9-.14 1.3-.44.98-.75 1.2-2.19.48-3.22a2.2 2.2 0 00-1.44-.92 3.4 3.4 0 00-.1-2.9 3.2 3.2 0 001.72-2.28 2.15 2.15 0 001.69.14c.56-.2 1.02-.6 1.29-1.15.27-.55.31-1.17.13-1.76zM3.21 8.52c-.18.57-.77.88-1.32.7a1.1 1.1 0 01-.67-1.37c.09-.28.27-.5.52-.63a1 1 0 01.8-.07c.55.19.85.8.67 1.37zM10 1.22c.58 0 1.04.49 1.04 1.08 0 .6-.46 1.1-1.04 1.1-.58 0-1.04-.5-1.04-1.1 0-.6.46-1.08 1.04-1.08zm0 3.5c.98 0 1.8.74 1.96 1.72H8.04C8.2 5.46 9.02 4.7 10 4.7zM4.54 10.5a2.13 2.13 0 01-.12-1.57 2 2 0 012.18-1.4L5.4 11.4c-.37-.2-.67-.5-.86-.9zm1.5 7.83c-.34.49-1 .6-1.46.25a1.12 1.12 0 01-.23-1.52 1 1 0 011.46-.24c.46.35.56 1.03.23 1.51zm2-2.21a1.92 1.92 0 01-1.49-.37 2.12 2.12 0 01-.61-2.6l3.17 2.4c-.3.3-.67.5-1.08.57zm1.96-1.4l-3.57-2.7 1.36-4.37h4.42l1.36 4.37-3.57 2.7zm3.45 1.03a1.92 1.92 0 01-2.56-.2l3.17-2.4a2.12 2.12 0 01-.61 2.6zm2.2 1.3c.34.5.24 1.17-.23 1.52-.46.36-1.12.25-1.46-.24a1.12 1.12 0 01.24-1.51 1 1 0 01.77-.2c.28.05.52.2.68.44zm-.2-6.55c-.18.4-.48.7-.84.9L13.4 7.52c.94-.14 1.88.44 2.18 1.4.16.53.12 1.1-.12 1.58zm3.26-1.82c-.12.26-.34.45-.6.54a1.04 1.04 0 01-1.32-.7 1.1 1.1 0 01.67-1.37 1 1 0 01.32-.05c.44 0 .85.29 1 .75.08.27.06.57-.07.83z"
    />
  </g>
  <g id="new-like">
    <path
      fill="url(#paint0_linear)"
      d="M13.99 16.17c.07-.92.35-1.8.83-2.58.46-.74 1.06-1.38 1.46-2.17.8-1.57 1.17-2.68 1.02-4.46a6.7 6.7 0 00-2.05-4.23A6.28 6.28 0 0011 1a6.28 6.28 0 00-4.25 1.73A6.7 6.7 0 004.7 6.96a7.2 7.2 0 001.02 4.46c.4.79 1 1.43 1.45 2.18.48.77.76 1.65.84 2.58H14z"
    />
    <path
      fill="#A5A5A4"
      d="M13.67 18.24v1.73c0 .27-.1.53-.3.73-.18.19-.44.3-.7.3H9.33a.95.95 0 01-.77-.37 1.06 1.06 0 01-.23-.66v-1.73h5.34z"
    />
    <path
      fill="url(#paint1_linear)"
      d="M3 7.9H1.33a.33.33 0 01-.23-.1.35.35 0 010-.5c.06-.06.15-.1.23-.1H3c.1 0 .18.04.24.1a.35.35 0 010 .5.33.33 0 01-.24.1zm-.37 5a.32.32 0 01-.2-.07.35.35 0 01-.1-.4.34.34 0 01.13-.18l1.45-.86a.32.32 0 01.26-.03c.08.02.15.08.2.16.04.08.05.18.03.26a.34.34 0 01-.16.21l-1.44.86a.32.32 0 01-.17.04zm16.74 0a.32.32 0 01-.17-.05L17.76 12a.34.34 0 01-.16-.2.35.35 0 01.03-.27.34.34 0 01.2-.16.32.32 0 01.26.03l1.45.86c.06.04.11.1.14.17a.35.35 0 01-.1.4.32.32 0 01-.21.07zm1.3-5H19a.33.33 0 01-.24-.1.35.35 0 010-.5c.06-.06.15-.1.24-.1h1.67c.08 0 .17.04.23.1a.35.35 0 010 .5.33.33 0 01-.23.1zm-2.74-4.14a.32.32 0 01-.21-.06.35.35 0 01-.1-.4.34.34 0 01.14-.18l1.44-.86a.32.32 0 01.45.12.35.35 0 01-.11.47l-1.45.87a.32.32 0 01-.16.04zm-13.86 0a.32.32 0 01-.17-.04l-1.44-.87a.35.35 0 01-.1-.45.33.33 0 01.2-.16.32.32 0 01.23.02l1.45.86a.35.35 0 01.04.58.32.32 0 01-.2.06z"
    />
    <path
      fill="#D1D4D1"
      d="M8.33 16.17h5.34c.26 0 .52.11.7.3a1.05 1.05 0 010 1.47c-.18.19-.44.3-.7.3H8.33a.98.98 0 01-.7-.3 1.05 1.05 0 010-1.47c.18-.19.44-.3.7-.3z"
    />
    <defs>
      <linearGradient id="paint0_linear" x1="11" x2="11" y1="1" y2="16.18" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FED44D" />
        <stop offset="1" stop-color="#F07622" />
      </linearGradient>
      <linearGradient id="paint1_linear" x1="11" x2="11" y1="2.21" y2="12.89" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FED44D" />
        <stop offset="1" stop-color="#F07622" />
      </linearGradient>
    </defs>
  </g>
  <g id="new-comment">
    <path
      fill="#29B6F6"
      d="M16.55 6.65v7.28c0 .94-.76 1.7-1.7 1.7H7.6l-3.45 3.8v-3.8H1.7a1.7 1.7 0 01-1.7-1.7V6.65c0-.93.76-1.7 1.7-1.7h13.15c.94 0 1.7.77 1.7 1.7z"
    />
    <path
      fill="#288FBE"
      d="M18.3.12H5.15c-.94 0-1.7.76-1.7 1.7v3.12h11.4c.94 0 1.7.77 1.7 1.7v4.17h1.75c.94 0 1.7-.76 1.7-1.7V1.8c0-.93-.76-1.7-1.7-1.7z"
    />
    <path
      fill="#fff"
      d="M3.8 11.5a1.04 1.04 0 100-2.07 1.04 1.04 0 000 2.07zm4.48 0a1.04 1.04 0 100-2.07 1.04 1.04 0 000 2.07zm4.48 0a1.04 1.04 0 100-2.07 1.04 1.04 0 000 2.07z"
    />
  </g>
  <g id="new-share">
    <path
      fill="#6F3BC9"
      d="M12.46 3.69v-.87a.72.72 0 011.21-.52l6.15 5.5a.7.7 0 010 1.04l-6.15 5.5a.72.72 0 01-1.2-.53V3.69z"
    />
    <path
      fill="#7E57C2"
      d="M.05 11.42v5.86c.24-5.86 6.55-5.86 6.55-5.86h2.42a.7.7 0 01.7.7v1.7a.72.72 0 001.2.52l1.54-1.4 4.6-4.1a.7.7 0 000-1.05l-4.6-4.1-1.55-1.4a.72.72 0 00-1.2.53v1.7a.7.7 0 01-.7.7h-2.4S.05 5.2.05 11.4z"
    />
  </g>
  <g id="new-bookmark">
    <path fill="#EF5350" d="M12 3.2V20l-6-4.1L0 20V3.2h12z" />
    <path fill="#CC2B1A" d="M0 0h12v5H0V0z" />
  </g>
  <g id="new-gear">
    <path
      fill="#789FA6"
      d="M7.55 3.1l.69-1.87c.1-.26.34-.45.61-.45h2.31c.27 0 .52.19.62.45l.67 1.86 2.74 1.64 1.89-.32c.27-.04.54.09.68.33l1.15 2.08c.14.25.11.55-.06.78l-1.23 1.54v3.3l1.22 1.52c.17.23.2.53.06.79l-1.15 2.07a.68.68 0 01-.3.28.64.64 0 01-.38.06l-1.9-.33-2.73 1.65-.67 1.86a.69.69 0 01-.24.32.65.65 0 01-.38.12h-2.3a.65.65 0 01-.38-.12.69.69 0 01-.24-.32l-.68-1.86-2.74-1.65-1.88.33a.64.64 0 01-.4-.06.67.67 0 01-.29-.28L1.1 14.75a.71.71 0 01.07-.78l1.21-1.54V9.14L1.16 7.62a.7.7 0 01-.07-.8l1.15-2.07a.68.68 0 01.3-.27.64.64 0 01.39-.06l1.88.32 2.74-1.63z"
    />
    <path
      fill="#54747A"
      d="M10 16.64c1.5 0 2.92-.62 3.98-1.72a5.97 5.97 0 000-8.27A5.53 5.53 0 0010 4.94c-1.5 0-2.93.61-3.99 1.71a5.97 5.97 0 000 8.27A5.53 5.53 0 0010 16.64z"
    />
    <path
      fill="#fff"
      d="M6.68 11.81a.96.96 0 00.77-.26 1.04 1.04 0 00.33-.77 1.07 1.07 0 00-.33-.77.99.99 0 00-.77-.26.98.98 0 00-.64.34 1.06 1.06 0 000 1.39c.17.19.4.3.64.33zm3.32 0a.96.96 0 00.77-.26 1.03 1.03 0 00.32-.77 1.07 1.07 0 00-.32-.77.99.99 0 00-.77-.26.98.98 0 00-.64.34 1.06 1.06 0 000 1.39c.16.19.4.3.64.33zm3.31 0a.96.96 0 00.77-.26 1.03 1.03 0 00.33-.77 1.07 1.07 0 00-.33-.77.99.99 0 00-.77-.26.98.98 0 00-.64.34 1.06 1.06 0 000 1.39c.17.19.4.3.64.33z"
    />
  </g>
  <g id="new-send">
    <path
      fill="#47979D"
      d="M20.85.1L.35 12.14c-.1 0-.18.03-.25.1a.35.35 0 00.25.6l5.84 2.64 1.49 6.5 4.53-3.42 5.23 2.99a.35.35 0 00.61-.26l3.23-16.9.7-3.52a.8.8 0 00-.33-.73.78.78 0 00-.8-.06z"
    />
    <path
      fill="#54747A"
      d="M19.62 4.05l-.08.09-9.25 13.28L7.67 22l-1.4-6.42L19.02 3.7a.36.36 0 01.35-.18.35.35 0 01.3.26.36.36 0 01-.04.27z"
    />
    <path
      fill="#47979D"
      d="M21.98.89l-.7 3.51-3.23 16.9a.35.35 0 01-.2.35.35.35 0 01-.4-.09l-5.24-3-1.92-1.13 9.25-13.2a.35.35 0 000-.18.35.35 0 00-.15-.34.35.35 0 00-.38-.01L6.2 15.58.35 12.85A.35.35 0 010 12.5a.35.35 0 01.35-.35L20.85.09a.78.78 0 011.1.44c.06.14.06.3.03.44V.9z"
    />
    <path fill="#40ABB4" d="M12.21 18.48v.09L7.68 22l2.61-4.58 1.92 1.15v-.09z" />
  </g>
  <g id="new-invite">
    <path
      fill="#222"
      d="M5.348 8.475c.546.23 1.125.346 1.721.346a4.409 4.409 0 003.125-1.289 4.386 4.386 0 000-6.225A4.405 4.405 0 007.07.017a4.409 4.409 0 00-3.125 1.29 4.384 4.384 0 00-.947 4.826c.223.525.541.995.947 1.399.405.404.878.721 1.404.943zM7.07 1.449a2.977 2.977 0 012.983 2.97c0 1.641-1.335 2.971-2.983 2.971a2.977 2.977 0 01-2.983-2.97c0-1.641 1.336-2.971 2.983-2.971z"
    />
    <path
      fill="#222"
      d="M7.068 8.837a4.425 4.425 0 01-3.137-1.294 4.4 4.4 0 01-.95-4.845A4.421 4.421 0 017.068 0a4.425 4.425 0 013.138 1.294 4.401 4.401 0 010 6.249 4.422 4.422 0 01-3.138 1.294zm0-8.804a4.392 4.392 0 00-3.113 1.285 4.367 4.367 0 00-.943 4.808c.222.522.539.991.943 1.393a4.388 4.388 0 003.113 1.285 4.392 4.392 0 003.114-1.285 4.367 4.367 0 00.943-4.808 4.367 4.367 0 00-.943-1.393A4.387 4.387 0 007.068.033zm0 7.373c-1.654 0-3-1.34-3-2.987a2.997 2.997 0 013-2.988c1.654 0 3 1.34 3 2.988a2.997 2.997 0 01-3 2.987zm0-5.942A2.964 2.964 0 004.102 4.42a2.964 2.964 0 002.966 2.954 2.964 2.964 0 002.967-2.954 2.964 2.964 0 00-2.967-2.955z"
    />
    <path fill="#47979D" d="M11.482 16.5v-2l1-2 2.5-1.5 1.5.5 1.5 1 1 2v2l-.5 1-2 1.5h-2l-2-1-1-1.5z" />
    <path
      fill="#222"
      d="M19.599 13.516a4.638 4.638 0 00-1.002-1.48 4.663 4.663 0 00-3.306-1.364 4.662 4.662 0 00-2.415.67 5.113 5.113 0 00-1.871-1.351 5.12 5.12 0 00-1.999-.403H5.133a5.12 5.12 0 00-3.63 1.497A5.09 5.09 0 000 14.7v2.46c0 1.15.94 2.087 2.097 2.087h9.945a2.1 2.1 0 00.595-.085 4.673 4.673 0 002.654.822 4.663 4.663 0 003.306-1.363 4.639 4.639 0 001.002-5.105zm-4.308 5.037a3.234 3.234 0 01-3.238-3.225 3.2 3.2 0 011.018-2.347 3.233 3.233 0 012.22-.877 3.232 3.232 0 013.239 3.225 3.232 3.232 0 01-3.239 3.224zm-13.194-.737a.659.659 0 01-.66-.657V14.7a3.689 3.689 0 013.696-3.68h3.873c1.102 0 2.091.48 2.768 1.242a4.631 4.631 0 00-1.157 3.067 4.612 4.612 0 00.722 2.488H2.097z"
    />
    <path
      fill="#F2F2F2"
      d="M16.872 14.612h-.861v-.857a.717.717 0 00-.718-.716.717.717 0 00-.719.716v.857h-.86a.717.717 0 00-.292 1.369c.089.04.188.062.291.062h.861v.857c0 .395.322.715.719.715.396 0 .718-.32.718-.715v-.857h.86c.398 0 .72-.32.72-.716a.717.717 0 00-.72-.715z"
    />
  </g>
  <g id="new-files">
    <path
      fill="#828282"
      d="M7.37 4.09A.84.84 0 007.15 4a.84.84 0 00-.24 0 .83.83 0 00-.2.04.76.76 0 00-.16.09c-.02 0-.03.02-.04.03l-.04.02-2.25 2c-.3.26-.3.69 0 .95.15.13.34.2.53.2a.8.8 0 00.53-.2l.97-.87v5.06c0 .37.34.67.75.67s.75-.3.75-.67V6.27l.97.87c.3.26.77.26 1.06 0 .3-.26.3-.69 0-.95l-2.25-2a.74.74 0 00-.16-.1z"
    />
    <path
      fill="#828282"
      d="M10.74.2a.6.6 0 00-.44-.2H.62C.28 0 0 .3 0 .67v14.66c0 .37.28.67.62.67h12.76c.34 0 .62-.3.62-.67V4a.7.7 0 00-.18-.47L10.74.2zm2.03 14.47H1.23V5.35 3.53v-2.2h8.82l2.72 2.95v10.39z"
    />
  </g>
  <g id="new-photo">
    <path
      fill="#828282"
      d="M13.86 0H2.14C.96 0 0 .98 0 2.18v11.64C0 15.02.96 16 2.14 16h11.72c1.18 0 2.14-.98 2.14-2.18V2.18C16 .98 15.04 0 13.86 0zm.98 13.82c0 .4-.59.98-.98.98H2.14c-.4 0-.9-.58-.9-.98V9.6l3.2-4.4 1.6 2-2.61 3.57a.6.6 0 10.98.7l3.42-4.83 5 6.56h2v.62zm0-1.9h-1.58L7.83 4.74 6.75 6.3 4.38 3.3 1.24 7.6V2.18c0-.4.5-.98.9-.98h11.72c.4 0 .98.58.98.98v9.75z"
    />
    <path
      fill="#828282"
      d="M11.64 2.4a2 2 0 100 4 2 2 0 000-4zm0 2.8c-.4 0-.8-.43-.8-.8 0-.37.4-.8.8-.8s.8.4.8.8c0 .37-.4.8-.8.8z"
    />
  </g>
  <g id="new-smile">
    <path
      fill="#828282"
      d="M13.66 2.34A7.95 7.95 0 008 0C5.86 0 3.85.83 2.34 2.34A7.95 7.95 0 000 8c0 2.14.83 4.15 2.34 5.66A7.95 7.95 0 008 16c2.14 0 4.15-.83 5.66-2.34A7.95 7.95 0 0016 8c0-2.14-.83-4.15-2.34-5.66zM8 14.75a6.76 6.76 0 11.02-13.52A6.76 6.76 0 018 14.75z"
    />
    <path
      fill="#828282"
      d="M12.12 9.12c-.33-.1-.68.07-.85.38-.12.22-.3.49-.52.76a3.6 3.6 0 01-5.43-.01 4.94 4.94 0 01-.58-.79c-.18-.3-.54-.46-.86-.34-.33.13-.49.49-.32.79.17.31.43.72.8 1.13a4.87 4.87 0 003.71 1.71c1.45 0 2.72-.6 3.66-1.72.34-.41.58-.82.74-1.14.16-.3-.02-.66-.35-.77zM5.25 6.63a1 1 0 100-2 1 1 0 000 2zM10.75 6.63a1 1 0 100-2 1 1 0 000 2z"
    />
  </g>
  <g id="new-file">
    <g fill="#54747A" clip-path="url(#clip34)">
      <path
        d="M51.25 60h-30A6.26 6.26 0 0115 53.75v-37.5C15 12.8 17.8 10 21.25 10h30c3.45 0 6.25 2.8 6.25 6.25v37.5c0 3.45-2.8 6.25-6.25 6.25zm-30-47.5a3.75 3.75 0 00-3.75 3.75v37.5a3.75 3.75 0 003.75 3.75h30A3.75 3.75 0 0055 53.75v-37.5a3.75 3.75 0 00-3.75-3.75h-30z"
      />
      <path
        d="M11.25 52.5h-2.5a6.26 6.26 0 01-6.25-6.25v-40C2.5 2.8 5.3 0 8.75 0h30C42.2 0 45 2.8 45 6.25a1.25 1.25 0 01-2.5 0 3.75 3.75 0 00-3.75-3.75h-30A3.75 3.75 0 005 6.25v40A3.75 3.75 0 008.75 50h2.5a1.25 1.25 0 010 2.5zM46.25 42.5h-20a1.25 1.25 0 010-2.5h20a1.25 1.25 0 010 2.5zM46.25 52.5h-20a1.25 1.25 0 010-2.5h20a1.25 1.25 0 010 2.5z"
      />
      <path
        d="M46.25 32.5h-20a1.25 1.25 0 010-2.5h20a1.25 1.25 0 010 2.5zM46.25 22.5h-20a1.25 1.25 0 010-2.5h20a1.25 1.25 0 010 2.5z"
      />
    </g>
    <defs>
      <clipPath id="clip34"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
    </defs>
  </g>
  <g id="new-add-photo">
    <path fill="#E0E0E0" d="M20.42 23.33a5.83 5.83 0 11-11.67 0 5.83 5.83 0 0111.67 0z" />
    <path
      fill="#E0E0E0"
      d="M61.25 8.75H8.75A8.76 8.76 0 000 17.5v35c0 .16.04.32.05.48-.04.35-.02.7.1 1.04a8.75 8.75 0 008.6 7.23h52.5A8.76 8.76 0 0070 52.5v-35a8.76 8.76 0 00-8.75-8.75zm-52.5 5.83h52.5c1.6 0 2.92 1.31 2.92 2.92v23.16L48.83 25.3c-2-2-5.25-2-7.24 0L27.71 39.2l-3.68-3.68c-2-2-5.24-2-7.23 0L5.83 46.5V17.5c0-1.6 1.31-2.92 2.92-2.92z"
    />
    <path
      fill="#47979D"
      d="M70 51a10.01 10.01 0 000 20 10.01 10.01 0 000-20zm4.38 10.83h-3.55v3.55a.83.83 0 01-1.66 0v-3.55h-3.55a.83.83 0 010-1.66h3.55v-3.55a.83.83 0 011.66 0v3.55h3.55a.83.83 0 010 1.66z"
    />
  </g>
  <g id="new-add-video">
    <path
      fill="#E0E0E0"
      d="M12.6 17.5a7 7 0 100-14 7 7 0 000 14zM30.1 17.5a7 7 0 100-14 7 7 0 000 14zM54.52 25.02a3.67 3.67 0 00-3.5-.15L42 29.34V24.5c0-1.93-1.22-3.5-3.15-3.5h-35C1.92 21 0 22.57 0 24.5V49c0 1.93 1.92 3.5 3.85 3.5h35c1.93 0 3.15-1.57 3.15-3.5v-4.84l9.11 4.47c.5.25 1.12.37 1.65.37.64 0 1.15-.18 1.71-.52A3.38 3.38 0 0056 45.5V28c0-1.21-.45-2.34-1.48-2.98zM22.75 32.9a3.15 3.15 0 110-6.3 3.15 3.15 0 010 6.3zm9.45 0a3.15 3.15 0 110-6.3 3.15 3.15 0 010 6.3z"
    />
    <path
      fill="#47979D"
      d="M56 43a10.01 10.01 0 000 20 10.01 10.01 0 000-20zm4.38 10.83h-3.55v3.55a.83.83 0 01-1.66 0v-3.55h-3.55a.83.83 0 010-1.66h3.55v-3.55a.83.83 0 011.66 0v3.55h3.55a.83.83 0 010 1.66z"
    />
  </g>
  <g id="new-add-file">
    <path
      fill="#E0E0E0"
      d="M39.64 11.47L29.17.4a1.3 1.3 0 00-.94-.41H9.93A3.96 3.96 0 006 3.98v38.04C6 44.22 7.76 46 9.92 46h26.16A3.96 3.96 0 0040 42.02V12.38c0-.34-.13-.67-.36-.91zm-6.18 4.9h-7.84c-.73 0-1.31-.6-1.31-1.33V7.08c0-.74.58-1.33 1.3-1.33.73 0 1.31.6 1.31 1.33v6.63h6.54c.72 0 1.3.6 1.3 1.33 0 .73-.58 1.33-1.3 1.33z"
    />
    <path
      fill="#47979D"
      d="M41 39a7 7 0 10.02 14.02A7 7 0 0041 39zm3.06 7.58h-2.48v2.48a.58.58 0 01-1.16 0v-2.48h-2.48a.58.58 0 010-1.16h2.48v-2.48a.58.58 0 011.16 0v2.48h2.48a.58.58 0 010 1.16z"
    />
  </g>
  <g id="new-science">
    <g clip-path="url(#clip35)">
      <path fill="#29B6F6" d="M25 33.592a8.592 8.592 0 100-17.184 8.592 8.592 0 000 17.184z" />
      <path
        fill="#222"
        d="M25 34.373c-5.169 0-9.373-4.205-9.373-9.373 0-5.168 4.204-9.373 9.373-9.373 5.168 0 9.372 4.205 9.372 9.373 0 5.168-4.204 9.373-9.372 9.373zm0-17.183c-4.307 0-7.81 3.503-7.81 7.81 0 4.307 3.503 7.81 7.81 7.81 4.306 0 7.81-3.503 7.81-7.81 0-4.307-3.504-7.81-7.81-7.81z"
      />
      <path
        fill="#222"
        d="M15.041 49.19c-.207 0-.387-.048-.548-.118-.933-.407-1.754-1.775.187-8.795 1.305-4.72 3.53-10.774 6.269-17.046 2.738-6.271 5.663-12.02 8.237-16.186C33.016.848 34.577.52 35.51.928c.933.407 1.754 1.775-.187 8.795-1.305 4.721-3.53 10.775-6.269 17.046-2.737 6.271-5.663 12.02-8.238 16.187-3.167 5.125-4.782 6.235-5.774 6.235zM34.864 2.405c-1.315.47-6.224 7.113-12.484 21.452-6.26 14.339-7.792 22.456-7.243 23.74 1.316-.47 6.226-7.114 12.485-21.452 6.259-14.339 7.792-22.456 7.242-23.74zm-6.526 24.053h.003-.004z"
      />
      <path
        fill="#222"
        d="M40.584 45.763c-1.053 0-2.952-.938-6.817-4.544-3.58-3.342-7.918-8.117-12.21-13.445-4.293-5.33-8.036-10.583-10.538-14.793-3.722-6.26-3.29-7.796-2.497-8.435.792-.639 2.385-.734 7.71 4.234 3.582 3.342 7.918 8.117 12.211 13.445 4.293 5.33 8.035 10.583 10.538 14.793 3.721 6.261 3.29 7.797 2.497 8.435-.217.175-.495.31-.894.31zM9.534 5.8c-.192 1.385 3.425 8.811 13.24 20.994 9.815 12.183 16.301 17.298 17.695 17.405.191-1.384-3.427-8.81-13.241-20.993C17.413 11.024 10.927 5.908 9.533 5.8z"
      />
      <path
        fill="#222"
        d="M3.272 34.525c-2.373 0-2.99-.618-3.198-1.245-.32-.966.147-2.49 6.665-5.741 4.383-2.186 10.373-4.578 16.867-6.735 6.494-2.157 12.725-3.826 17.545-4.697 7.167-1.295 8.454-.353 8.775.613.321.965-.146 2.49-6.664 5.741-4.383 2.186-10.374 4.578-16.868 6.735C19.9 31.353 13.67 33.021 8.85 33.892c-2.51.454-4.298.633-5.577.633zM1.62 32.767c.385.16 1.999.54 7.634-.538 4.648-.89 10.561-2.493 16.649-4.515 6.087-2.022 11.784-4.276 16.04-6.345 5.16-2.508 6.226-3.777 6.44-4.136-.386-.16-2-.54-7.635.538-4.648.89-10.56 2.492-16.649 4.515-6.087 2.022-11.784 4.275-16.04 6.345-5.16 2.507-6.226 3.776-6.44 4.136z"
      />
      <path fill="#EF5350" d="M28.906 10.94a2.343 2.343 0 100-4.686 2.343 2.343 0 000 4.687z" />
      <path
        fill="#222"
        d="M28.905 11.722a3.128 3.128 0 01-3.124-3.124 3.128 3.128 0 013.124-3.124 3.128 3.128 0 013.124 3.124 3.128 3.128 0 01-3.124 3.124zm0-4.686c-.861 0-1.562.7-1.562 1.562 0 .861.7 1.562 1.562 1.562.862 0 1.563-.7 1.563-1.562 0-.862-.701-1.562-1.563-1.562z"
      />
      <path fill="#7E57C2" d="M37.888 39.059a2.734 2.734 0 100-5.468 2.734 2.734 0 000 5.468z" />
      <path
        fill="#222"
        d="M37.888 39.84a3.52 3.52 0 01-3.515-3.515 3.52 3.52 0 013.515-3.515 3.52 3.52 0 013.515 3.515 3.519 3.519 0 01-3.515 3.515zm0-5.467a1.955 1.955 0 00-1.953 1.952c0 1.077.876 1.953 1.953 1.953a1.955 1.955 0 001.952-1.953 1.954 1.954 0 00-1.952-1.952z"
      />
      <path fill="#FFCA28" d="M10.94 34.372a2.343 2.343 0 100-4.686 2.343 2.343 0 000 4.686z" />
      <path
        fill="#222"
        d="M10.94 35.153a3.128 3.128 0 01-3.124-3.124 3.128 3.128 0 013.125-3.124 3.128 3.128 0 013.124 3.124 3.128 3.128 0 01-3.124 3.124zm0-4.686c-.861 0-1.562.7-1.562 1.562a1.564 1.564 0 003.124 0c0-.862-.7-1.562-1.562-1.562z"
      />
    </g>
    <defs>
      <clipPath id="clip35"><path fill="#fff" d="M0 0h50v50H0z" /></clipPath>
    </defs>
  </g>
  <g id="new-business">
    <path
      fill="#7E57C2"
      d="M48.01 17.78L34.87 25.7a1.6 1.6 0 00-.54 2.16l6 10.27c.45.75 1.4 1 2.15.55l5.74-3.46c.65-.4 1.05-1.1 1.05-1.88V18.5a.83.83 0 00-1.26-.72z"
    />
    <path
      fill="#29B6F6"
      d="M1.99 17.78l13.14 7.93c.73.45.98 1.41.54 2.16l-6 10.27c-.45.75-1.4 1-2.15.55L1.8 35.23a2.2 2.2 0 01-1.06-1.88V18.5c0-.65.7-1.06 1.26-.72z"
    />
    <path
      fill="#000"
      d="M47.64 17.14L34.5 25.07a2.34 2.34 0 00-.97 2.83c-.58.25-1.24.26-1.84.02l-1.7-.67a3.4 3.4 0 00-2.12-.14l-2.6.67-.3.09c-1.59-.92-2.53-1.2-4.21-.54l-1.51.6c-.71.27-1.5.2-2.16-.2l-.5-.3a2.34 2.34 0 00-1.09-2.36L2.36 17.14A1.56 1.56 0 000 18.5v14.85c0 1.03.54 2 1.41 2.52l5.74 3.46c1.06.65 2.43.31 3.1-.74l.24.15-.74 1.05a2.63 2.63 0 00.6 3.64c.56.42 1.26.57 1.94.45a2.6 2.6 0 003 2.18c.1.67.46 1.3 1.05 1.73.79.57 1.77.62 2.56.26a2.56 2.56 0 004.43.75l1.93 1.15c.4.25.86.37 1.3.37a2.57 2.57 0 002.58-2.38l.07.04a2.56 2.56 0 003.53-.92c.22-.37.34-.78.36-1.2a2.56 2.56 0 002.9-1.19c.21-.34.33-.72.36-1.12 1.17.5 2.56.07 3.22-1.07.59-1 .44-2.23-.28-3.06l.75-.45c.72.74 1.87.92 2.8.36l4.36-2.63a.75.75 0 00.25-1.01.73.73 0 00-1-.26l-4.36 2.63a.82.82 0 01-.98-.1c0-.05-6.16-10.47-6.16-10.47a.85.85 0 01.29-1.14l13.14-7.93a.1.1 0 01.15.08v14.85c0 .51-.27.99-.7 1.24l-1.38.84a.75.75 0 00-.26 1.02c.2.35.66.46 1 .25l1.39-.83A2.95 2.95 0 0050 33.35V18.5a1.56 1.56 0 00-2.36-1.36zm-19.4 11.4c.4-.1.82-.07 1.21.09l1.7.68c1.02.4 2.13.35 3.1-.11l5 8.53-.81.48c-.15.1-.29.19-.42.3L27.34 32.1a.72.72 0 00-.74 0 .74.74 0 00-.37.64v.15a1.97 1.97 0 01-1.95 1.97.16.16 0 01-.16-.16v-3.52a2.03 2.03 0 011.5-1.96l2.61-.67zm-19.72 9.6a.81.81 0 01-.62-.08l-5.74-3.47c-.43-.25-.7-.73-.7-1.24V18.5c0-.01 0-.06.05-.08a.1.1 0 01.05-.02.1.1 0 01.05.02l13.14 7.93c.4.23.52.75.29 1.14l-6 10.27c-.12.2-.3.33-.52.39zm3.5 4.28a1.12 1.12 0 01-1.28-.93c-.04-.3.03-.6.2-.84l1.05-1.47a1.12 1.12 0 01.14-.17 1.1 1.1 0 011.4-.09c.5.36.62 1.07.26 1.57l-1.04 1.48c-.18.24-.43.4-.73.45zm2.17 1.98a1.13 1.13 0 01-.25-1.57l1.04-1.47 1.16-1.63a1.1 1.1 0 011.55-.26c.5.36.61 1.07.25 1.57l-2.2 3.1a1.1 1.1 0 01-1.55.26zm3.83 2.38a1.1 1.1 0 01-.83-.2 1.14 1.14 0 01-.26-1.57l2.2-3.1a1.1 1.1 0 012 .47c.05.3-.02.6-.19.84l-2.2 3.1c-.17.25-.43.41-.72.46zm2.66 1.29a1.13 1.13 0 01-.25-1.57l.72-1.03a1.1 1.1 0 011.56-.26c.5.36.6 1.07.25 1.57l-.42.59-.01.02-.3.42a1.1 1.1 0 01-1.55.26zm17.64-6.35c-.3.54-1 .72-1.52.4l-1.7-1.02-5.24-3.14a.73.73 0 00-1 .26c-.21.35-.1.8.25 1.01l5.25 3.15c.53.32.7 1 .39 1.54a1.1 1.1 0 01-1.53.4l-1.38-.83-3.86-2.32a.73.73 0 00-1 .26c-.21.35-.1.8.25 1.02l3.86 2.31a1.13 1.13 0 01-.3 2.06 1.1 1.1 0 01-.83-.12l-2.07-1.24-1.52-.91a.73.73 0 00-1 .26c-.2.35-.1.8.25 1.02l1.52.9c.53.32.7 1.02.39 1.55-.31.53-1 .71-1.53.4l-1.8-1.1c.77-1.16.5-2.75-.64-3.58-.35-.25-.74-.4-1.13-.46a2.62 2.62 0 00-.89-3.1 2.55 2.55 0 00-1.95-.44 2.6 2.6 0 00-1.05-1.73 2.54 2.54 0 00-3.38.33 2.55 2.55 0 00-3.64-.98l-.52-.3 4.98-8.52.37.22a3.89 3.89 0 003.43.29l1.5-.6c.9-.35 1.39-.36 2.3.08a3.53 3.53 0 00-.92 2.39v3.52c0 .9.72 1.64 1.62 1.64.91 0 1.77-.35 2.41-1 .4-.4.68-.88.84-1.4l10.2 6.12a.7.7 0 00.1.05l.1.07c.53.32.7 1 .4 1.54z"
    />
    <path
      fill="#47979D"
      d="M33.82 19.28h-16.8A2.04 2.04 0 0115 17.23V7.1c0-1.13.9-2.05 2.02-2.05h16.8c1.11 0 2.02.92 2.02 2.05v10.12c0 1.13-.9 2.05-2.02 2.05z"
    />
    <path
      fill="#54747A"
      d="M35.84 7.99V7.1c0-1.13-.9-2.05-2.02-2.05h-16.8c-1.11 0-2.02.92-2.02 2.05v.88a3.7 3.7 0 003.67 3.71h13.5A3.7 3.7 0 0035.84 8z"
    />
    <path
      fill="#000"
      d="M16.6 19.64h16.8a2.78 2.78 0 002.75-2.79V6.73c0-1.54-1.23-2.79-2.75-2.79h-4.05V2.77A2.44 2.44 0 0026.94.32h-3.87a2.44 2.44 0 00-2.42 2.45v1.17H16.6a2.78 2.78 0 00-2.75 2.8v5.57c0 .4.33.74.73.74.4 0 .73-.33.73-.74v-1.38c.78.7 1.81 1.14 2.94 1.14h.57v.81c0 .41.33.75.73.75.4 0 .74-.34.74-.75v-.81h9.42v.81c0 .41.33.75.74.75.4 0 .73-.34.73-.75v-.81h.57c1.13 0 2.16-.43 2.94-1.14v5.92c0 .72-.58 1.31-1.3 1.31H16.6a1.3 1.3 0 01-1.29-1.3v-4.92a.74.74 0 00-.73-.74c-.4 0-.73.33-.73.74v4.91c0 1.54 1.23 2.8 2.76 2.8zm5.51-16.87c0-.54.43-.97.96-.97h3.87c.52 0 .95.43.95.97v1.17h-5.78V2.77zm9.64 7.81h-.57v-.81a.74.74 0 00-.73-.74c-.4 0-.74.33-.74.74v.81H20.3v-.81a.74.74 0 00-.74-.74c-.4 0-.73.33-.73.74v.81h-.57a2.96 2.96 0 01-2.94-2.97v-.88c0-.72.58-1.3 1.3-1.3H33.4c.7 0 1.29.58 1.29 1.3v.88a2.96 2.96 0 01-2.94 2.97z"
    />
  </g>
  <g id="new-finance">
    <path fill="#47979D" d="M41.18 31.14v5.2a2.78 2.78 0 01-2.74 2.82H33.1v-1.79a6.2 6.2 0 016.07-6.23h2z" />
    <path fill="#FFCA28" d="M41.18 17.45v5.16h-2.01a6.2 6.2 0 01-6.07-6.24v-1.74h5.34a2.78 2.78 0 012.74 2.82z" />
    <path
      fill="#29B6F6"
      d="M21 35.92a8.93 8.93 0 008.81-9.05c0-5-3.94-9.05-8.81-9.05a8.93 8.93 0 00-8.81 9.05c0 5 3.94 9.05 8.81 9.05z"
    />
    <path fill="#EF5350" d="M8.9 38.97v.19H3.56a2.78 2.78 0 01-2.74-2.82v-5.2h2.01a6.2 6.2 0 016.07 6.23v1.6z" />
    <path fill="#54747A" d="M8.9 14.82v1.6a6.2 6.2 0 01-6.07 6.28h-2v-5.25a2.78 2.78 0 012.73-2.81H8.9v.18z" />
    <path
      fill="#222"
      d="M42 17.5a3.7 3.7 0 00-3.65-3.76H3.65A3.7 3.7 0 000 17.5v18.76A3.7 3.7 0 003.65 40h34.7A3.7 3.7 0 0042 36.25V17.49zm-1.83-.05v4.26h-1a5.5 5.5 0 01-5.39-5.34v-.75h4.66a1.7 1.7 0 011.73 1.83zm-8.21 20.67H10.04v-.75a7.32 7.32 0 00-7.21-7.22h-1V23.6h1a7.27 7.27 0 007.21-7.17v-.8h21.92v.75a7.32 7.32 0 007.2 7.22h1.01v6.56h-1a7.32 7.32 0 00-7.21 7.22v.75zm-28.4-22.5h4.66v.8c0 2.9-2.56 5.3-5.39 5.3h-1v-4.27a1.72 1.72 0 011.73-1.83zM1.83 36.3v-4.27h1a5.5 5.5 0 015.39 5.34v.75H3.56a1.7 1.7 0 01-1.73-1.82zm36.6 1.82h-4.65v-.75a5.5 5.5 0 015.39-5.34h1v4.27a1.72 1.72 0 01-1.73 1.82z"
    />
    <path
      fill="#222"
      d="M21 36.86a9.86 9.86 0 01-9.72-9.99A9.86 9.86 0 0121 16.88a9.86 9.86 0 019.73 10A9.86 9.86 0 0121 36.85zm0-18.1a8 8 0 00-7.9 8.11 8 8 0 007.9 8.11 8 8 0 007.9-8.1 7.96 7.96 0 00-7.9-8.12zM36.61 10.88H5.4a.93.93 0 01-.92-.94.88.88 0 01.92-.93H36.6a.88.88 0 01.92.93c0 .52-.41.94-.92.94zM32.05 6.2H9.95a.93.93 0 01-.91-.94.88.88 0 01.91-.94h22.1a.88.88 0 01.91.94c0 .51-.4.93-.91.93zM28.93 1.88l-15.07.03a.93.93 0 01-.92-.94.88.88 0 01.92-.94L28.93 0a.88.88 0 01.92.94c0 .52-.41.94-.92.94z"
    />
    <path
      fill="#222"
      d="M21 25.65c-.78 0-1.42-.65-1.41-1.45 0-.8.63-1.46 1.41-1.45a1.43 1.43 0 011.41 1.5c0 .51.41.93.92.93.5 0 .91-.42.91-.93 0-1.48-.95-2.78-2.33-3.2v-.27c0-.52-.4-.94-.91-.94-.5 0-.91.42-.91.94v.28A3.29 3.29 0 0017.72 25 3.2 3.2 0 0021 27.53c.78 0 1.41.65 1.41 1.45 0 .8-.63 1.45-1.41 1.45-.78 0-1.42-.65-1.42-1.45 0-.52-.4-.94-.9-.94-.51 0-.92.42-.92.94 0 1.46.96 2.75 2.33 3.14v.38c0 .52.4.94.91.94.5 0 .91-.42.91-.94v-.38a3.27 3.27 0 002.33-3.14A3.29 3.29 0 0021 25.65z"
    />
  </g>
  <g id="new-edit-info">
    <g clip-path="url(#clip36)">
      <path fill="#47979D" d="M8.44 12.38c-1.13-.76-3.49-2.26-3.94-2.26L11.81.56l3.38 3.38-6.75 8.44z" />
      <path
        fill="#000"
        d="M3.7 15.39l4.55-1.87.3-.23 7.48-9.12c.23-.35.2-.8-.11-1.07L12.37.16c-.3-.21-.75-.25-1.04.12L3.82 9.39c-.08.12-.12.23-.16.35l-.95 4.84c-.05.83.61.98 1 .8zm8.28-13.6l2.4 2-6.51 7.96-2.38-1.97 6.5-7.98zM4.9 11.27l1.62 1.35-2.1.87.48-2.22z"
      />
      <path
        fill="#000"
        d="M17.21 16.46H4.4s-2.66.12-2.76-.56c0-.04-.07-.2.28-.62a.77.77 0 00-.08-1.07.77.77 0 00-1.07.07c-.72.88-.91 1.64-.57 2.33.94 1.75 4.08 1.34 4.24 1.37H17.2a.76.76 0 100-1.53z"
      />
    </g>
    <defs>
      <clipPath id="clip36"><path fill="#fff" d="M0 0h18v18H0z" /></clipPath>
    </defs>
  </g>
  <g id="new-join">
    <path
      fill="#000"
      d="M1.2 19.98h8.12c.37 0 .67-.33.67-.74 0-.4-.3-.74-.67-.74H1.35v-17H9.3c.36 0 .66-.33.66-.74S9.66.02 9.3.02H1.2C.56.02.03.6.03 1.34v17.32c0 .73.53 1.32 1.19 1.32z"
    />
    <path
      fill="#000"
      d="M1.2 0h8.1c.37 0 .67.34.67.76 0 .41-.3.75-.68.75H1.36V18.5h7.96c.37 0 .68.34.68.75 0 .42-.3.76-.68.76H1.2C.54 20 0 19.4 0 18.66V1.34C0 .6.54 0 1.2 0zm8.1 1.48c.35 0 .64-.32.64-.72 0-.4-.29-.73-.65-.73H1.2C.56.03.03.62.03 1.33v17.33c0 .72.53 1.3 1.17 1.3h8.12c.36 0 .65-.32.65-.72 0-.4-.3-.72-.65-.72H1.33V1.48H9.3z"
    />
    <path fill="#47979D" d="M11 5.5l4.5 4.5-4 4-1 .5-1-.5.5-1.5H6L4.5 12V8.5l.5-1h4.5L10 6l1-.5z" />
    <path
      fill="#000"
      d="M4 8.41v3.18c0 .8.66 1.45 1.46 1.45h3.68v.51a1.43 1.43 0 00.46 1.06 1.47 1.47 0 001.99.01l3.93-3.55a1.44 1.44 0 000-2.14L11.6 5.38a1.47 1.47 0 00-2.45 1.07v.51H5.46c-.8 0-1.46.65-1.46 1.45zm5.93-.33c.18 0 .33-.15.33-.34v-1.3c0-.2.17-.33.34-.33.08 0 .16.03.23.1l3.93 3.54c.15.14.15.36 0 .5l-3.93 3.55a.33.33 0 01-.23.09.33.33 0 01-.34-.34v-1.3a.33.33 0 00-.33-.33H5.46a.33.33 0 01-.33-.33V8.41c0-.18.15-.33.33-.33h4.47z"
    />
  </g>
  <g id="new-exit">
    <path
      fill="#000"
      d="M14.8.02H6.67c-.37 0-.67.33-.67.74 0 .4.3.74.67.74h7.97v17H6.7c-.36 0-.66.33-.66.74s.3.74.66.74h8.1c.65 0 1.18-.59 1.18-1.32V1.34c0-.73-.53-1.32-1.19-1.32z"
    />
    <path
      fill="#000"
      d="M14.8 20H6.7c-.37 0-.67-.34-.67-.76 0-.41.3-.75.68-.75h7.92V1.5H6.68c-.37 0-.68-.34-.68-.75 0-.42.3-.76.68-.76h8.12c.66 0 1.2.6 1.2 1.34v17.32c0 .74-.54 1.34-1.2 1.34zm-8.1-1.48c-.35 0-.64.32-.64.72 0 .4.29.73.65.73h8.09c.64 0 1.17-.59 1.17-1.3V1.33c0-.72-.53-1.3-1.17-1.3H6.68c-.36 0-.65.32-.65.72 0 .4.3.72.65.72h7.99v17.04H6.7z"
    />
    <path fill="#47979D" d="M5 14.5L.5 10l4-4 1-.5 1 .5L6 7.5h4l1.5.5v3.5l-.5 1H6.5L6 14l-1 .5z" />
    <path
      fill="#000"
      d="M12 11.59V8.41c0-.8-.66-1.45-1.46-1.45H6.86v-.51a1.43 1.43 0 00-.46-1.06 1.47 1.47 0 00-1.99-.01L.48 8.93a1.44 1.44 0 000 2.14l3.93 3.55a1.47 1.47 0 002.45-1.07v-.51h3.68c.8 0 1.46-.65 1.46-1.45zm-5.93.33a.33.33 0 00-.33.34v1.3c0 .2-.17.33-.34.33a.33.33 0 01-.23-.1l-3.93-3.54a.33.33 0 010-.5L5.17 6.2a.33.33 0 01.23-.09c.17 0 .34.14.34.34v1.3c0 .18.15.33.33.33h4.47c.18 0 .33.15.33.33v3.18c0 .18-.15.33-.33.33H6.07z"
    />
  </g>
  <g id="new-target">
    <g clip-path="url(#clip37)">
      <path fill="#47979D" d="M7.5 31L1 37.5l11 11 7-6.5L7.5 31z" />
      <path
        fill="#29B6F6"
        d="M5.5 19.5L5 14v-1.5L8 10l1.5.5 2 .5 2-.5h2l2 2v5c0 .5-.5 1.5-.5 2 0 .4-.67.5-1 .5-2.33.17-7.2.5-8 .5-.8 0-2-.67-2.5-1z"
      />
      <path
        fill="#7E57C2"
        d="M17.5 19.5L17 14v-1.5l3-2.5 1.5.5 2 .5 2-.5h2l2 2v5c0 .5-.5 1.5-.5 2 0 .4-.67.5-1 .5-2.33.17-7.2.5-8 .5-.8 0-2-.67-2.5-1z"
      />
      <path
        fill="#FFCA28"
        d="M30.5 19.5L30 14v-1.5l3-2.5 1.5.5 2 .5 2-.5h2l2 2v5c0 .5-.5 1.5-.5 2 0 .4-.67.5-1 .5-2.33.17-7.2.5-8 .5-.8 0-2-.67-2.5-1z"
      />
      <path
        fill="#000"
        d="M48.82 23.4a4.53 4.53 0 00-2.8-1.17 4 4 0 00-3.07 1.16l-5.56 5.5a3.6 3.6 0 00-3.2-1.8h-7.77c-1.47.01-2.9-.18-4.26-.56a10.47 10.47 0 00-9.76 2.07c-1.16.95-2.01 1.98-2.55 2.73l-1.4-1.35a1 1 0 00-.68-.28 1 1 0 00-.71.3L.27 37.04a.98.98 0 00.04 1.4l11.47 10.92a.98.98 0 001.38-.02l6.72-6.9a1 1 0 00-.02-1.4l-.58-.57 1.34-.15c.8-.09 1.63-.14 2.45-.14H34.9a8.89 8.89 0 004.89-1.27c.46-.32.88-.7 1.25-1.14l7.98-9.39c1.37-1.6 1.28-3.6-.21-4.98zM12.43 47.27L2.38 37.69l5.41-5.62 10 9.7-5.36 5.5zm35.1-20.16l-7.98 9.39c-.25.3-.54.56-.86.78a7 7 0 01-3.78.94H23.07c-.9 0-1.8.05-2.68.15l-2.94.33-6.17-5.98c.43-.64 1.22-1.66 2.36-2.6a8.47 8.47 0 018-1.69c1.53.42 3.13.64 4.78.64h7.78c1.4 0 1.77 1.2 1.77 1.92 0 .53-.17 1.02-.46 1.37-.32.37-.77.56-1.34.56H27.4a.98.98 0 000 1.97h6.77c1.14 0 2.15-.45 2.84-1.26.57-.67.9-1.56.93-2.5l6.4-6.34c.92-.92 2.34-.69 3.14.05.42.38.97 1.18.05 2.27z"
      />
      <path
        fill="#000"
        d="M24.33 33.64a.98.98 0 00-1.92.45l.01.04a.98.98 0 001.92-.45l-.01-.04zM6.65 21.14h9.58c.52 0 1-.17 1.4-.45.4.28.88.45 1.4.45h9.58c.52 0 1-.17 1.4-.45.4.28.88.45 1.4.45h9.58a2.38 2.38 0 002.38-2.38V14.3c0-2-1.12-3.75-2.8-4.6a5.68 5.68 0 10-8.74 0c-.72.36-1.35.9-1.82 1.55a5.14 5.14 0 00-1.82-1.56 5.68 5.68 0 10-8.74 0c-.72.37-1.35.91-1.82 1.56a5.15 5.15 0 00-1.82-1.56 5.68 5.68 0 10-8.74 0 5.16 5.16 0 00-2.8 4.61v4.47a2.38 2.38 0 002.38 2.38zM36.2 2.36a3.71 3.71 0 110 7.42 3.71 3.71 0 010-7.42zm-2.55 8.77a5.64 5.64 0 005.1 0 3.2 3.2 0 012.66 3.16v4.47c0 .23-.19.42-.42.42h-9.58a.41.41 0 01-.42-.42V14.3a3.2 3.2 0 012.66-3.16zm-9.83-8.77a3.71 3.71 0 110 7.42 3.71 3.71 0 010-7.42zm-2.55 8.77a5.63 5.63 0 005.1 0 3.2 3.2 0 012.66 3.16v4.47c0 .23-.19.42-.42.42h-9.58a.41.41 0 01-.42-.42V14.3a3.2 3.2 0 012.66-3.16zm-9.83-8.77a3.71 3.71 0 110 7.42 3.71 3.71 0 010-7.42zm-5.2 11.93a3.2 3.2 0 012.65-3.16 5.64 5.64 0 005.1 0 3.2 3.2 0 012.66 3.16v4.47c0 .23-.19.42-.42.42H6.65a.41.41 0 01-.42-.42V14.3z"
      />
    </g>
    <defs>
      <clipPath id="clip37"><path fill="#fff" d="M0 0h50v50H0z" /></clipPath>
    </defs>
  </g>
  <g id="new-idea">
    <path
      fill="#FFCA28"
      d="M20.44 47.37l1.01-4.07 3.55.51 3.55-1.01v2.03l.5 3.05-.5.51c-.68.17-2.13.61-2.54 1.02-.4.4-2.2.17-3.04 0l-2.53-2.04z"
    />
    <path
      fill="#47979D"
      d="M1.16 45.85l3.55-19.83h3.05L6.74 31.6l-1.52 11.7h1.52l6.6-1.53 7.6 1.02v4.57c-2.87.17-8.72.51-9.13.51-.4 0-6.93-.34-10.14-.5l-.5-1.53z"
    />
    <path
      fill="#29B6F6"
      d="M10.8 16.86l.5-2.03 1.02-1.52.5-1.53 2.04-2.03 2.53.5 1.02-1.01 2.03-1.53 3.55.51h1.52l2.53-.5 1.52 1 1.53 1.03 2.53-.51 2.03 3.05 1.02 2.54 3.04 2.03v5.6l-1.02 3.56-2.53 2.54.5 1.02v3.05l-1.52 1.01-1.52-1.52-3.04-1.02-2.54-2.03-2.53-1.53c-1.19.51-3.65 1.53-4.06 1.53-.4 0-1.86-1.02-2.54-1.53l-1.52-1.52-3.04.5-3.55-3.05-1.01-3.55 1.01-3.06z"
    />
    <path
      fill="#7E57C2"
      d="M48.84 45.85l-3.55-19.83h-3.05l1.02 5.59 1.52 11.7h-1.52l-6.6-1.53-7.6 1.02v4.57c2.87.17 8.72.51 9.13.51.4 0 6.93-.34 10.14-.5l.5-1.53z"
    />
    <path
      fill="#000"
      d="M46.25 26.23a1.7 1.7 0 00-1.66-1.37h-1.63l-.12-.73a1.7 1.7 0 00-1.41-1.4l-.48-.06c.27-1.3.04-2.65-.65-3.78a3.48 3.48 0 00-2.5-4.64 7.2 7.2 0 00-7.03-5.89l-.24.02a3.44 3.44 0 00-5.26-.66 5.8 5.8 0 00-7.77 1.34 4.2 4.2 0 00-5.38 3.8 3.49 3.49 0 00-2.05 3.93 6.83 6.83 0 00-.8 5.84l-.68.1a1.7 1.7 0 00-1.43 1.4l-.12.72H5.41c-.81 0-1.5.58-1.66 1.38L.05 45.28a2.55 2.55 0 002.5 3.02h17.62C20.87 49.46 23 50 25 50c1.98 0 4.09-.52 4.81-1.7h17.65a2.53 2.53 0 002.5-3.02l-3.7-19.05zm-33.7-8.63a1.8 1.8 0 01.9-3.33c.57 0 1.1.27 1.43.72a.84.84 0 101.35-1 3.41 3.41 0 00-2.4-1.36 2.57 2.57 0 012.51-2.04l.31.03a5.6 5.6 0 00-.18.53c-.1.45.17.9.62 1.02.44.11.9-.15 1.02-.6a4.13 4.13 0 016.24-2.42c-.12.36-.19.73-.2 1.11a.85.85 0 101.7 0 1.78 1.78 0 113.55 0 .85.85 0 101.7 0l-.03-.19a5.5 5.5 0 015 4.24c-.39.12-.76.3-1.09.55A.85.85 0 0036 16.22a1.78 1.78 0 012.61 2.3 1.8 1.8 0 01-.8.75.85.85 0 00.36 1.61c.13 0 .25-.03.36-.08.22-.11.44-.24.63-.4a3.63 3.63 0 01-.71 3.62l-.02.02a3.64 3.64 0 01-4.72.54c.62-.88.7-2.03.22-2.99a.85.85 0 10-1.51.77c.28.56.1 1.24-.4 1.6a1.27 1.27 0 01-1.84-.48.85.85 0 10-1.52.76 2.93 2.93 0 003.7 1.43 5.2 5.2 0 004.9 1.04 5.39 5.39 0 01-3.49 2.14.85.85 0 00.27 1.67 6.93 6.93 0 001.5-.44c.26.46.47.95.63 1.46a.91.91 0 01-.51 1.11.96.96 0 01-1.1-.3 5.4 5.4 0 00-2.47-1.64c-1.82-.62-2.53-1.16-2.83-1.76a8.1 8.1 0 001.3-.27.85.85 0 00-.5-1.62 6.39 6.39 0 01-4.26-.16.84.84 0 00-.95.24 3.61 3.61 0 01-5.83-4.24.85.85 0 00-.72-1.29c-.3 0-.58.15-.74.41-.2.35-.36.71-.48 1.1a1.27 1.27 0 01-1.2-1.26v-.02a.84.84 0 00-.85-.83.85.85 0 00-.84.85c0 1.5 1.13 2.77 2.62 2.93 0 .28.03.57.08.85a5.16 5.16 0 01-5.85-7.1c.2.2.4.36.63.5.4.24.92.11 1.15-.29a.85.85 0 00-.28-1.16zm-3.72 6.8l1.19-.16a6.82 6.82 0 007.41 3.02 5.3 5.3 0 008.3 1.4 8.1 8.1 0 001.76.33c.4 1.55 1.59 2.5 4.07 3.33.66.2 1.26.6 1.72 1.13.5.6 1.25.96 2.04.96a2.61 2.61 0 002.45-3.4 9.28 9.28 0 00-.74-1.73 7.15 7.15 0 002.8-4.3c.19-.22.35-.45.5-.69l.84.12 3.06 18.4c-5.97-2-12.42-2-18.38 0v-10.6a.85.85 0 10-1.7 0v10.6c-5.96-2-12.4-2-18.37 0l3.05-18.4zM1.88 46.3a.84.84 0 01-.18-.7l3.7-19.05h1.36L4.1 42.53a1.7 1.7 0 002.18 1.9 28.2 28.2 0 0113.96-.9L20 46.62H2.54a.85.85 0 01-.66-.31zm23.12 2c-2.04 0-3.2-.6-3.38-.87l.3-3.51c.92.23 1.83.53 2.71.91a.85.85 0 00.74 0c.88-.38 1.79-.69 2.72-.92l.29 3.52c-.18.27-1.34.87-3.38.87zm23.12-2c-.16.2-.4.31-.66.31H30l-.25-3.08c4.66-.88 9.46-.57 13.97.9a1.7 1.7 0 002.17-1.9l-2.65-15.98h1.36l3.7 19.05c.04.25-.02.5-.18.7z"
    />
    <path
      fill="#000"
      d="M22.2 19.22a.85.85 0 00-.06 1.2 5.1 5.1 0 002.7 1.57 2.52 2.52 0 01-2.05 1.06.85.85 0 000 1.7 4.2 4.2 0 003.94-2.72 5.1 5.1 0 004.17-4.07.85.85 0 00-1.1-.97c-.3.1-.5.35-.56.65a3.38 3.38 0 01-1.4 2.15c-1.4.95-3.3.74-4.45-.5a.84.84 0 00-1.2-.07zM19.25 18.3c.47 0 .85-.37.85-.84a2.2 2.2 0 012.2-2.2.85.85 0 000-1.7 3.9 3.9 0 00-3.9 3.9.85.85 0 00.85.85zM25.84 1.7V.84a.85.85 0 10-1.69 0v.84a.85.85 0 101.7 0zM38.87 6.08l-.84.85a.85.85 0 00.37 1.43c.3.08.6-.01.82-.23l.85-.85a.85.85 0 00-.38-1.43.84.84 0 00-.82.23zM11.38 8.38a.85.85 0 00.6-1.45l-.85-.85a.84.84 0 00-1.43.38c-.07.3.01.6.23.82l.85.85c.16.16.37.25.6.25zM17.88 4.8c.11 0 .22-.01.33-.06a.85.85 0 00.45-1.1l-.97-2.35a.85.85 0 10-1.56.65l.97 2.35c.13.31.44.52.78.52zM33.41.83a.84.84 0 00-1.1.46l-.98 2.35a.85.85 0 00.79 1.17c.34 0 .65-.2.78-.52l.97-2.35A.85.85 0 0033.4.83zM42.18 14.9c.11 0 .22-.02.32-.07l2.35-.97a.85.85 0 00-.65-1.56l-2.34.97a.85.85 0 00.32 1.63zM7.5 14.83a.85.85 0 00.65-1.57L5.8 12.3a.85.85 0 00-.65 1.57l2.35.96z"
    />
  </g>
  <g id="new-connection">
    <path
      fill="#000"
      d="M42.16 17.41c-.39-.48-.8-.95-1.23-1.39l-1.21 1.17c.4.4.77.84 1.12 1.28l1.32-1.06zM42.7 21.3l1.5-.78c-.3-.55-.61-1.09-.95-1.6l-1.41.93c.3.46.6.96.86 1.46zM39.57 14.75c-.47-.4-.96-.78-1.47-1.14L37.13 15c.47.32.92.67 1.35 1.03l1.1-1.28zM44.63 27.78l1.68-.17c-.06-.62-.15-1.24-.27-1.84l-1.65.32c.1.56.19 1.12.24 1.69zM43.98 24.45l1.62-.49c-.18-.59-.39-1.18-.62-1.75l-1.57.64c.22.52.4 1.06.57 1.6zM44.64 31.17l1.68.15c.06-.59.09-1.19.09-1.85l-1.7.06c0 .55-.02 1.1-.07 1.64zM22.87 48.5c.54.11 1.09.2 1.64.28l.21-1.68c-.5-.06-1-.15-1.5-.25l-.35 1.65zM26.23 47.23l-.07 1.7a21.01 21.01 0 001.66-.01l-.07-1.69c-.5.03-1.01.03-1.52 0zM19.68 47.51c.52.21 1.05.4 1.57.56l.5-1.61c-.48-.15-.96-.32-1.43-.51l-.64 1.56zM32.23 46.46l.5 1.62a19.3 19.3 0 001.57-.56l-.64-1.57c-.46.2-.95.37-1.43.51zM29.27 47.1l.21 1.68c.55-.07 1.1-.17 1.64-.28l-.35-1.65c-.5.1-1 .2-1.5.26zM9.35 31.15c-.04-.53-.07-1.08-.07-1.62v-.08l-1.69.08c0 .6.03 1.19.09 1.77l1.67-.15zM10.59 22.83l-1.56-.64c-.24.58-.44 1.16-.62 1.76l1.61.48c.17-.54.36-1.08.57-1.6zM16.88 14.99l-.97-1.38c-.5.35-1 .73-1.47 1.13l1.09 1.3c.43-.38.88-.73 1.35-1.05zM9.62 26.08l-1.66-.33c-.12.6-.2 1.23-.27 1.84l1.68.17c.05-.56.14-1.13.25-1.68zM12.17 19.83l-1.41-.92c-.34.51-.66 1.05-.95 1.6l1.5.78c.26-.5.55-.98.86-1.46z"
    />
    <path
      fill="#29B6F6"
      d="M6 49.5v-2l.5-2L8 44l2-1h1l2 1 1 1.5c.17.67.5 2.1.5 2.5 0 .4-.33 1.17-.5 1.5l-3.5 1H8l-2-1z"
    />
    <path
      fill="#7E57C2"
      d="M40 49.5v-2l.5-2L42 44l2-1h1l2 1 1 1.5c.17.67.5 2.1.5 2.5 0 .4-.33 1.17-.5 1.5l-3.5 1H42l-2-1z"
    />
    <path
      fill="#FFCA28"
      d="M23 19.5v-2l.5-2L25 14l2-1h1l2 1 1 1.5c.17.67.5 2.1.5 2.5 0 .4-.33 1.17-.5 1.5l-3.5 1H25l-2-1z"
    />
    <path fill="#000" d="M14.29 17.19L13.08 16c-.43.44-.85.91-1.23 1.4l1.31 1.05c.36-.44.74-.87 1.13-1.27z" />
    <circle cx="27" cy="30" r="4" fill="#47979D" />
    <path
      fill="#000"
      d="M43.87 32.9A9.25 9.25 0 0037 35.99l-5.5-4.13a5.05 5.05 0 00-3.66-7.3v-3.5a9.28 9.28 0 10-1.68 0v3.5a5.05 5.05 0 00-3.66 7.3L17 35.98a9.3 9.3 0 101.01 1.35l5.5-4.13a5.04 5.04 0 006.97 0l5.5 4.13a9.27 9.27 0 107.9-4.42zM6.75 48.99v-1.73a3.38 3.38 0 016.75 0v1.73a7.5 7.5 0 01-6.75 0zm1.69-8.48v-.84a1.69 1.69 0 113.37 0v.84a1.69 1.69 0 11-3.37 0zm6.75 7.33v-.58a5.06 5.06 0 00-2.62-4.43c.6-.63.93-1.46.93-2.32v-.84a3.37 3.37 0 10-6.75 0v.84c0 .86.34 1.7.93 2.32a5.06 5.06 0 00-2.62 4.43v.58a7.6 7.6 0 1110.13 0zm10.12-37.7v-.85a1.69 1.69 0 013.38 0v.85a1.69 1.69 0 11-3.38 0zM27 13.5a3.38 3.38 0 013.37 3.38v1.72a7.5 7.5 0 01-6.75 0v-1.72A3.38 3.38 0 0127 13.5zm-7.6-1.69a7.6 7.6 0 1112.66 5.65v-.58a5.06 5.06 0 00-2.62-4.44c.6-.62.93-1.45.93-2.31v-.85a3.38 3.38 0 00-6.75 0v.85c0 .86.34 1.69.94 2.31a5.06 5.06 0 00-2.62 4.44v.58a7.57 7.57 0 01-2.53-5.65zm7.6 21.1a3.38 3.38 0 110-6.75 3.38 3.38 0 010 6.75zm13.5 16.07v-1.73a3.38 3.38 0 016.75 0v1.73a7.5 7.5 0 01-6.75 0zm1.69-8.48v-.84a1.69 1.69 0 013.37 0v.84a1.69 1.69 0 11-3.37 0zm6.75 7.33v-.58a5.06 5.06 0 00-2.62-4.43c.6-.63.93-1.46.93-2.32v-.84a3.37 3.37 0 10-6.75 0v.84c0 .86.34 1.7.93 2.32a5.06 5.06 0 00-2.62 4.43v.58a7.6 7.6 0 1110.13 0z"
    />
  </g>
  <g id="new-clipboards">
    <path
      fill="#FFCA28"
      d="M11 10l.5 3.5 20 1V12c0-.4-.33-2.17-.5-3-.5-.5-1.6-1.5-2-1.5-.4 0-1.83-1-2.5-1.5l-1-2L24 2l-2-1h-2l-3 3-.5 2L13 7.5 11 10z"
    />
    <circle cx="36.5" cy="33.5" r="10.5" fill="#29B6F6" />
    <path
      fill="#000"
      d="M21.34 6.9a1.38 1.38 0 100-2.76 1.38 1.38 0 000 2.77zM32.37 18.42h-22.1v1.84h22.1v-1.84zM26.5 35H10.26v1.84H26.5V35zM42.44 33.16c-.5 0-.9.42-1 .92a5.54 5.54 0 01-4.53 4.53c-.5.08-.91.49-.91 1 0 .5.41.92.92.86a7.37 7.37 0 006.39-6.4c.06-.5-.36-.91-.87-.91zM10.26 29.48v1.84H26c.1-.63.22-1.25.4-1.84H10.26zM10.26 23.95v1.84h18.68a13 13 0 011.56-1.84H10.26z"
    />
    <path fill="#7E57C2" d="M22.5 49l7.5-7a19.33 19.33 0 01-2.44-2.82L20 47l2.5 2z" />
    <path
      fill="#000"
      d="M36.05 22.1a11.05 11.05 0 00-9.54 16.62l-6.8 6.84a1.8 1.8 0 00-.33.5H6.58a1.84 1.84 0 01-1.85-1.85V11.05c0-1.01.83-1.84 1.85-1.84h4c-.2.56-.31 1.17-.32 1.8v3.73h22.1v-3.69a5.5 5.5 0 00-.31-1.84h4c1.02 0 1.84.83 1.84 1.84v12.5c.63.1 1.25.22 1.85.4v-12.9a3.68 3.68 0 00-3.69-3.68h-5.11a5.51 5.51 0 00-2.57-1.63c-.85-.24-1.5-.9-1.74-1.74A5.53 5.53 0 0016 4c-.24.85-.9 1.5-1.75 1.74-1 .3-1.88.87-2.56 1.63H6.58a3.68 3.68 0 00-3.69 3.68v33.16a3.68 3.68 0 003.69 3.69h12.96c.06.08.1.18.17.26l1.3 1.3a1.84 1.84 0 002.61 0l1.56-1.56h10.87a3.68 3.68 0 003.69-3.69v-.64a11.05 11.05 0 00-3.69-21.46zM12.1 11.03a3.7 3.7 0 012.66-3.5 4.37 4.37 0 003.01-3.01 3.7 3.7 0 013.54-2.67 3.7 3.7 0 013.55 2.67 4.37 4.37 0 003 3 3.7 3.7 0 012.67 3.54v1.85H12.1v-1.88zm10.22 37.14l-1.3-1.3 6.56-6.6c.4.47.84.9 1.3 1.3l-6.56 6.6zm15.57-3.95c0 1.02-.82 1.84-1.84 1.84h-9.04l3.4-3.4a10.98 10.98 0 007.48 1.4v.16zm-1.84-1.84a9.22 9.22 0 010-18.42 9.22 9.22 0 010 18.42z"
    />
  </g>
  <g id="new-follow">
    <path
      fill="#000"
      d="M14.8.02H6.67c-.37 0-.67.33-.67.74 0 .4.3.74.67.74h7.97v17H6.7c-.37 0-.67.33-.67.74s.3.74.67.74h8.08c.66 0 1.2-.59 1.2-1.32V1.34c0-.73-.54-1.32-1.2-1.32z"
    />
    <path
      fill="#000"
      d="M14.8 20H6.7c-.37 0-.67-.34-.67-.76 0-.41.3-.75.68-.75h7.93V1.5H6.68c-.37 0-.68-.34-.68-.75 0-.42.3-.76.68-.76h8.12c.66 0 1.2.6 1.2 1.34v17.32c0 .74-.54 1.34-1.2 1.34zm-8.1-1.48c-.35 0-.64.32-.64.72 0 .4.29.73.65.73h8.09c.64 0 1.17-.59 1.17-1.3V1.33c0-.72-.53-1.3-1.17-1.3H6.68c-.36 0-.65.32-.65.72 0 .4.3.72.65.72h7.99v17.04H6.7z"
    />
    <path fill="#47979D" d="M7 5.5l4.5 4.5-4 4-1 .5-1-.5.5-1.5H2L.5 12V8.5l.5-1h4.5L6 6l1-.5z" />
    <path
      fill="#000"
      d="M0 8.41v3.18c0 .8.66 1.45 1.46 1.45h3.68v.51a1.43 1.43 0 00.46 1.06 1.47 1.47 0 001.99.01l3.93-3.55a1.44 1.44 0 000-2.14L7.6 5.38a1.47 1.47 0 00-2.45 1.07v.51H1.46C.66 6.96 0 7.61 0 8.41zm5.93-.33c.18 0 .33-.15.33-.34v-1.3c0-.2.17-.33.34-.33.08 0 .16.03.23.1l3.93 3.54c.15.14.15.36 0 .5L6.83 13.8a.33.33 0 01-.23.09.33.33 0 01-.34-.34v-1.3a.33.33 0 00-.33-.33H1.46a.33.33 0 01-.33-.33V8.41c0-.18.15-.33.33-.33h4.47z"
    />
  </g>
  <g id="new-unfollow">
    <path
      fill="#000"
      d="M14.8.02H6.67c-.37 0-.67.33-.67.74 0 .4.3.74.67.74h7.97v17H6.7c-.36 0-.66.33-.66.74s.3.74.66.74h8.1c.65 0 1.18-.59 1.18-1.32V1.34c0-.73-.53-1.32-1.19-1.32z"
    />
    <path
      fill="#000"
      d="M14.8 20H6.7c-.37 0-.67-.34-.67-.76 0-.41.3-.75.68-.75h7.92V1.5H6.68c-.37 0-.68-.34-.68-.75 0-.42.3-.76.68-.76h8.12c.66 0 1.2.6 1.2 1.34v17.32c0 .74-.54 1.34-1.2 1.34zm-8.1-1.48c-.35 0-.64.32-.64.72 0 .4.29.73.65.73h8.09c.64 0 1.17-.59 1.17-1.3V1.33c0-.72-.53-1.3-1.17-1.3H6.68c-.36 0-.65.32-.65.72 0 .4.3.72.65.72h7.99v17.04H6.7z"
    />
    <path fill="#47979D" d="M5 14.5L.5 10l4-4 1-.5 1 .5L6 7.5h4l1.5.5v3.5l-.5 1H6.5L6 14l-1 .5z" />
    <path
      fill="#000"
      d="M12 11.59V8.41c0-.8-.66-1.45-1.46-1.45H6.86v-.51a1.43 1.43 0 00-.46-1.06 1.47 1.47 0 00-1.99-.01L.48 8.93a1.44 1.44 0 000 2.14l3.93 3.55a1.47 1.47 0 002.45-1.07v-.51h3.68c.8 0 1.46-.65 1.46-1.45zm-5.93.33a.33.33 0 00-.33.34v1.3c0 .2-.17.33-.34.33a.33.33 0 01-.23-.1l-3.93-3.54a.33.33 0 010-.5L5.17 6.2a.33.33 0 01.23-.09c.17 0 .34.14.34.34v1.3c0 .18.15.33.33.33h4.47c.18 0 .33.15.33.33v3.18c0 .18-.15.33-.33.33H6.07z"
    />
  </g>
  <g id="new-education">
    <path
      fill="#EF5350"
      d="M18.28 12.97c-.11 0-7.15 1.17-7.16 1.17H8.88c-7.07-1.16-6.98-1.18-7.16-1.17-.53.02-1 .37-1.31 1C.14 14.5 0 15.19 0 15.9c0 .71.14 1.4.4 1.92.32.64.8 1 1.32 1 .11.01 6.52-1.06 6.52-1.06v.48c0 .16.06.3.17.42l1.18 1.17a.58.58 0 00.82 0l1.18-1.17a.59.59 0 00.17-.42v-.48s6.41 1.07 6.52 1.07c.53-.02 1-.37 1.31-1.01.27-.52.41-1.2.41-1.92s-.14-1.4-.4-1.92c-.32-.64-.8-1-1.32-1.01zM1.74 17.65c-.04-.02-.16-.1-.29-.36a3.25 3.25 0 01-.28-1.4c0-.52.1-1.03.28-1.39.13-.25.25-.33.3-.35l6.5 1.07v1.35l-6.5 1.08zm8.85.35l-.59.59-.59-.6v-2.68h1.18V18zm1.17-2.78l4.95-.82a4.74 4.74 0 000 3l-4.95-.83v-1.35zm6.79 2.07c-.13.26-.25.34-.3.36 0 0-.12.02-.31-.36a3.25 3.25 0 01-.28-1.4c0-.52.1-1.03.28-1.39.18-.37.32-.35.32-.35.04.02.16.1.29.35.18.36.28.87.28 1.4 0 .53-.1 1.04-.28 1.4zM.94 4.14c0 .24.14.45.36.54l3.39 1.4v2.79c0 .21.11.4.3.51.1.05 2.3 1.24 5.01 1.24 2.7 0 4.92-1.19 5-1.24.2-.1.31-.3.31-.51V6.09l2.35-.97v3.6l-1.11 2.23a.59.59 0 101.04.52l.65-1.3.65 1.3a.59.59 0 101.05-.52l-1.11-2.22V4.6a.59.59 0 00-.13-1.01L10.23.05a.59.59 0 00-.46 0L1.3 3.6c-.22.1-.36.3-.36.54zm13.2 4.36c-.65.3-2.28.95-4.14.95-1.85 0-3.49-.65-4.14-.95V6.57L9.78 8.2a.59.59 0 00.44 0l3.92-1.63V8.5zM10 1.22l6.95 2.92L10 7.02 3.05 4.14 10 1.22z"
    />
  </g>
  <g id="trophy">
    <path
      fill="#fff"
      d="M29.12 2.17h-3.85c.02-.43.02-.86.02-1.3 0-.48-.4-.87-.88-.87H5.6C5.1 0 4.7.4 4.7.88c0 .43 0 .86.02 1.29H.88c-.49 0-.88.39-.88.87 0 3.94 1.03 7.66 2.9 10.47 1.85 2.77 4.3 4.37 6.96 4.52.6.66 1.24 1.2 1.9 1.6v3.9H10.3a3.24 3.24 0 00-3.23 3.24v1.47H7A.88.88 0 007 30h16a.88.88 0 100-1.76h-.06v-1.47a3.24 3.24 0 00-3.23-3.23h-1.48v-3.91c.67-.4 1.3-.94 1.9-1.6 2.66-.15 5.12-1.75 6.97-4.52C28.97 10.7 30 6.98 30 3.04c0-.48-.4-.87-.88-.87zM4.36 12.53a16.94 16.94 0 01-2.58-8.6h3.05a29.37 29.37 0 002.73 10.66c.23.46.48.9.73 1.32a8.48 8.48 0 01-3.93-3.38zm16.82 14.24v1.47H8.82v-1.47c0-.82.66-1.48 1.47-1.48h9.42c.81 0 1.47.66 1.47 1.48zm-4.7-3.23h-2.95v-3.15a5.78 5.78 0 002.94 0v3.14zm.54-5.24a4.25 4.25 0 01-2.02.53 4.25 4.25 0 01-2.02-.53 7.07 7.07 0 01-2.1-1.77 13.86 13.86 0 01-1.75-2.73C7.5 10.57 6.58 6.32 6.48 1.76h17.04c-.1 4.56-1.03 8.8-2.65 12.04a13.87 13.87 0 01-1.86 2.86 7.08 7.08 0 01-2 1.64zm8.62-5.77a8.48 8.48 0 01-3.93 3.38c.25-.41.5-.86.73-1.32a29.37 29.37 0 002.73-10.67h3.05a16.94 16.94 0 01-2.58 8.61z"
    />
  </g>
  <g id="new-info">
    <path fill="#828282" d="M8 0a8 8 0 000 16A8 8 0 008 0zm0 14.55a6.55 6.55 0 11.01-13.11A6.55 6.55 0 018 14.54z" />
    <path
      fill="#828282"
      d="M8 3.4a.97.97 0 100 1.94.97.97 0 000-1.95zM8 6.79c-.4 0-.73.32-.73.73v4.36a.73.73 0 001.46 0V7.52c0-.4-.33-.73-.73-.73z"
    />
  </g>
  <g id="competition">
    <g clip-path="url(#clip38)">
      <path
        fill="#DD9834"
        d="M34.85 27h-1.76a1.7 1.7 0 01-1.64-2.09l4.22-17.3c.18-.75.86-1.28 1.64-1.28h7.62a6.01 6.01 0 015.87 7.48l-.2.82A16.17 16.17 0 0134.85 27zm3.78-17.3l-3.39 13.92a12.8 12.8 0 0012.08-9.8l.2-.82a2.66 2.66 0 00-2.6-3.3h-6.29zM3.4 14.63l-.2-.82a6 6 0 011.12-5.17 6.01 6.01 0 014.75-2.31h7.62c.78 0 1.46.53 1.64 1.29l4.22 17.3A1.69 1.69 0 0120.9 27h-1.76c-7.5 0-13.97-5.09-15.75-12.37zM9.07 9.7A2.66 2.66 0 006.48 13l.2.83a12.8 12.8 0 0012.08 9.79L15.36 9.7H9.08z"
      />
      <path
        fill="#FFBB24"
        d="M12.72 3.38V17.3c0 4.57 2.14 8.64 5.47 11.25a10.27 10.27 0 014.02 9.63v.02h9.58a10.29 10.29 0 014.02-9.67 14.24 14.24 0 005.47-11.23V3.38H12.72z"
      />
      <path fill="#D08B25" d="M40 38.18H14a1.27 1.27 0 100 2.55h26a1.27 1.27 0 100-2.55z" />
      <path fill="#6F7070" d="M40 51.45H14A1.27 1.27 0 1014 54h26a1.27 1.27 0 100-2.55z" />
      <path fill="#464646" d="M39.37 40.74H14.63v10.72h24.74V40.74z" />
      <path fill="#DB8C23" d="M41.53 0H12.47a1.7 1.7 0 000 3.38h29.06a1.7 1.7 0 000-3.38z" />
      <path fill="#4FBA6F" d="M24.97 15.43l-3.98-2.86-3.97 2.86V3.38h7.95v12.05z" />
      <path fill="#010101" d="M41.23 3.38H12.77v1.55h28.46V3.38z" opacity=".1" />
    </g>
    <defs>
      <clipPath id="clip0"><path fill="#fff" d="M0 0h54v54H0z" /></clipPath>
    </defs>
  </g>
  <g id="time">
    <path
      fill="#828282"
      d="M22.35 22.73h-1.9v-2.77c0-.25 0-.5-.02-.74v-.02a9.67 9.67 0 00-3.5-6.7 9.67 9.67 0 003.5-6.7v-.05c.02-.23.02-.47.02-.7V2.26h1.9a1.14 1.14 0 000-2.27H2.65a1.14 1.14 0 000 2.27h1.9v2.77c0 .25 0 .5.03.75v.01a9.67 9.67 0 003.49 6.7 9.67 9.67 0 00-3.5 6.7v.04l-.02.72v2.77h-1.9a1.14 1.14 0 000 2.27H22.35a1.14 1.14 0 000-2.27zM18.18 2.27v2.28H6.82V2.27h11.36zM10.63 13.5a1.14 1.14 0 000-1.98 7.4 7.4 0 01-3.6-4.7h10.93a7.4 7.4 0 01-3.59 4.7 1.14 1.14 0 000 1.98 7.4 7.4 0 013.6 4.7H7.03a7.4 7.4 0 013.59-4.7zm-3.81 9.24v-2.28h11.36v2.28H6.82z"
    />
  </g>
  <g id="add-icon">
    <path fill="#47979D" d="M13 0a13 13 0 100 26 13 13 0 000-26zm0 23.6a10.6 10.6 0 110-21.3 10.6 10.6 0 010 21.3z" />
    <path fill="#47979D" d="M13 7c-.6 0-1 .5-1 1.1V18c0 .6.4 1.1 1 1.1s1-.5 1-1.1V8c0-.6-.4-1.1-1-1.1z" />
    <path fill="#47979D" d="M19 13c0-.6-.5-1-1.1-1H8c-.6 0-1.1.4-1.1 1s.5 1 1.1 1H18c.6 0 1.1-.4 1.1-1z" />
  </g>
  <g id="eye">
    <g fill="#54747A" clip-path="url(#clip39)">
      <path
        d="M9 6.545c1.354 0 2.454 1.1 2.454 2.454 0 1.355-1.1 2.455-2.454 2.455a2.456 2.456 0 01-2.455-2.455c0-1.354 1.1-2.454 2.455-2.454z"
      />
      <path
        d="M9 2.863c4.09 0 7.584 2.545 9 6.137-1.416 3.591-4.91 6.136-9 6.136-4.095 0-7.585-2.544-9-6.136 1.415-3.592 4.905-6.137 9-6.137zm0 10.228A4.092 4.092 0 0013.09 9 4.092 4.092 0 009 4.909a4.092 4.092 0 00-4.09 4.09A4.092 4.092 0 009 13.09z"
      />
    </g>
    <defs>
      <clipPath id="clip0"><path fill="#fff" d="M0 0h18v18H0z" transform="matrix(-1 0 0 1 18 0)" /></clipPath>
    </defs>
  </g>
  <g id="new-student">
    <path
      fill="#EF5350"
      d="M15.96 17.46a.75.75 0 00-.89-.6c-.4.08-.66.5-.58.92.04.16 0 .33-.1.46a.48.48 0 01-.39.2H9.04l2.02-5.4c.73.4 1.4.94 1.95 1.61.27.33.74.36 1.05.08a.8.8 0 00.08-1.1 8.1 8.1 0 00-3.37-2.42 4.62 4.62 0 00.95-5.7l2.3-.89v3.86c0 .43.33.78.75.78.4 0 .74-.35.74-.78V3.55v-.02-.07c0-.33-.19-.62-.48-.73L8.3.05a.72.72 0 00-.53 0L.97 2.72c-.3.11-.48.4-.48.73v.04c0 .33.2.63.49.74L4.29 5.5a4.62 4.62 0 00.95 5.71c-.87.33-1.68.81-2.4 1.43a8.62 8.62 0 00-2.8 4.84c-.12.62.03 1.26.41 1.75S1.4 20 2 20h12c.6 0 1.16-.28 1.54-.77.4-.5.54-1.14.42-1.77zm-12.63-14l4.69-1.84 4.67 1.85-2.1.8A6.66 6.66 0 008 3.87c-.7 0-1.85.05-2.58.4l-2.1-.8zM5.2 7.77c0-.78.29-1.52.82-2.07.15-.1.81-.28 1.96-.28h.03c1.16 0 1.84.2 1.98.29.52.55.81 1.28.81 2.06A2.87 2.87 0 018 10.7a2.87 2.87 0 01-2.8-2.93zM2 18.44a.49.49 0 01-.39-.2.55.55 0 01-.1-.45 6.93 6.93 0 013.44-4.74l2.01 5.39H2zm4.34-5.95a6.3 6.3 0 013.32 0L8 16.92l-1.66-4.43z"
    />
    <path fill="#EF5350" d="M14.5 18c-.4-2.8-2.5-4.5-3.5-5 0-.67.5-1.6 2.5 0s2.5 4 2.5 5h-1.5z" />
  </g>
  <g id="action-close">
    <path fill="#54747A" d="M8 .8L7.2 0 4 3.2.8 0 0 .8 3.2 4 0 7.2l.8.8L4 4.8 7.2 8l.8-.8L4.8 4 8 .8z" />
  </g>
  <g id="action-check">
    <path
      fill="#47979D"
      d="M8.78 1.37c.3-.31.3-.82 0-1.13a.73.73 0 00-1.07 0L3.17 5.06l-1.88-2a.72.72 0 00-1.07 0c-.3.31-.3.82 0 1.14l2.42 2.56c.3.32.77.32 1.07 0l5.07-5.39z"
    />
  </g>
  <g id="edit-pencil">
    <g clip-path="url(#clip40)">
      <path
        fill="#F3D55B"
        d="M11.38 2.07H1.55C.7 2.07 0 2.77 0 3.62v9.83C0 14.3.7 15 1.55 15h9.83c.86 0 1.55-.7 1.55-1.55V3.62c0-.86-.7-1.55-1.55-1.55z"
      />
      <path
        fill="#802F34"
        d="M11.04 3.23L5.75 8.52l-.01.01A.52.52 0 005 7.8l5.3-5.3.74.73zM7.2 10a.52.52 0 00-.73-.74l5.3-5.3.74.73L7.2 10z"
      />
      <path fill="#FF5364" d="M14.7 2.5l-1.28 1.28-2.2-2.2L12.5.3c.4-.4 1.06-.4 1.46 0l.74.73c.4.4.4 1.06 0 1.47z" />
      <path fill="#FDD7AD" d="M12.32 1.58l-.55.55a.26.26 0 10.37.37l.54-.55a.26.26 0 10-.36-.37z" />
      <path fill="#2C3E50" d="M5.21 10.83l-1.2.5a.26.26 0 01-.34-.34l.5-1.2c.5.15.89.54 1.04 1.04z" />
      <path fill="#F29C1F" d="M6.47 9.26a.52.52 0 00-.72-.74l5.3-5.29.72.73-5.3 5.3z" />
      <path
        fill="#F9EAB0"
        d="M7.2 10l-1.99.83c-.15-.5-.54-.89-1.04-1.04L5 7.8a.52.52 0 01.74.73l.01-.01a.52.52 0 01.72.74.52.52 0 11.73.74zM1.55 3.36H1.3a.26.26 0 110-.51h.26a.26.26 0 010 .51zM6.47 3.36H2.59a.26.26 0 110-.51h3.88a.26.26 0 010 .51zM11.9 13.97a.26.26 0 01-.26-.26v-.52a.26.26 0 11.52 0v.52c0 .14-.12.26-.26.26z"
      />
      <path
        fill="#35495E"
        d="M2.59 11.64h-1.3a.26.26 0 110-.52h1.3a.26.26 0 010 .52zM10.6 11.64H6.47a.26.26 0 010-.52h4.13a.26.26 0 010 .52zM7.24 12.93H1.3a.26.26 0 110-.52h5.95a.26.26 0 110 .52zM10.6 12.93H8.8a.26.26 0 110-.52h1.8a.26.26 0 110 .52z"
      />
      <path fill="#BDC3C7" d="M13.42 3.78l-.92.91-2.2-2.2.92-.9 2.2 2.19z" />
    </g>
    <defs>
      <clipPath id="clip40"><path fill="#fff" d="M0 0h15v15H0z" /></clipPath>
    </defs>
  </g>
  <g id="file">
    <path
      fill="#828282"
      d="M5.79 3.32a.64.64 0 00-.17-.06.64.64 0 00-.2 0c-.05 0-.1.01-.14.03h-.01a.59.59 0 00-.13.07l-.03.03s-.02 0-.03.02L3.32 5.03a.51.51 0 000 .77.61.61 0 00.83 0l.76-.7v4.1c0 .3.26.55.59.55.33 0 .59-.24.59-.54V5.1l.76.7c.23.21.6.21.83 0a.51.51 0 000-.77L5.92 3.41a.58.58 0 00-.13-.09z"
    />
    <path
      fill="#828282"
      d="M8.44.16A.46.46 0 008.09 0H.5C.21 0 0 .24 0 .54v11.92c0 .3.22.54.48.54h10.04c.26 0 .48-.24.48-.54V3.25a.58.58 0 00-.14-.38L8.44.16zm1.6 11.76H.96V4.35 2.87 1.08h6.92l2.14 2.4v8.44z"
    />
  </g>
  <g id="new-edit-pencil">
    <path fill="#FAFAFA" d="M5.1 11.21c-1-.68-3.1-2.04-3.5-2.04L8.1.51l3 3.06-6 7.64z" />
    <path
      fill="#54747A"
      d="M.89 13.94l4.04-1.7c.1-.06.2-.13.28-.2l6.66-8.26a.75.75 0 00-.1-.97L8.6.15c-.26-.2-.66-.23-.91.1L.99 8.5c-.07.1-.1.2-.14.31L0 13.22c-.04.75.55.88.89.72zM8.26 1.63l2.15 1.8-5.81 7.22-2.12-1.79 5.78-7.23zM1.95 10.2l1.45 1.23-1.87.78.42-2z"
    />
  </g>
  <g id="new-pin">
    <path
      fill="#878787"
      d="M7.93 1.06C7.2.33 6.23-.27 5.83.12a.41.41 0 00-.08.14c-.26.34-.4.74-.43 1.15l-1.5 1.1c-.82-.14-1.63.02-2.31.44a.6.6 0 00-.28.6c.14.97.56 1.86 1.18 2.57L.05 8.66a.2.2 0 00.3.29l2.53-2.36a4.92 4.92 0 002.65 1.18c.2 0 .4-.1.51-.28a3.29 3.29 0 00.44-2.32l1.1-1.5c.45-.03.87-.19 1.23-.49l.06-.03A.46.46 0 009 2.8c0-.42-.42-1.1-1.07-1.75z"
    />
  </g>
  <g id="literature">
    <g clip-path="url(#clip41)">
      <path
        fill="#955BA5"
        d="M7 4.83v7.37c0 .28-.23.51-.52.51H4.96a.25.25 0 00-.25.25V15l-2.74-2.24a.25.25 0 00-.14-.05h-.68c-.57 0-1.02-.45-1.02-1.02V3.81l6.86 1.02z"
      />
      <path
        fill="#F0C419"
        d="M14.88 1.27v7.88c0 .56-.46 1.02-1.02 1.02h-.68c-.06 0-.1.01-.15.04l-2.73 2.25v-2.04a.25.25 0 00-.25-.25H8.52a.51.51 0 01-.5-.51V2.29l6.86-1.02z"
      />
      <path fill="#F9EAB0" d="M7 4.83H1.14a1.02 1.02 0 010-2.03h5.84c-.18.3-.27.66-.25 1.01-.02.36.07.71.25 1.02z" />
      <path fill="#894B9D" d="M1.14 11.95a.25.25 0 01-.25-.25V5.85a.25.25 0 11.5 0v5.85c0 .14-.1.25-.25.25z" />
      <path
        fill="#ECF0F1"
        d="M5.72 6.6h-3.3a.25.25 0 00-.26.26v3.05c0 .14.12.26.26.26h3.3c.14 0 .26-.12.26-.26V6.86a.25.25 0 00-.26-.25z"
      />
      <path
        fill="#FAC176"
        d="M1.65 4.07H1.4a.25.25 0 110-.51h.25a.25.25 0 010 .5zM5.47 4.07h-2.8a.25.25 0 110-.51h2.8a.25.25 0 010 .5z"
      />
      <path
        fill="#547580"
        d="M4.96 8.14H3.18a.25.25 0 010-.51h1.78a.25.25 0 110 .5zM4.96 9.15H3.18a.25.25 0 010-.5h1.78a.25.25 0 010 .5z"
      />
      <path fill="#F9EAB0" d="M8.01 2.29h5.85a1.02 1.02 0 000-2.04H8c.19.31.28.66.26 1.02.02.36-.07.71-.26 1.02z" />
      <path
        fill="#894B9D"
        d="M6.74 5.09H1.4a1.27 1.27 0 010-2.55h5.34a.25.25 0 110 .51H1.4a.76.76 0 000 1.53h5.34a.25.25 0 110 .5z"
      />
      <path
        fill="#F29C1F"
        d="M13.6 2.54H8.27a.25.25 0 110-.5h5.33a.76.76 0 100-1.53H8.27a.25.25 0 110-.51h5.33a1.27 1.27 0 110 2.54zM13.86 9.4a.25.25 0 01-.25-.25V3.31a.25.25 0 11.5 0v5.84c0 .14-.11.26-.25.26z"
      />
      <path
        fill="#ECF0F1"
        d="M9.28 7.63h3.3c.15 0 .26-.11.26-.26V4.32a.25.25 0 00-.25-.25h-3.3a.25.25 0 00-.26.25v3.05c0 .15.11.26.25.26z"
      />
      <path
        fill="#FAC176"
        d="M13.6 1.52h-.25a.25.25 0 010-.5h.25a.25.25 0 010 .5zM12.33 1.52h-2.8a.25.25 0 010-.5h2.8a.25.25 0 010 .5z"
      />
      <path
        fill="#547580"
        d="M11.82 5.6h-1.78a.25.25 0 010-.51h1.78a.25.25 0 010 .5zM11.82 6.61h-1.78a.25.25 0 110-.5h1.78a.25.25 0 010 .5z"
      />
    </g>
    <defs>
      <clipPath id="clip41"><path fill="#fff" d="M0 0h15v15H0z" /></clipPath>
    </defs>
  </g>
  <g id="connections">
    <path fill="#3B97D3" d="M7.5 15a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" />
    <path
      fill="#285680"
      d="M5.6 9.39c.84-1.83 2.2-3.37 3.9-4.44a.26.26 0 00-.28-.44A10.86 10.86 0 005.2 9.04a.26.26 0 00-.07-.18c-.7-.8-1.27-1.7-1.7-2.69a.26.26 0 00-.47.21A10.81 10.81 0 004.74 9.2c.1.1.26.12.37.02l.01-.01a.26.26 0 00.48.18zM5.27 10.2a10.26 10.26 0 00-.58 4.25 5.53 5.53 0 01-.54-.24v-.5c-.01-1.26.2-2.5.63-3.67a.26.26 0 11.49.17zM2.87 5.43a.26.26 0 01-.32-.17 10.6 10.6 0 01-.48-2.94c.17-.17.34-.33.52-.48v.23c0 1.03.15 2.06.45 3.04a.26.26 0 01-.17.32zM13.17 12.41c-.16.18-.32.36-.5.52-.9-.02-1.81-.16-2.69-.4h-.4a.26.26 0 010-.52h.44a10.41 10.41 0 002.91.4h.24zM8.5 11.97a.26.26 0 00.11-.5c-1-.46-1.92-1.08-2.73-1.84a.26.26 0 10-.36.38 11.03 11.03 0 002.98 1.96zM14.95 6.63a10.2 10.2 0 00-4.38-2.03.26.26 0 01-.2-.17.26.26 0 01-.24-.14.26.26 0 01.12-.35c1.01-.5 2.1-.83 3.21-.99.13.16.24.32.34.48-.96.11-1.9.36-2.8.74 1.37.32 2.68.9 3.82 1.72.06.24.1.49.13.74z"
    />
    <path
      fill="#285680"
      d="M9.95 4.11a.25.25 0 01-.11 0c.01.04.02.08.01.12a.25.25 0 01-.29.22A10.37 10.37 0 003.7 5.6a.26.26 0 11-.24-.46 10.9 10.9 0 016.17-1.19A10.28 10.28 0 007.38 0h.12c.2 0 .39 0 .58.03.93 1.1 1.62 2.38 2.04 3.76a.26.26 0 01-.17.32zM2.74 6.18C1.72 6.87.82 7.74.1 8.74.06 8.5.03 8.25.02 8c.7-.87 1.51-1.63 2.43-2.25a.26.26 0 11.29.43zM9.61 11.52a10.77 10.77 0 00.78-6.67.26.26 0 10-.5.1 10.26 10.26 0 01-.74 6.35.26.26 0 10.46.22zM9.06 12.57c-.54.9-1.2 1.71-1.98 2.42a7.8 7.8 0 01-.7-.07c.88-.74 1.64-1.62 2.23-2.61a.26.26 0 01.36-.1c.12.08.16.24.09.36z"
    />
    <path
      fill="#F0C419"
      d="M10.09 5.43a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07zM3.1 6.72a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07zM5.17 10.6a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06zM9.05 12.93a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07z"
    />
  </g>
  <g id="notification-config">
    <g clip-path="url(#clip42)">
      <path fill="#F29C1F" d="M8.8 12.93a2.07 2.07 0 11-4.14 0l2.07-.26 2.06.26z" />
      <path fill="#F3D55B" d="M4.95 2.18A1.81 1.81 0 016.72 0c.96 0 1.75.74 1.8 1.7l-3.57.48z" />
      <path
        fill="#F0C419"
        d="M12.05 12.93H1.4a.52.52 0 01-.38-.87 4.86 4.86 0 001.3-3.01V6.21a4.4 4.4 0 014.73-4.39l-.34.6a.26.26 0 00.06.33l1 .83c-.02.2-.02.4 0 .6l-1 .83a.26.26 0 00-.06.33l.55.96c.07.1.2.16.32.11l1.22-.46c.16.12.33.22.52.3l.21 1.29c.02.13.13.22.26.22h1.11c.09 0 .17-.05.22-.12v1.41a4.86 4.86 0 001.3 3 .52.52 0 01-.37.88z"
      />
      <path
        fill="#F9EAB0"
        d="M3.36 12.15H2.33a.26.26 0 010-.51h1.03a.26.26 0 010 .51zM11.12 12.15H4.4a.26.26 0 010-.51h6.72a.26.26 0 010 .51zM3.36 6.46a.26.26 0 01-.26-.25c0-1.1.5-2.14 1.36-2.83a.26.26 0 11.32.4 3.1 3.1 0 00-1.16 2.43.26.26 0 01-.26.25z"
      />
      <path
        fill="#2FA8CC"
        d="M8.8 5.95l-1.22.46a.26.26 0 01-.32-.11l-.55-.96A.26.26 0 016.77 5l1-.83c.09.7.46 1.35 1.03 1.77z"
      />
      <path
        fill="#67B9CC"
        d="M12.91 3.58a2.57 2.57 0 00-1.54-2.07 2.56 2.56 0 00-2.57.3 2.57 2.57 0 000 4.14 2.56 2.56 0 003.08 0 2.57 2.57 0 001.03-2.37zM10.34 4.9a1.03 1.03 0 110-2.07 1.03 1.03 0 010 2.07z"
      />
      <path fill="#285680" d="M10.34 4.91a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07z" />
      <path
        fill="#2FA8CC"
        d="M11.37 1.5a2.56 2.56 0 00-2.05 0L9.53.23A.26.26 0 019.8 0h1.1c.14 0 .24.1.27.22l.21 1.29zM11.37 6.25l-.21 1.3-.04.09a.26.26 0 01-.22.12H9.79a.26.26 0 01-.26-.22l-.21-1.29c.65.29 1.4.29 2.05 0zM8.8 1.8a2.57 2.57 0 00-1.02 1.78l-1.01-.83a.26.26 0 01-.06-.33l.34-.6.21-.36c.07-.11.2-.16.32-.12l.94.36.28.1zM13.98 5.34l-.55.96a.26.26 0 01-.32.11l-1.22-.46c.57-.42.94-1.06 1.02-1.77l1.01.83c.1.08.13.22.06.33zM13.92 2.75l-1 .83a2.57 2.57 0 00-1.03-1.78l1.22-.46c.12-.04.25 0 .32.12l.55.96c.07.11.04.25-.06.33z"
      />
      <path
        fill="#2980BA"
        d="M10.34 5.17a1.3 1.3 0 110-2.58 1.3 1.3 0 010 2.58zm0-2.07a.78.78 0 100 1.55.78.78 0 000-1.55z"
      />
    </g>
    <defs>
      <clipPath id="clip42"><path fill="#fff" d="M0 0h15v15H0z" /></clipPath>
    </defs>
  </g>
  <g id="change-email">
    <g clip-path="url(#clip43)">
      <path
        fill="#FFD54F"
        d="m19.58 1.33-7.3 5.29-1.2.87a1.8 1.8 0 0 1-2.15 0l-1.2-.87L.41 1.34c.4-.57 1.07-.9 1.77-.9h15.65c.7 0 1.35.33 1.75.89Z"
      />
      <path
        fill="#FFC107"
        d="m.4 1.34 7.33 5.28-7.1 7.1c-.4-.41-.63-.97-.63-1.55V2.61c0-.46.14-.9.4-1.27ZM20 2.61v9.57c0 .57-.23 1.13-.63 1.53l-7.1-7.1 7.31-5.28c.27.37.42.82.42 1.28Z"
      />
      <path
        fill="#455A64"
        d="M13.04 16.09c-.57 0-.86-.44-.86-1.3a2.2 2.2 0 1 0-.53 1.4c.28.5.82.79 1.4.77 1.73 0 1.73-1.64 1.73-2.18a4.78 4.78 0 1 0-1.45 3.44.44.44 0 0 0-.61-.63 3.91 3.91 0 1 1 1.2-2.8c0 .97-.22 1.3-.88 1.3Zm-3.04 0a1.3 1.3 0 1 1 0-2.61 1.3 1.3 0 0 1 0 2.6Z"
      />
      <path
        fill="#FFA000"
        d="m12.27 6.62-1.2.87a1.8 1.8 0 0 1-2.14 0l-1.2-.87-7.1 7.1c.41.4.96.63 1.54.63h2.2a5.65 5.65 0 0 1 11.26 0h2.2c.57 0 1.12-.23 1.53-.64l-7.1-7.1Z"
      />
    </g>
    <defs>
      <clipPath id="clip43"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="change-password">
    <path fill="#708A96" d="M14.8 4.8v3.1h-1.2V4.8a3.6 3.6 0 0 0-7.2 0v3.1H5.2V4.8a4.8 4.8 0 0 1 9.6 0Z" />
    <path fill="#455A64" d="M14.8 4.8v3.1h-1.2V4.8c0-2-1.6-3.6-3.6-3.6V0c2.6 0 4.8 2.1 4.8 4.8Z" />
    <path fill="#FFD54F" d="M2.8 7.4h14.4V15H2.8V7.4Z" />
    <path fill="#FFC107" d="M10 7.4h7.2V15H10V7.4Z" />
    <path fill="#47979D" d="M0 16c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2Z" />
    <path fill="#54747A" d="M10 14h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-8v-6Z" />
    <path
      fill="#fff"
      d="m11 16.9 1 .7-.6 1-.8-.6v.8H9.4V18l-.8.5-.7-1 1-.6-1-.7.7-1 .8.6V15h1.2v.8l.8-.6.6 1-1 .7ZM6 15.2l-.9.6V15H4v.8l-.9-.6-.6 1 1 .7-1 .7.6 1L4 18v.8H5V18l.9.5.6-1-1-.6 1-.7-.6-1Z"
    />
    <path
      fill="#EEEFFF"
      d="m17.5 16.2-.6-1-.9.6V15H15v.8l-.8-.6-.7 1 1 .7-1 .7.7 1 .8-.6v.8H16V18l.9.5.6-1-1-.6 1-.7ZM12 16.2l-1 .7 1 .7-.6 1-.8-.6v.8H10V15h.6v.8l.8-.5.6 1Z"
    />
  </g>
  <g id="danger">
    <path
      fill="#708A96"
      d="m19.6 14.8-7-12.4A3 3 0 0 0 10 1c-1 0-2 .5-2.5 1.4l-7 12.4c-.6.9-.6 2-.1 2.8A3 3 0 0 0 2.9 19h14.2c1 0 2-.5 2.5-1.4.5-.9.5-2 0-2.8Z"
    />
    <path fill="#455A64" d="M19.6 17.6a3 3 0 0 1-2.5 1.4H10V1c1 0 2 .5 2.5 1.4l7 12.4c.6.9.6 2 .1 2.8Z" />
    <path
      fill="#FFD54F"
      d="M18.7 15.4 11.5 2.8c-.3-.5-.9-.8-1.5-.8s-1.2.3-1.5.8L1.3 15.4c-.4.6-.4 1.2 0 1.7.3.6.8.9 1.5.9h14.4c.7 0 1.2-.3 1.6-.9.3-.5.3-1.1 0-1.7Z"
    />
    <path fill="#FFC107" d="M18.8 17.1c-.4.6-1 .9-1.6.9H10V2c.6 0 1.2.3 1.5.8l7.2 12.6c.4.6.4 1.2 0 1.7Z" />
    <path
      fill="#708A96"
      d="M10 17.1a1.1 1.1 0 1 1 0-2.3 1.1 1.1 0 0 1 0 2.3ZM11.1 12.5a1.1 1.1 0 0 1-2.2 0V6.8a1.1 1.1 0 0 1 2.2 0v5.7Z"
    />
    <path
      fill="#455A64"
      d="M11.1 16c0-.6-.5-1.2-1.1-1.2v2.3c.6 0 1.1-.5 1.1-1.1ZM11.1 12.5V6.8c0-.6-.5-1.1-1.1-1.1v8c.6 0 1.1-.5 1.1-1.2Z"
    />
  </g>
  <g id="upload-avatar">
    <circle
      cx="70"
      cy="70"
      r="69"
      fill="#fff"
      stroke="#EFEFEF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="8 8"
    />
    <path
      d="M34.17 87.05v6.65c0 1.06-.34 1.9-1.01 2.51-.68.62-1.58.93-2.7.93a3.9 3.9 0 0 1-2.72-.91c-.67-.61-1-1.46-1-2.54v-6.64h1.72v6.66c0 .66.17 1.17.5 1.52.34.35.84.53 1.5.53 1.33 0 2-.7 2-2.11v-6.6h1.71Zm8.31 6.33c0 1.14-.26 2.05-.78 2.74a2.5 2.5 0 0 1-2.09 1.02c-.81 0-1.46-.27-1.95-.8v3.5H36V89.6h1.53l.07.76c.49-.6 1.15-.9 2-.9.9 0 1.6.34 2.11 1.02.52.67.77 1.6.77 2.8v.1Zm-1.65-.15c0-.73-.15-1.32-.45-1.75-.29-.44-.7-.65-1.25-.65-.68 0-1.17.28-1.47.84v3.28c.3.57.8.86 1.48.86.53 0 .94-.21 1.24-.64.3-.42.45-1.07.45-1.94ZM45.8 97h-1.66V86.5h1.66V97Zm1.65-3.77c0-.72.14-1.37.43-1.95.28-.59.69-1.03 1.2-1.34a3.39 3.39 0 0 1 1.8-.47c1 0 1.8.32 2.42.96.63.64.97 1.5 1.02 2.56v.39c0 .73-.14 1.38-.42 1.95a3.08 3.08 0 0 1-1.2 1.34c-.52.3-1.13.47-1.8.47a3.22 3.22 0 0 1-2.52-1.04 4.01 4.01 0 0 1-.93-2.78v-.09Zm1.66.15a3 3 0 0 0 .47 1.79c.31.43.75.64 1.31.64s1-.22 1.3-.66c.32-.43.48-1.07.48-1.92 0-.74-.16-1.34-.49-1.77a1.53 1.53 0 0 0-1.3-.66c-.55 0-.98.22-1.3.65a3.21 3.21 0 0 0-.47 1.93ZM60.29 97a2.56 2.56 0 0 1-.2-.69c-.52.55-1.17.83-1.94.83-.74 0-1.35-.22-1.81-.64-.47-.42-.7-.95-.7-1.57 0-.79.28-1.4.87-1.81a4.26 4.26 0 0 1 2.51-.64h1.02V92c0-.39-.1-.7-.32-.92-.22-.23-.54-.35-.98-.35-.38 0-.69.1-.93.29a.87.87 0 0 0-.36.72h-1.66c0-.4.13-.79.4-1.14.27-.35.64-.63 1.1-.83.46-.2.98-.3 1.55-.3.86 0 1.55.22 2.07.65.51.44.78 1.05.8 1.84v3.33c0 .67.08 1.2.27 1.6V97h-1.7Zm-1.83-1.2c.33 0 .64-.08.92-.24.3-.16.51-.37.66-.64v-1.4h-.9c-.61 0-1.07.11-1.38.33-.31.21-.47.52-.47.9 0 .33.1.58.32.77.21.19.5.28.85.28Zm4.81-2.55c0-1.14.26-2.06.8-2.74a2.54 2.54 0 0 1 2.12-1.04c.78 0 1.42.27 1.9.82V86.5h1.66V97h-1.5l-.09-.77c-.5.6-1.16.9-1.98.9-.87 0-1.57-.34-2.11-1.04-.53-.7-.8-1.64-.8-2.84Zm1.66.14c0 .75.14 1.34.43 1.76.3.42.7.63 1.24.63.68 0 1.18-.3 1.49-.9v-3.16c-.3-.6-.8-.9-1.48-.9-.53 0-.95.22-1.24.65-.3.42-.44 1.06-.44 1.92ZM79.67 97a2.56 2.56 0 0 1-.2-.69c-.52.55-1.17.83-1.93.83-.75 0-1.35-.22-1.82-.64-.47-.42-.7-.95-.7-1.57 0-.79.29-1.4.87-1.81a4.26 4.26 0 0 1 2.51-.64h1.02V92c0-.39-.1-.7-.32-.92-.21-.23-.54-.35-.98-.35-.37 0-.68.1-.93.29a.87.87 0 0 0-.36.72h-1.66c0-.4.14-.79.4-1.14.27-.35.64-.63 1.1-.83.46-.2.98-.3 1.55-.3.87 0 1.56.22 2.07.65.52.44.78 1.05.8 1.84v3.33c0 .67.09 1.2.27 1.6V97h-1.7Zm-1.83-1.2c.33 0 .64-.08.93-.24.29-.16.5-.37.65-.64v-1.4h-.9c-.6 0-1.07.11-1.38.33-.31.21-.46.52-.46.9 0 .33.1.58.31.77.21.19.5.28.85.28Zm7.62-.9 1.57-5.3h1.71L86.18 97h-1.44l-2.59-7.4h1.73l1.58 5.3Zm8.78 2.1a2.56 2.56 0 0 1-.2-.69c-.52.55-1.17.83-1.94.83-.74 0-1.35-.22-1.81-.64-.47-.42-.7-.95-.7-1.57 0-.79.28-1.4.87-1.81a4.26 4.26 0 0 1 2.51-.64H94V92c0-.39-.1-.7-.32-.92-.22-.23-.54-.35-.98-.35-.38 0-.69.1-.93.29a.87.87 0 0 0-.36.72h-1.66c0-.4.13-.79.4-1.14.27-.35.64-.63 1.1-.83.46-.2.98-.3 1.55-.3.86 0 1.55.22 2.07.65.51.44.78 1.05.8 1.84v3.33c0 .67.08 1.2.27 1.6V97h-1.7Zm-1.83-1.2c.33 0 .64-.08.92-.24.3-.16.51-.37.66-.64v-1.4h-.9c-.61 0-1.07.11-1.38.33-.31.21-.47.52-.47.9 0 .33.1.58.32.77.21.19.5.28.85.28Zm7.2-8v1.8h1.3v1.23h-1.3v4.13c0 .29.06.5.17.62.11.12.31.18.6.18.19 0 .38-.02.58-.07v1.29c-.38.1-.74.16-1.1.16-1.27 0-1.9-.7-1.9-2.12v-4.19h-1.23V89.6h1.22v-1.8h1.66Zm7.14 9.2a2.57 2.57 0 0 1-.19-.69c-.53.55-1.17.83-1.94.83a2.6 2.6 0 0 1-1.82-.64c-.47-.42-.7-.95-.7-1.57 0-.79.29-1.4.87-1.81a4.26 4.26 0 0 1 2.52-.64h1.02V92c0-.39-.11-.7-.33-.92-.2-.23-.54-.35-.97-.35-.38 0-.69.1-.93.29a.87.87 0 0 0-.36.72h-1.67c0-.4.14-.79.4-1.14.28-.35.64-.63 1.1-.83.47-.2.98-.3 1.55-.3.87 0 1.56.22 2.08.65.51.44.77 1.05.79 1.84v3.33c0 .67.1 1.2.28 1.6V97h-1.7Zm-1.82-1.2c.33 0 .63-.08.92-.24.3-.16.51-.37.66-.64v-1.4h-.9c-.61 0-1.08.11-1.39.33-.3.21-.46.52-.46.9 0 .33.1.58.31.77.22.19.5.28.86.28Zm8.99-4.68a4.1 4.1 0 0 0-.68-.05c-.76 0-1.27.29-1.53.87V97h-1.67v-7.4h1.59l.04.83c.4-.64.96-.96 1.67-.96.24 0 .43.03.59.1l-.01 1.55ZM60.42 67.84a6.22 6.22 0 0 1-5.9-4.06l-.07-.18a5.57 5.57 0 0 1-.28-1.73V51.03L50.12 63.9a3.6 3.6 0 0 0 2.66 4.38l25.77 6.6a4 4 0 0 0 .96.11 3.7 3.7 0 0 0 3.6-2.6l1.5-4.56h-24.2ZM65 51.14a3.26 3.26 0 0 0 3.33-3.18c0-1.76-1.5-3.18-3.33-3.18a3.26 3.26 0 0 0-3.33 3.18c0 1.75 1.5 3.18 3.33 3.18Z"
      fill="#B7B7B7"
    />
    <path
      d="M85.83 40h-25a4.08 4.08 0 0 0-4.16 3.98v17.5c0 2.19 1.87 3.98 4.16 3.98h25c2.3 0 4.17-1.79 4.17-3.98v-17.5c0-2.2-1.87-3.98-4.17-3.98Zm-25 3.18h25c.46 0 .84.36.84.8v11.3L81.4 49.4a3.05 3.05 0 0 0-2.23-.98c-.87 0-1.68.37-2.23 1l-6.19 7.1-2.02-1.93a3.02 3.02 0 0 0-4.13 0L60 59V43.97c0-.44.37-.8.83-.8Z"
      fill="#B7B7B7"
    />
  </g>
  <g id="upload-cover">
    <circle
      cx="70"
      cy="70"
      r="69"
      fill="#fff"
      stroke="#EFEFEF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="8 8"
    />
    <path
      d="M36.52 87.05v6.65c0 1.06-.34 1.9-1.02 2.51-.67.62-1.57.93-2.7.93a3.9 3.9 0 0 1-2.71-.91c-.67-.61-1-1.46-1-2.54v-6.64h1.72v6.66c0 .66.16 1.17.5 1.52.34.35.84.53 1.5.53 1.32 0 1.99-.7 1.99-2.11v-6.6h1.72Zm8.3 6.33c0 1.14-.25 2.05-.77 2.74a2.5 2.5 0 0 1-2.1 1.02c-.8 0-1.45-.27-1.94-.8v3.5h-1.66V89.6h1.53l.07.76c.49-.6 1.15-.9 1.99-.9.9 0 1.6.34 2.12 1.02.51.67.77 1.6.77 2.8v.1Zm-1.65-.15c0-.73-.14-1.32-.44-1.75-.3-.44-.71-.65-1.26-.65-.68 0-1.16.28-1.46.84v3.28c.3.57.8.86 1.48.86.52 0 .94-.21 1.23-.64.3-.42.45-1.07.45-1.94ZM48.15 97h-1.66V86.5h1.66V97Zm1.64-3.77c0-.72.15-1.37.43-1.95.29-.59.7-1.03 1.21-1.34a3.39 3.39 0 0 1 1.8-.47c1 0 1.8.32 2.42.96.62.64.96 1.5 1.01 2.56v.39c0 .73-.13 1.38-.42 1.95a3.08 3.08 0 0 1-1.2 1.34c-.52.3-1.12.47-1.8.47a3.22 3.22 0 0 1-2.51-1.04 4.02 4.02 0 0 1-.94-2.78v-.09Zm1.66.15a3 3 0 0 0 .47 1.79c.32.43.76.64 1.32.64s1-.22 1.3-.66c.32-.43.47-1.07.47-1.92 0-.74-.16-1.34-.48-1.77a1.53 1.53 0 0 0-1.3-.66c-.55 0-.98.22-1.3.65a3.21 3.21 0 0 0-.48 1.93ZM62.63 97a2.56 2.56 0 0 1-.19-.69c-.53.55-1.17.83-1.94.83-.74 0-1.35-.22-1.82-.64-.47-.42-.7-.95-.7-1.57 0-.79.29-1.4.87-1.81a4.26 4.26 0 0 1 2.52-.64h1.02V92c0-.39-.11-.7-.32-.92-.22-.23-.54-.35-.98-.35-.38 0-.69.1-.93.29a.87.87 0 0 0-.36.72h-1.67c0-.4.14-.79.4-1.14.28-.35.64-.63 1.1-.83.47-.2.98-.3 1.55-.3.87 0 1.56.22 2.07.65.52.44.78 1.05.8 1.84v3.33c0 .67.1 1.2.28 1.6V97h-1.7Zm-1.82-1.2c.33 0 .63-.08.92-.24.3-.16.51-.37.66-.64v-1.4h-.9c-.61 0-1.08.11-1.39.33-.3.21-.46.52-.46.9 0 .33.1.58.31.77.22.19.5.28.86.28Zm4.8-2.55c0-1.14.27-2.06.8-2.74a2.54 2.54 0 0 1 2.13-1.04c.78 0 1.41.27 1.9.82V86.5h1.66V97h-1.5l-.09-.77c-.5.6-1.16.9-1.99.9-.86 0-1.57-.34-2.1-1.04-.54-.7-.8-1.64-.8-2.84Zm1.67.14c0 .75.14 1.34.43 1.76.29.42.7.63 1.24.63.67 0 1.17-.3 1.49-.9v-3.16c-.3-.6-.8-.9-1.48-.9-.54 0-.95.22-1.24.65-.3.42-.44 1.06-.44 1.92Zm13.35 2.42c.42 0 .76-.12 1.04-.36.27-.24.42-.54.43-.9h1.57c-.02.46-.16.9-.43 1.3s-.63.7-1.1.94c-.45.23-.95.35-1.48.35a3.15 3.15 0 0 1-2.47-1c-.6-.68-.9-1.6-.9-2.78v-.17c0-1.13.3-2.03.9-2.7a3.12 3.12 0 0 1 2.46-1.02c.88 0 1.6.25 2.14.77.56.51.85 1.18.88 2.02H82.1a1.51 1.51 0 0 0-.43-1.05 1.38 1.38 0 0 0-1.04-.41c-.53 0-.95.2-1.24.59-.3.39-.44.98-.44 1.77v.26c0 .8.14 1.4.43 1.8.29.4.7.6 1.25.6Zm4.12-2.58c0-.72.15-1.37.43-1.95.3-.59.7-1.03 1.21-1.34a3.39 3.39 0 0 1 1.8-.47c1 0 1.8.32 2.42.96.63.64.96 1.5 1.01 2.56l.01.39c0 .73-.14 1.38-.42 1.95a3.08 3.08 0 0 1-1.2 1.34c-.53.3-1.13.47-1.81.47a3.22 3.22 0 0 1-2.51-1.04 4.02 4.02 0 0 1-.94-2.78v-.09Zm1.66.15a3 3 0 0 0 .48 1.79c.31.43.75.64 1.3.64.57 0 1-.22 1.31-.66.32-.43.48-1.07.48-1.92 0-.74-.17-1.34-.49-1.77a1.53 1.53 0 0 0-1.3-.66c-.55 0-.98.22-1.3.65a3.21 3.21 0 0 0-.48 1.93Zm9.26 1.51 1.57-5.29h1.71L96.4 97h-1.44l-2.59-7.4h1.73l1.58 5.3Zm7.63 2.25c-1.05 0-1.9-.33-2.56-1a3.63 3.63 0 0 1-.98-2.65v-.2c0-.74.14-1.4.42-1.98a3.17 3.17 0 0 1 2.93-1.85c1 0 1.78.33 2.33.97.55.64.83 1.55.83 2.73v.67h-4.84c.05.6.26 1.1.61 1.45.36.35.81.53 1.35.53.77 0 1.39-.3 1.86-.92l.9.85c-.3.44-.7.79-1.19 1.03-.5.25-1.05.37-1.66.37Zm-.2-6.34c-.45 0-.82.16-1.1.48a2.5 2.5 0 0 0-.54 1.33h3.17v-.12a2 2 0 0 0-.45-1.26 1.38 1.38 0 0 0-1.08-.43Zm8.47.32a4.11 4.11 0 0 0-.67-.05c-.76 0-1.28.29-1.54.87V97h-1.66v-7.4h1.58l.05.83c.4-.64.95-.96 1.66-.96.24 0 .44.03.6.1l-.02 1.55ZM60.42 67.84a6.22 6.22 0 0 1-5.9-4.06l-.07-.18a5.57 5.57 0 0 1-.28-1.73V51.03L50.12 63.9a3.6 3.6 0 0 0 2.66 4.38l25.77 6.6a4 4 0 0 0 .96.11 3.7 3.7 0 0 0 3.6-2.6l1.5-4.56h-24.2ZM65 51.14a3.26 3.26 0 0 0 3.33-3.18c0-1.76-1.5-3.18-3.33-3.18a3.26 3.26 0 0 0-3.33 3.18c0 1.75 1.5 3.18 3.33 3.18Z"
      fill="#B7B7B7"
    />
    <path
      d="M85.83 40h-25a4.08 4.08 0 0 0-4.16 3.98v17.5c0 2.19 1.87 3.98 4.16 3.98h25c2.3 0 4.17-1.79 4.17-3.98v-17.5c0-2.2-1.87-3.98-4.17-3.98Zm-25 3.18h25c.46 0 .84.36.84.8v11.3L81.4 49.4a3.05 3.05 0 0 0-2.23-.98c-.87 0-1.68.37-2.23 1l-6.19 7.1-2.02-1.93a3.02 3.02 0 0 0-4.13 0L60 59V43.97c0-.44.37-.8.83-.8Z"
      fill="#B7B7B7"
    />
  </g>
  <g id="upload-file">
    <circle
      cx="70"
      cy="70"
      r="69"
      fill="#fff"
      stroke="#EFEFEF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="8 8"
    />
    <path
      d="M44.27 87.05v6.65c0 1.06-.34 1.9-1.02 2.51-.67.62-1.57.93-2.7.93a3.9 3.9 0 0 1-2.71-.91c-.67-.61-1-1.46-1-2.54v-6.64h1.71v6.66c0 .66.17 1.17.51 1.52.34.35.83.53 1.49.53 1.33 0 2-.7 2-2.11v-6.6h1.72Zm8.3 6.33c0 1.14-.25 2.05-.77 2.74a2.5 2.5 0 0 1-2.1 1.02c-.8 0-1.45-.27-1.94-.8v3.5H46.1V89.6h1.53l.07.76c.48-.6 1.15-.9 1.99-.9.9 0 1.6.34 2.11 1.02.52.67.78 1.6.78 2.8v.1Zm-1.65-.15c0-.73-.15-1.32-.44-1.75-.3-.44-.71-.65-1.26-.65-.68 0-1.17.28-1.46.84v3.28c.3.57.8.86 1.47.86.53 0 .95-.21 1.24-.64.3-.42.45-1.07.45-1.94ZM55.9 97h-1.66V86.5h1.66V97Zm1.64-3.77c0-.72.14-1.37.43-1.95.29-.59.7-1.03 1.21-1.34a3.39 3.39 0 0 1 1.8-.47c.99 0 1.8.32 2.42.96.62.64.96 1.5 1.01 2.56v.39c0 .73-.13 1.38-.42 1.95a3.08 3.08 0 0 1-1.2 1.34c-.52.3-1.12.47-1.8.47a3.22 3.22 0 0 1-2.51-1.04 4.02 4.02 0 0 1-.94-2.78v-.09Zm1.66.15a3 3 0 0 0 .47 1.79c.32.43.75.64 1.32.64.56 0 1-.22 1.3-.66.32-.43.47-1.07.47-1.92 0-.74-.16-1.34-.48-1.77a1.53 1.53 0 0 0-1.3-.66c-.55 0-.98.22-1.3.65a3.21 3.21 0 0 0-.48 1.93ZM70.38 97a2.56 2.56 0 0 1-.19-.69c-.53.55-1.18.83-1.94.83-.74 0-1.35-.22-1.82-.64-.47-.42-.7-.95-.7-1.57 0-.79.29-1.4.87-1.81a4.26 4.26 0 0 1 2.52-.64h1.02V92c0-.39-.11-.7-.33-.92-.21-.23-.54-.35-.97-.35-.38 0-.7.1-.93.29a.87.87 0 0 0-.37.72h-1.66c0-.4.14-.79.4-1.14.28-.35.64-.63 1.1-.83.47-.2.98-.3 1.55-.3.87 0 1.56.22 2.07.65.52.44.78 1.05.8 1.84v3.33c0 .67.09 1.2.28 1.6V97h-1.7Zm-1.82-1.2c.32 0 .63-.08.92-.24.29-.16.5-.37.66-.64v-1.4h-.9c-.62 0-1.08.11-1.39.33-.3.21-.46.52-.46.9 0 .33.1.58.31.77.22.19.5.28.86.28Zm4.8-2.55c0-1.14.27-2.06.8-2.74a2.54 2.54 0 0 1 2.12-1.04c.79 0 1.42.27 1.9.82V86.5h1.67V97h-1.5l-.09-.77c-.5.6-1.16.9-1.99.9-.87 0-1.57-.34-2.1-1.04-.54-.7-.8-1.64-.8-2.84Zm1.67.14c0 .75.14 1.34.43 1.76.29.42.7.63 1.23.63.68 0 1.18-.3 1.5-.9v-3.16c-.31-.6-.8-.9-1.48-.9-.54 0-.95.22-1.25.65-.29.42-.43 1.06-.43 1.92ZM85.79 97v-6.17h-1.13V89.6h1.13v-.5c0-.58.12-1.08.36-1.5a2.3 2.3 0 0 1 1.03-.93 4.6 4.6 0 0 1 2.64-.2c.34.08.68.18 1.04.3l-.25 1.37a5.29 5.29 0 0 0-1.72-.33c-.5 0-.87.11-1.1.34-.23.22-.34.55-.34.99v.46h1.45v1.23h-1.45V97h-1.66Zm5.86 0H90v-7.4h1.66V97Zm3.75 0h-1.66V86.5h1.66V97Zm5.21.14c-1.05 0-1.9-.33-2.56-1a3.63 3.63 0 0 1-.98-2.65v-.2c0-.74.14-1.4.43-1.98a3.17 3.17 0 0 1 2.93-1.85c1 0 1.77.33 2.32.97.55.64.83 1.55.83 2.73v.67h-4.83c.05.6.25 1.1.6 1.45.36.35.82.53 1.36.53.76 0 1.38-.3 1.86-.92l.9.85c-.3.44-.7.79-1.2 1.03-.49.25-1.04.37-1.66.37Zm-.2-6.34c-.45 0-.82.16-1.1.48a2.5 2.5 0 0 0-.54 1.33h3.17v-.12a2 2 0 0 0-.45-1.26 1.38 1.38 0 0 0-1.08-.43ZM75.2 49.55a2.46 2.46 0 0 1-2.46-2.46V39H60.16a3.87 3.87 0 0 0-3.87 3.87v28.26A3.87 3.87 0 0 0 60.16 75h19.68a3.87 3.87 0 0 0 3.87-3.87V49.55h-8.5ZM62.05 64.3h5.12a1.05 1.05 0 1 1 0 2.11h-5.12a1.05 1.05 0 1 1 0-2.1ZM61 59.74c0-.58.47-1.05 1.05-1.05h15.47a1.05 1.05 0 1 1 0 2.1H62.05c-.58 0-1.05-.47-1.05-1.05Zm16.52-6.68a1.05 1.05 0 1 1 0 2.11H62.05a1.05 1.05 0 1 1 0-2.1h15.47Z"
      fill="#B7B7B7"
    />
    <path
      d="M74.85 47.09c0 .19.16.35.35.35h8.04c-.2-.36-.44-.69-.74-.97l-6.78-6.41a3.88 3.88 0 0 0-.87-.62v7.65Z"
      fill="#B7B7B7"
    />
  </g>
  <g id="account-link" box="59 60">
    <path
      d="M29.983 0C20.425 0 12.65 7.78 12.65 17.344c0 5.923 2.984 11.162 7.527 14.292a29.867 29.867 0 0 0-11.394 7.15C3.592 43.98.539 50.74.065 58.002-.007 59.103.895 60 2 60h.685c1.104 0 1.992-.899 2.078-2 1.022-13.026 11.943-23.313 25.22-23.313 9.558 0 17.335-7.78 17.335-17.343C47.318 7.78 39.54 0 29.983 0Zm0 30c-6.974 0-12.649-5.677-12.649-12.656 0-6.979 5.675-12.656 12.65-12.656 6.974 0 12.649 5.677 12.649 12.656 0 6.979-5.675 12.656-12.65 12.656ZM57.086 33.325l-1.009-.893a5.691 5.691 0 0 0-8.032.483l-2.888 3.258a1.786 1.786 0 0 0 .15 2.517l.272.24a1.783 1.783 0 0 0 2.518-.15l2.888-3.259a1.765 1.765 0 0 1 2.486-.15l1.008.895c.727.644.795 1.76.15 2.486l-6.315 7.124a1.759 1.759 0 0 1-2.126.396 1.927 1.927 0 0 0-2.329.433l-.049.056a1.917 1.917 0 0 0-.453 1.629 1.918 1.918 0 0 0 1.004 1.36 5.685 5.685 0 0 0 6.894-1.269l6.315-7.123a5.698 5.698 0 0 0-.484-8.033Z"
    />
    <path
      d="m43.69 52.309-.271-.241a1.786 1.786 0 0 0-2.518.152l-2.886 3.258a1.765 1.765 0 0 1-2.486.15l-1.01-.895a1.76 1.76 0 0 1-.15-2.485l6.316-7.124a1.765 1.765 0 0 1 2.094-.411c.816.4 1.807.206 2.411-.476l.023-.026a1.89 1.89 0 0 0 .448-1.595 1.89 1.89 0 0 0-.974-1.34 5.67 5.67 0 0 0-6.942 1.243L31.43 49.64a5.697 5.697 0 0 0 .483 8.032l1.009.894a5.666 5.666 0 0 0 3.771 1.43 5.68 5.68 0 0 0 4.262-1.913l2.888-3.258a1.782 1.782 0 0 0-.153-2.517Z"
    />
  </g>
  <g id="account-create" box="64 64">
    <path
      d="M29.58 0a17.14 17.14 0 0 0-9.67 31.26 29.46 29.46 0 0 0-11.25 7.06 29.45 29.45 0 0 0-8.6 18.96c-.07 1.1.84 2 1.94 2h.62c1.1 0 2-.9 2.08-2a25.01 25.01 0 0 1 24.88-23 17.14 17.14 0 0 0 0-34.28Zm0 29.64a12.5 12.5 0 0 1 0-25 12.5 12.5 0 0 1 0 25ZM59.7 49.9a2 2 0 0 0 1.99-2v-.63a2 2 0 0 0-2-2h-9.77v-9.79a2 2 0 0 0-2-2h-.62a2 2 0 0 0-2 2v9.79h-9.77a2 2 0 0 0-2 2v.63c0 1.1.9 2 2 2h9.77v9.78c0 1.1.89 2 2 2h.62a2 2 0 0 0 2-2V49.9h9.77Z"
    />
  </g>
  <g id="complete" box="60 60">
    <path
      d="M30 0C13.46 0 0 13.46 0 30s13.46 30 30 30 30-13.46 30-30S46.54 0 30 0Zm0 54.55A24.57 24.57 0 0 1 5.45 30 24.57 24.57 0 0 1 30 5.45 24.57 24.57 0 0 1 54.55 30 24.57 24.57 0 0 1 30 54.55Z"
      fill="#47979D"
    />
    <path
      d="M41.25 19.4 25.82 34.81l-7.07-7.07a2.73 2.73 0 0 0-3.86 3.86l9 9a2.73 2.73 0 0 0 3.86 0l17.36-17.36a2.73 2.73 0 0 0-3.86-3.86Z"
      fill="#47979D"
    />
  </g>
  <g id="community" box="90 90">
    <circle cx="18.5" cy="11.5" r="8.5" fill="#FFCA28" />
    <circle cx="72.5" cy="11.5" r="8.5" fill="#FFCA28" />
    <circle cx="44.5" cy="61.5" r="8.5" fill="#FFCA28" />
    <path
      d="m89.75 36.51-1.87-9.36a7.1 7.1 0 0 0-6.76-5.56h-4.05A11.44 11.44 0 0 0 71.87 0a11.43 11.43 0 0 0-5.2 21.6H62.6a7.1 7.1 0 0 0-6.76 5.55l-.43 2.19H34.58l-.43-2.19a7.1 7.1 0 0 0-6.76-5.56h-4.05A11.44 11.44 0 0 0 18.14 0a11.43 11.43 0 0 0-5.21 21.6H8.88a7.1 7.1 0 0 0-6.76 5.55L.25 36.51a2.27 2.27 0 0 0 2.23 2.7h11.2l16.53 36.03c-.6.8-1.03 1.7-1.22 2.7l-1.87 9.35A2.27 2.27 0 0 0 29.34 90h31.32a2.26 2.26 0 0 0 2.22-2.7L61 77.92c-.2-.98-.62-1.9-1.22-2.7L76.3 39.23h11.22a2.26 2.26 0 0 0 2.22-2.7ZM71.87 4.53a6.9 6.9 0 0 1 0 13.8 6.9 6.9 0 0 1 0-13.8Zm0 18.33c1.26 0 2.47-.2 3.6-.59l-3.6 3.62-3.6-3.62c1.13.38 2.34.6 3.6.6ZM18.13 4.53a6.9 6.9 0 0 1 0 13.8 6.9 6.9 0 0 1 0-13.8Zm0 18.33c1.26 0 2.47-.2 3.6-.59l-3.6 3.62-3.6-3.62c1.13.38 2.34.6 3.6.6ZM6.56 28.04c.2-1 1.3-1.92 2.32-1.92h3.1l4.55 4.57a2.26 2.26 0 0 0 3.2 0l4.56-4.57h3.1c1.01 0 2.12.92 2.32 1.92l1.32 6.65H5.23l1.33-6.65ZM32.1 85.47l1.33-6.65c.2-1 1.3-1.92 2.32-1.92h3.1l4.55 4.58a2.26 2.26 0 0 0 3.2 0l4.56-4.58h3.1c1 0 2.11.92 2.31 1.92l1.33 6.65H32.1ZM45 69.12a6.9 6.9 0 0 1 0-13.81 6.9 6.9 0 0 1 0 13.8Zm0 4.52c1.26 0 2.47-.2 3.6-.58L45 76.67l-3.6-3.61c1.13.37 2.34.58 3.6.58Zm11-1.02a6.43 6.43 0 0 0-1.75-.24H50.2a11.44 11.44 0 0 0-5.2-21.6 11.43 11.43 0 0 0-5.2 21.6h-4.05c-.6 0-1.19.08-1.76.24l-15.32-33.4h15.12a2.27 2.27 0 0 0 2.22-2.7l-.52-2.66h19.03l-.53 2.65a2.26 2.26 0 0 0 2.22 2.7h15.12L56.01 72.63Zm2.97-37.93 1.32-6.65c.2-1 1.31-1.92 2.32-1.92h3.1l4.55 4.58a2.26 2.26 0 0 0 3.21 0l4.56-4.58h3.09c1.01 0 2.12.91 2.32 1.92l1.33 6.65h-25.8Z"
      fill="#000"
    />
  </g>
  <g id="eduniverse" box="90 90">
    <g clip-path="url(#clip-eduniverse)">
      <path fill="#FFCA28" d="M21 6h41v29H21z" />
      <path
        d="M89.105 57.966 77.219 46.08c-2.358-2.358-6.651-4.136-9.985-4.136h-31.17c-4.213 0-7.64 3.427-7.64 7.64v.917c0 4.212 3.427 6.64 7.64 6.64H46.27l-2.627 3.626c-1.11 1.11-3.63 1.949-5.186 1.728L10.24 58.75c-3.45-.493-6.599-.316-8.651 1.737C.312 61.762-.233 63.46.092 65.148c.381 1.98 1.892 3.67 4.145 4.635L31.106 81.3c2.942 1.26 7.5 1.625 10.605.85l11.275-2.82c2.637-.66 6.65-2.04 9.135-3.143l2.978-1.322c1.1-.489 2.978-.097 3.791.791l10.758 11.747a3.048 3.048 0 0 0 2.255.992c.737 0 1.476-.266 2.063-.803 1.245-1.14 1.33-2.073.19-3.317L73.397 72.528c-2.567-2.804-7.302-3.792-10.778-2.25l-2.978 1.323c-2.14.95-5.866 2.232-8.138 2.8L39.228 77.22c-1.805.451-5.005.194-6.715-.539L4.866 65.261s.764-2.46 4.51-2.46l27.22 4.745c3.45.495 7.907-.994 10.37-3.457l3.603-3.602c2.51-2.51 1.958-4.766 1.605-5.62-.354-.853-1.56-2.838-5.109-2.838H36.064c-1.064 0-1.528-1.617-1.528-2.445 0-.828.464-2.528 1.528-2.528h31.17c1.705 0 5.458 1.14 6.664 2.347l11.885 11.885c1.194 1.193 2.128 2.193 3.322 1a3.057 3.057 0 0 0 0-4.322ZM6.27 7.719h2.986V24.83c0 1.688.368 3.056 2.056 3.056a3.056 3.056 0 0 0 3.056-3.056V7.72h3.972v27.197a3.056 3.056 0 0 0 3.056 3.056h40.338a3.056 3.056 0 0 0 3.056-3.056V7.719h12.07c1.688 0 3.056-1.031 3.056-2.719s-1.368-2.393-3.056-2.393H6.27c-1.688 0-3.056.706-3.056 2.393 0 1.688 1.368 2.719 3.056 2.719Zm53.408 25.14H23.452V7.72h36.226v25.14Z"
        fill="#000"
      />
    </g>
    <defs>
      <clipPath id="clip-eduniverse">
        <path fill="#fff" d="M0 0h90v90H0z" />
      </clipPath>
    </defs>
  </g>
  <g id="competitions" box="90 90">
    <path
      d="M24.47 56h41.06c.4 0 .77.06 1.04.16.28.1.43.23.43.37V88H23V56.53c0-.14.15-.27.43-.37.27-.1.65-.16 1.04-.16v0ZM2 69a4 4 0 0 1 4-4h17v23H6a4 4 0 0 1-4-4V69Z"
      stroke="#000"
      fill="transparent"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M88 74a4 4 0 0 0-4-4H67v18h17a4 4 0 0 0 4-4V74Z"
      stroke="#000"
      fill="transparent"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.5 14c-.4-.4-2.17-4.5-3-6.5L19 6l5.5.5H31L32 5l4-3 13-.5 6.5 2L59 6l12 .5-1 3-1.5 4.5-4 6-5.5 2.5-3.5 2L51 29l-6 1-5.5-1.5C38 27 35 23.9 35 23.5c0-.4-1.67-.17-2.5 0-2.33-1.17-7-3.6-7-4 0-.5-3.5-5-4-5.5Z"
      fill="#FFCA28"
    />
    <path
      d="M71 4H59l-.12.02A14.42 14.42 0 0 0 56.04.45 2 2 0 0 0 54.77 0H35.23c-.47 0-.91.16-1.27.45-.1.09-1.54 1.33-2.84 3.58L31 4H19a2 2 0 0 0-1.99 2.22c.68 6.12 5.14 17.88 17.03 19.55a49.02 49.02 0 0 0 4.62 5.6c.1.1.23.16.34.24v4.4h-4a2 2 0 0 0-2 2v6h-4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h32a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-4v-6a2 2 0 0 0-2-2h-4v-4.4c.11-.08.24-.13.34-.23a49.27 49.27 0 0 0 4.62-5.6C67.86 24.1 72.3 12.33 72.99 6.21A2 2 0 0 0 71 4ZM21.4 8h8.12c-.23.9-.42 1.86-.49 2.93a20.3 20.3 0 0 0 2.14 9.98C24.7 18.3 22.26 11.55 21.4 8ZM59 52H31v-4h28v4Zm-6-8H37v-4h16v4Zm-10-8v-4h4v4h-4Zm6.02-8h-8.04c-5.57-6.04-8.24-11.67-7.96-16.74.21-3.85 2.11-6.3 3-7.26h17.95c.9.96 2.8 3.42 3.01 7.26.28 5.07-2.4 10.7-7.96 16.74Zm9.82-7.1a20.27 20.27 0 0 0 2.13-9.98A15.65 15.65 0 0 0 60.49 8h8.09c-.87 3.53-3.36 10.27-9.74 12.9Z"
      fill="#000"
    />
  </g>
  <g id="career_resources" box="90 90">
    <path
      d="M87.19 19.69H2.8v63.5a4 4 0 0 0 4 4H83.2a4 4 0 0 0 4-4v-63.5Z"
      stroke="#000"
      fill="transparent"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M87.19 23.69a4 4 0 0 0-4-4H6.8a4 4 0 0 0-4 4v12.87c0 6.22 5.04 11.25 11.25 11.25h61.88c6.21 0 11.25-5.03 11.25-11.25V23.7Z"
      stroke="#000"
      fill="transparent"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M27 20V8.67C27 5.54 29.01 3 31.5 3h27C60.99 3 63 5.54 63 8.67V20"
      stroke="#000"
      fill="transparent"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M45 60c-4.42 0-8-2.69-8-6V42c0-3.31 3.58-6 8-6s8 2.69 8 6v12c0 3.31-3.58 6-8 6Z"
      fill="#FFCA28"
      stroke="#000"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M50.63 47.81H39.37"
      stroke="#000"
      fill="transparent"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
  </g>
  <g id="circle_arrow" box="26 26">
    <circle cx="13" cy="13" r="12" stroke="#47979D" fill="transparent" stroke-width="2" />
    <path
      d="M11.97 7.96a1 1 0 1 0-1.41 1.41l1.41-1.41ZM15.6 13l.7.7a1 1 0 0 0 0-1.4l-.7.7Zm-5.04 3.63a1 1 0 1 0 1.41 1.41l-1.41-1.41Zm0-7.26 4.33 4.34 1.42-1.42-4.34-4.33-1.41 1.41Zm4.33 2.92-4.33 4.34 1.41 1.41 4.34-4.33-1.42-1.42Z"
      fill="#47979D"
    />
  </g>
  <g id="club-chat" box="20 20">
    <path
      d="M18.05 6.6A8.74 8.74 0 0 0 10 1.26h-.04a8.7 8.7 0 0 0-8.69 8.8c0 1.35.33 2.7.94 3.9v2.96c0 .5.4.9.9.9h2.96c1.2.61 2.54.93 3.9.94H10a8.72 8.72 0 0 0 8.05-12.14ZM6.1 10.95a.94.94 0 1 1 0-1.88.94.94 0 0 1 0 1.88Zm3.9 0a.94.94 0 1 1 0-1.88.94.94 0 0 1 0 1.88Zm3.9 0a.94.94 0 1 1 0-1.88.94.94 0 0 1 0 1.88Z"
      fill="#fff"
    />
  </g>
  <g id="file-type" box="40 40">
    <g clip-path="url(#clip0_1242_7680)" fill="#54747A">
      <path
        d="M34.17 40h-20A4.17 4.17 0 0 1 10 35.83v-25c0-2.3 1.87-4.16 4.17-4.16h20c2.3 0 4.16 1.86 4.16 4.16v25c0 2.3-1.87 4.17-4.16 4.17Zm-20-31.67a2.5 2.5 0 0 0-2.5 2.5v25a2.5 2.5 0 0 0 2.5 2.5h20a2.5 2.5 0 0 0 2.5-2.5v-25a2.5 2.5 0 0 0-2.5-2.5h-20Z"
      />
      <path
        d="M7.5 35H5.83a4.17 4.17 0 0 1-4.16-4.17V4.17C1.67 1.87 3.54 0 5.83 0h20C28.13 0 30 1.87 30 4.17a.83.83 0 0 1-1.67 0 2.5 2.5 0 0 0-2.5-2.5h-20a2.5 2.5 0 0 0-2.5 2.5v26.66a2.5 2.5 0 0 0 2.5 2.5H7.5a.83.83 0 0 1 0 1.67ZM30.83 28.33H17.5a.83.83 0 0 1 0-1.66h13.33a.83.83 0 0 1 0 1.66ZM30.83 35H17.5a.83.83 0 0 1 0-1.67h13.33a.83.83 0 0 1 0 1.67Z"
      />
      <path
        d="M30.83 21.67H17.5a.83.83 0 0 1 0-1.67h13.33a.83.83 0 0 1 0 1.67ZM30.83 15H17.5a.83.83 0 0 1 0-1.67h13.33a.83.83 0 0 1 0 1.67Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_1242_7680"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </g>
  <g id="empty-posts" box="50 24">
    <path
      d="M48.46 7.98h-6.53V1.61c0-.9-.7-1.61-1.54-1.61H1.54C.7 0 0 .72 0 1.6v34.6C0 39.4 2.5 42 5.58 42h38.84A5.7 5.7 0 0 0 50 36.2V9.58c0-.89-.7-1.6-1.54-1.6ZM3.09 36.2V3.21h35.75V36.2c0 .94.22 1.82.6 2.6H5.57a2.55 2.55 0 0 1-2.5-2.6Zm41.33 2.6a2.55 2.55 0 0 1-2.49-2.6v-25h4.98v25c0 1.43-1.11 2.6-2.49 2.6Z"
      fill="#557479"
    />
    <path
      d="M8.2 12.26h26.05c.86 0 1.56-.7 1.56-1.58 0-.87-.7-1.57-1.56-1.57H8.2c-.86 0-1.56.7-1.56 1.57 0 .87.7 1.58 1.56 1.58ZM34.25 16.18H13.33c-.86 0-1.56.7-1.56 1.58 0 .87.7 1.57 1.56 1.57h20.92c.86 0 1.56-.7 1.56-1.57 0-.87-.7-1.58-1.56-1.58ZM34.25 30.33H8.33c-.86 0-1.56.7-1.56 1.58 0 .87.7 1.57 1.56 1.57h25.92c.86 0 1.56-.7 1.56-1.57 0-.87-.7-1.58-1.56-1.58ZM34.25 23.26H8.44c-.87 0-1.56.7-1.56 1.57 0 .87.7 1.58 1.56 1.58h25.8c.87 0 1.57-.7 1.57-1.58 0-.87-.7-1.57-1.56-1.57Z"
      fill="#557479"
    />
  </g>
  <g id="club-empty-logo" box="32 32">
    <path
      d="M16 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM23 28a7 7 0 1 0-14 0h14ZM24 14a5 5 0 1 0-4-8M25 24h6a7 7 0 0 0-7-7M12 6a5 5 0 1 0-4 8M8 17a7 7 0 0 0-7 7h6"
      stroke="#A8A8A8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="project" box="66 66">
    <rect width="65" height="65" x=".5" y=".5" fill="#A8A8A8" stroke="#E9E9E9" rx="32.5" />
    <g clip-path="url(#clip44)">
      <path
        fill="#fff"
        d="M50.81 21.31H43.7v-5.34a1.19 1.19 0 0 0-1.19-1.19h-19a1.19 1.19 0 0 0-1.19 1.19v5.34H15.2A1.19 1.19 0 0 0 14 22.5v13.66a1.19 1.19 0 0 0 .6 1.02v10.85a1.19 1.19 0 0 0 1.18 1.19h34.44a1.19 1.19 0 0 0 1.19-1.19V37.18a1.19 1.19 0 0 0 .59-1.02V22.5a1.19 1.19 0 0 0-1.19-1.19ZM24.7 17.16H41.3v4.15H24.7v-4.15Zm24.34 29.68H16.97v-9.5h13.06v2.97a1.19 1.19 0 0 0 1.19 1.19h3.56a1.19 1.19 0 0 0 1.19-1.19v-2.97h13.06v9.5Zm-16.62-7.72v-5.34h1.18v5.34h-1.18Zm17.22-4.15H35.97v-2.38a1.19 1.19 0 0 0-1.19-1.18h-3.56a1.19 1.19 0 0 0-1.19 1.18v2.38H16.37V23.69h33.25v11.28Z"
      />
    </g>
    <defs>
      <clipPath id="clip44"><path fill="#fff" d="M14 13h38v38H14z" /></clipPath>
    </defs>
  </g>
</svg>
